var _defs, _g, _g2, _g3, _path, _g4, _g5, _g6, _path2, _path3, _g7, _g8, _g9, _g10, _path4, _path5, _g11, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodcontact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128.06pt",
    height: "176.25pt",
    viewBox: "0 0 128.06 176.25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6719 0v-0.89062h-1.6094v-0.40625l1.6875-2.3906h0.375v2.3906h0.5v0.40625h-0.5v0.89062zm0-1.2969v-1.6719l-1.1562 1.6719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5938-0.4375v0.4375h-2.4375c0-0.10156 0.015625-0.20703 0.046875-0.3125 0.0625-0.16406 0.16016-0.32812 0.29688-0.48438 0.14453-0.16406 0.34375-0.35156 0.59375-0.5625 0.40625-0.33203 0.67578-0.59375 0.8125-0.78125 0.14453-0.19531 0.21875-0.37891 0.21875-0.54688 0-0.17578-0.070312-0.32812-0.20312-0.45312-0.125-0.125-0.28906-0.1875-0.48438-0.1875-0.21875 0-0.39844 0.070313-0.53125 0.20312-0.13672 0.125-0.20312 0.30469-0.20312 0.53125l-0.46875-0.046875c0.039063-0.34375 0.16016-0.60156 0.35938-0.78125 0.20703-0.1875 0.48828-0.28125 0.84375-0.28125 0.35156 0 0.63281 0.10156 0.84375 0.29688 0.20703 0.19922 0.3125 0.4375 0.3125 0.71875 0 0.15625-0.03125 0.30859-0.09375 0.45312-0.0625 0.13672-0.16797 0.28125-0.3125 0.4375-0.13672 0.15625-0.36719 0.375-0.6875 0.65625-0.27344 0.23047-0.44922 0.38672-0.53125 0.46875-0.074219 0.074219-0.13672 0.15234-0.1875 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.28125-0.85938 0.4375-0.03125c0.03125 0.19922 0.097656 0.34375 0.20312 0.4375 0.10156 0.09375 0.23828 0.14062 0.40625 0.14062 0.13281 0 0.25391-0.03125 0.35938-0.09375 0.11328-0.0625 0.20312-0.14453 0.26562-0.25 0.0625-0.11328 0.11328-0.25781 0.15625-0.4375 0.050781-0.17578 0.078125-0.35938 0.078125-0.54688v-0.09375c-0.09375 0.14844-0.21875 0.26562-0.375 0.35938-0.15625 0.085938-0.32422 0.125-0.5 0.125-0.3125 0-0.57422-0.10938-0.78125-0.32812-0.21094-0.22656-0.3125-0.51953-0.3125-0.875 0-0.375 0.10938-0.67578 0.32812-0.90625 0.21875-0.22656 0.49219-0.34375 0.82812-0.34375 0.23828 0 0.45703 0.070313 0.65625 0.20312 0.19531 0.125 0.34766 0.30859 0.45312 0.54688 0.10156 0.24219 0.15625 0.58594 0.15625 1.0312 0 0.46875-0.054687 0.84375-0.15625 1.125-0.10547 0.28125-0.25781 0.49609-0.45312 0.64062-0.19922 0.14844-0.4375 0.21875-0.71875 0.21875s-0.51562-0.078125-0.70312-0.23438c-0.17969-0.16406-0.28906-0.39453-0.32812-0.6875zm1.8594-1.625c0-0.25781-0.074219-0.46094-0.21875-0.60938-0.13672-0.15625-0.29688-0.23438-0.48438-0.23438-0.21094 0-0.38672 0.085937-0.53125 0.25-0.14844 0.15625-0.21875 0.37109-0.21875 0.64062 0 0.23047 0.066406 0.41797 0.20312 0.5625 0.14453 0.14844 0.32031 0.21875 0.53125 0.21875 0.20703 0 0.37891-0.070312 0.51562-0.21875 0.13281-0.14453 0.20312-0.34766 0.20312-0.60938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.90625-2c-0.1875-0.070312-0.32812-0.17188-0.42188-0.29688-0.085937-0.125-0.125-0.27344-0.125-0.45312 0-0.26953 0.09375-0.49219 0.28125-0.67188 0.19531-0.1875 0.45703-0.28125 0.78125-0.28125 0.32031 0 0.57812 0.09375 0.76562 0.28125 0.19531 0.1875 0.29688 0.41797 0.29688 0.6875 0 0.16797-0.046875 0.3125-0.14062 0.4375-0.085938 0.125-0.21484 0.22656-0.39062 0.29688 0.21875 0.074219 0.38281 0.19531 0.5 0.35938 0.125 0.16797 0.1875 0.35938 0.1875 0.57812 0 0.32422-0.11719 0.59375-0.34375 0.8125-0.21875 0.21094-0.51172 0.3125-0.875 0.3125-0.36719 0-0.66406-0.10156-0.89062-0.3125-0.21875-0.21875-0.32812-0.48828-0.32812-0.8125 0-0.23828 0.0625-0.4375 0.1875-0.59375 0.125-0.16406 0.29688-0.28125 0.51562-0.34375zm-0.078125-0.76562c0 0.17969 0.050781 0.32422 0.15625 0.4375 0.11328 0.10547 0.25781 0.15625 0.4375 0.15625 0.17578 0 0.32031-0.050781 0.4375-0.15625 0.11328-0.11328 0.17188-0.25391 0.17188-0.42188 0-0.16406-0.0625-0.30078-0.1875-0.40625-0.11719-0.11328-0.25781-0.17188-0.42188-0.17188-0.17969 0-0.32422 0.058594-0.4375 0.17188-0.10547 0.10547-0.15625 0.23438-0.15625 0.39062zm-0.15625 1.7031c0 0.125 0.03125 0.25 0.09375 0.375 0.0625 0.11719 0.14844 0.21094 0.26562 0.28125 0.125 0.0625 0.25781 0.09375 0.40625 0.09375 0.20703 0 0.37891-0.066406 0.51562-0.20312 0.14453-0.14453 0.21875-0.32031 0.21875-0.53125 0-0.21875-0.074219-0.39844-0.21875-0.54688-0.13672-0.14453-0.3125-0.21875-0.53125-0.21875s-0.40234 0.074219-0.54688 0.21875c-0.13672 0.14844-0.20312 0.32422-0.20312 0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.25-3.2031v-0.4375h2.3906v0.34375c-0.24219 0.25-0.47656 0.58594-0.70312 1-0.23047 0.41797-0.40625 0.84375-0.53125 1.2812-0.09375 0.3125-0.15625 0.65234-0.1875 1.0156h-0.45312c0-0.28906 0.050781-0.64062 0.15625-1.0469 0.11328-0.41406 0.26953-0.8125 0.46875-1.1875 0.20703-0.38281 0.42578-0.70703 0.65625-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625-2.7812-0.45312 0.03125c-0.042969-0.17578-0.10156-0.30469-0.17188-0.39062-0.11719-0.125-0.26562-0.1875-0.45312-0.1875-0.13672 0-0.26172 0.039063-0.375 0.10938-0.14844 0.10547-0.26172 0.26172-0.34375 0.46875-0.074219 0.19922-0.11719 0.48047-0.125 0.84375 0.11328-0.16406 0.25-0.28516 0.40625-0.35938 0.15625-0.082031 0.32031-0.125 0.5-0.125 0.30078 0 0.55469 0.10938 0.76562 0.32812 0.20703 0.21875 0.3125 0.50781 0.3125 0.85938 0 0.24219-0.054688 0.46094-0.15625 0.65625-0.09375 0.19922-0.23047 0.35156-0.40625 0.45312-0.16797 0.10156-0.36719 0.15625-0.59375 0.15625-0.375 0-0.68359-0.13281-0.92188-0.40625-0.24219-0.28125-0.35938-0.74219-0.35938-1.3906 0-0.70703 0.13281-1.2227 0.40625-1.5469 0.22656-0.28125 0.53516-0.42188 0.92188-0.42188 0.28906 0 0.53125 0.085937 0.71875 0.25 0.1875 0.15625 0.29688 0.38281 0.32812 0.67188zm-1.8438 1.5781c0 0.15625 0.03125 0.30859 0.09375 0.45312 0.0625 0.14844 0.14844 0.25781 0.26562 0.32812 0.125 0.074219 0.25391 0.10938 0.39062 0.10938 0.1875 0 0.34766-0.070312 0.48438-0.21875 0.14453-0.15625 0.21875-0.36719 0.21875-0.64062 0-0.25-0.070313-0.44531-0.20312-0.59375-0.13672-0.15625-0.30859-0.23438-0.51562-0.23438-0.21094 0-0.38672 0.078125-0.53125 0.23438-0.13672 0.14844-0.20312 0.33594-0.20312 0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875-1.8125c0-0.4375 0.039062-0.78516 0.125-1.0469 0.09375-0.26953 0.22656-0.47656 0.40625-0.625 0.17578-0.14453 0.39844-0.21875 0.67188-0.21875 0.19531 0 0.36719 0.042969 0.51562 0.125 0.14453 0.074219 0.26562 0.1875 0.35938 0.34375 0.10156 0.14844 0.17969 0.32812 0.23438 0.54688 0.0625 0.21094 0.09375 0.5 0.09375 0.875 0 0.42969-0.046875 0.77734-0.14062 1.0469-0.085937 0.26172-0.21484 0.46484-0.39062 0.60938-0.17969 0.14844-0.40234 0.21875-0.67188 0.21875-0.35547 0-0.63672-0.125-0.84375-0.375-0.24219-0.3125-0.35938-0.8125-0.35938-1.5zm0.46875 0c0 0.60547 0.066406 1.0078 0.20312 1.2031 0.14453 0.19922 0.32031 0.29688 0.53125 0.29688 0.20703 0 0.37891-0.097656 0.51562-0.29688 0.14453-0.19531 0.21875-0.59766 0.21875-1.2031 0-0.61328-0.074219-1.0195-0.21875-1.2188-0.13672-0.19531-0.3125-0.29688-0.53125-0.29688-0.21094 0-0.375 0.089844-0.5 0.26562-0.14844 0.21875-0.21875 0.63672-0.21875 1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875-0.96875 0.46875-0.03125c0.039062 0.23047 0.125 0.40234 0.25 0.51562 0.125 0.11719 0.28125 0.17188 0.46875 0.17188 0.21875 0 0.39844-0.078125 0.54688-0.23438 0.15625-0.16406 0.23438-0.39062 0.23438-0.67188 0-0.25-0.074219-0.44531-0.21875-0.59375-0.14844-0.15625-0.33984-0.23438-0.57812-0.23438-0.14844 0-0.27734 0.039063-0.39062 0.10938-0.11719 0.0625-0.21094 0.14844-0.28125 0.25l-0.42188-0.0625 0.35938-1.8906h1.8281v0.4375h-1.4688l-0.20312 0.98438c0.21875-0.15625 0.45312-0.23438 0.70312-0.23438 0.32031 0 0.59375 0.11719 0.8125 0.34375 0.21875 0.21875 0.32812 0.50781 0.32812 0.85938 0 0.33594-0.09375 0.62109-0.28125 0.85938-0.24219 0.30469-0.5625 0.45312-0.96875 0.45312-0.34375 0-0.62109-0.09375-0.82812-0.28125-0.21094-0.1875-0.32812-0.4375-0.35938-0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.57812 0v-5.7344h4.25v0.96875h-3.0938v1.2812h2.875v0.95312h-2.875v1.5625h3.2031v0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.57812-5.7344h1.1562v3.1094c0 0.49219 0.015625 0.80859 0.046875 0.95312 0.039062 0.24219 0.15625 0.43359 0.34375 0.57812 0.1875 0.13672 0.44141 0.20312 0.76562 0.20312 0.33203 0 0.58203-0.066406 0.75-0.20312 0.16406-0.13281 0.26562-0.29688 0.29688-0.48438 0.03125-0.19531 0.046875-0.52344 0.046875-0.98438v-3.1719h1.1562v3.0156c0 0.6875-0.03125 1.1719-0.09375 1.4531s-0.17969 0.52344-0.34375 0.71875c-0.16797 0.19922-0.39062 0.35547-0.67188 0.46875-0.28125 0.11328-0.65234 0.17188-1.1094 0.17188-0.54297 0-0.95312-0.0625-1.2344-0.1875s-0.50781-0.28516-0.67188-0.48438c-0.16797-0.20703-0.27734-0.42188-0.32812-0.64062-0.074219-0.33203-0.10938-0.81641-0.10938-1.4531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.59375 0v-5.7344h2.4219c0.61328 0 1.0547 0.054687 1.3281 0.15625 0.28125 0.10547 0.50391 0.29297 0.67188 0.5625 0.16406 0.26172 0.25 0.55859 0.25 0.89062 0 0.42969-0.125 0.78125-0.375 1.0625s-0.625 0.46094-1.125 0.53125c0.25 0.14844 0.45312 0.30859 0.60938 0.48438 0.16406 0.17969 0.38281 0.48438 0.65625 0.92188l0.70312 1.125h-1.375l-0.84375-1.25c-0.29297-0.44531-0.49609-0.72656-0.60938-0.84375-0.10547-0.11328-0.21875-0.19141-0.34375-0.23438-0.125-0.039063-0.32031-0.0625-0.57812-0.0625h-0.23438v2.3906zm1.1562-3.3125h0.84375c0.5625 0 0.91016-0.019531 1.0469-0.0625 0.13281-0.050781 0.23828-0.13281 0.3125-0.25 0.082031-0.11328 0.125-0.25391 0.125-0.42188 0-0.19531-0.054687-0.35156-0.15625-0.46875-0.10547-0.11328-0.25-0.1875-0.4375-0.21875-0.09375-0.019531-0.375-0.03125-0.84375-0.03125h-0.89062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.0469-1.1875v1.1875h-6.625c-0.011719-0.28906 0.035156-0.57812 0.14062-0.85938 0.17578-0.44531 0.44531-0.89062 0.8125-1.3281 0.375-0.4375 0.91016-0.94141 1.6094-1.5156 1.0938-0.89453 1.8281-1.6016 2.2031-2.125 0.38281-0.51953 0.57812-1.0156 0.57812-1.4844 0-0.48828-0.17969-0.89844-0.53125-1.2344-0.34375-0.33203-0.79297-0.5-1.3438-0.5-0.59375 0-1.0742 0.17969-1.4375 0.53125-0.35547 0.35547-0.53125 0.85156-0.53125 1.4844l-1.2656-0.14062c0.082031-0.9375 0.40625-1.6484 0.96875-2.1406 0.57031-0.5 1.332-0.75 2.2812-0.75 0.96875 0 1.7266 0.26562 2.2812 0.79688 0.5625 0.53125 0.84375 1.1953 0.84375 1.9844 0 0.40625-0.085938 0.80469-0.25 1.1875-0.15625 0.38672-0.42969 0.79297-0.8125 1.2188-0.375 0.42969-1.0078 1.0156-1.8906 1.7656-0.74219 0.61719-1.2148 1.0391-1.4219 1.2656-0.21094 0.21875-0.38281 0.4375-0.51562 0.65625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.4375-1.3281 0.67188-0.0625c0.0625 0.32422 0.17188 0.55859 0.32812 0.70312 0.16406 0.13672 0.375 0.20312 0.625 0.20312 0.21875 0 0.40625-0.046875 0.5625-0.14062 0.16406-0.10156 0.30078-0.23828 0.40625-0.40625 0.10156-0.16406 0.19141-0.39062 0.26562-0.67188 0.070313-0.28125 0.10938-0.56641 0.10938-0.85938 0-0.03125-0.00781-0.078125-0.015625-0.14062-0.13672 0.23047-0.32812 0.41797-0.57812 0.5625-0.24219 0.13672-0.5 0.20312-0.78125 0.20312-0.48047 0-0.88672-0.17188-1.2188-0.51562-0.32422-0.34375-0.48438-0.79688-0.48438-1.3594 0-0.58203 0.17188-1.0508 0.51562-1.4062 0.34375-0.35156 0.77344-0.53125 1.2969-0.53125 0.36328 0 0.70312 0.10156 1.0156 0.29688 0.3125 0.19922 0.54688 0.48438 0.70312 0.85938s0.23438 0.91406 0.23438 1.6094c0 0.73047-0.078125 1.3125-0.23438 1.75s-0.39062 0.77344-0.70312 1c-0.3125 0.21875-0.68359 0.32812-1.1094 0.32812-0.44922 0-0.8125-0.125-1.0938-0.375s-0.45312-0.59766-0.51562-1.0469zm2.875-2.5312c0-0.39453-0.10938-0.71094-0.32812-0.95312-0.21094-0.23828-0.46484-0.35938-0.76562-0.35938-0.3125 0-0.58594 0.13281-0.8125 0.39062-0.23047 0.25-0.34375 0.57812-0.34375 0.98438 0 0.36719 0.10938 0.66406 0.32812 0.89062 0.21875 0.23047 0.48828 0.34375 0.8125 0.34375 0.32031 0 0.58594-0.11328 0.79688-0.34375 0.20703-0.22656 0.3125-0.54688 0.3125-0.95312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.23438-3.0625h0.75c0.125 0 0.23438 0.011719 0.32812 0.03125 0.09375 0.011719 0.17969 0.058594 0.26562 0.14062 0.09375 0.074219 0.17188 0.17188 0.23438 0.29688s0.10938 0.27344 0.14062 0.4375c0.039063 0.16797 0.0625 0.37109 0.0625 0.60938 0 0.44922-0.078125 0.82031-0.23438 1.1094-0.14844 0.29297-0.40234 0.4375-0.76562 0.4375h-0.78125zm0.29688 2.7031h0.45312c0.09375 0 0.17578-0.003906 0.25-0.015625 0.070313-0.019531 0.14453-0.066406 0.21875-0.14062 0.082031-0.082031 0.14453-0.20703 0.1875-0.375 0.050781-0.16406 0.078125-0.39062 0.078125-0.67188 0-0.14453-0.011719-0.28516-0.03125-0.42188-0.011719-0.13281-0.042969-0.25391-0.09375-0.35938-0.054688-0.11328-0.11719-0.19531-0.1875-0.25-0.0625-0.050781-0.125-0.082031-0.1875-0.09375-0.0625-0.00781-0.14844-0.015625-0.25-0.015625h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438 0h-1.6094v-3.0625h1.5625v0.35938h-1.2812v0.9375h1.1875v0.35938h-1.1875v1.0469h1.3281zm-0.46875-3.8438-0.32812 0.57812h-0.21875l0.20312-0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0469-0.96875c-0.0625 0.34375-0.17188 0.60156-0.32812 0.76562-0.15625 0.16797-0.34375 0.25-0.5625 0.25-0.34375 0-0.60156-0.15625-0.76562-0.46875-0.15625-0.3125-0.23438-0.6875-0.23438-1.125 0-0.48828 0.09375-0.86719 0.28125-1.1406 0.1875-0.28125 0.42969-0.42188 0.73438-0.42188 0.20703 0 0.38281 0.078125 0.53125 0.23438 0.14453 0.14844 0.25 0.36719 0.3125 0.65625l-0.28125 0.09375c-0.042969-0.21875-0.11719-0.37891-0.21875-0.48438-0.09375-0.10156-0.21484-0.15625-0.35938-0.15625-0.23047 0-0.40625 0.10938-0.53125 0.32812-0.11719 0.21875-0.17188 0.51172-0.17188 0.875 0 0.42969 0.0625 0.74609 0.1875 0.95312 0.125 0.21094 0.28906 0.3125 0.5 0.3125 0.16406 0 0.30078-0.0625 0.40625-0.1875 0.10156-0.13281 0.17578-0.33203 0.21875-0.59375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1719-3.1094c0.30078 0 0.54688 0.14844 0.73438 0.4375 0.19531 0.28125 0.29688 0.66406 0.29688 1.1406 0 0.48047-0.10156 0.86719-0.29688 1.1562-0.1875 0.28125-0.43359 0.42188-0.73438 0.42188-0.3125 0-0.5625-0.14453-0.75-0.4375-0.1875-0.30078-0.28125-0.67188-0.28125-1.1094 0-0.5 0.09375-0.89062 0.28125-1.1719 0.19531-0.28906 0.44531-0.4375 0.75-0.4375zm0 2.8125c0.21875 0 0.39453-0.10938 0.53125-0.32812 0.13281-0.21875 0.20312-0.51953 0.20312-0.90625 0-0.39453-0.074219-0.69531-0.21875-0.90625-0.13672-0.21875-0.30859-0.32812-0.51562-0.32812-0.21875 0-0.39844 0.10547-0.53125 0.3125-0.13672 0.21094-0.20312 0.53125-0.20312 0.96875 0 0.35547 0.066406 0.64062 0.20312 0.85938 0.13281 0.21875 0.3125 0.32812 0.53125 0.32812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1406 0h-0.35938c-0.21875-0.47656-0.35547-0.76953-0.40625-0.875-0.054688-0.11328-0.10938-0.21094-0.17188-0.29688-0.054687-0.082031-0.10547-0.13281-0.15625-0.15625-0.042969-0.019531-0.10547-0.03125-0.1875-0.03125h-0.32812v1.3594h-0.29688v-3.0625h0.95312c0.13281 0 0.24219 0.011719 0.32812 0.03125 0.09375 0.023438 0.17188 0.074219 0.23438 0.15625 0.0625 0.074219 0.10938 0.16797 0.14062 0.28125 0.039063 0.11719 0.0625 0.24219 0.0625 0.375 0 0.23047-0.054687 0.41797-0.15625 0.5625-0.10547 0.13672-0.25 0.21875-0.4375 0.25v0.015625c0.13281 0.09375 0.26953 0.28125 0.40625 0.5625zm-1.6094-1.7188h0.60938c0.11328 0 0.20703-0.015625 0.28125-0.046875 0.070313-0.03125 0.12891-0.085937 0.17188-0.17188 0.039062-0.082031 0.0625-0.17578 0.0625-0.28125 0-0.14453-0.039062-0.26562-0.10938-0.35938-0.0625-0.10156-0.17969-0.15625-0.34375-0.15625h-0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 0h-0.3125l-0.25-0.9375h-0.90625l-0.23438 0.9375h-0.29688l0.82812-3.0625h0.29688zm-0.65625-1.25c-0.17969-0.66406-0.27734-1.0391-0.29688-1.125-0.023437-0.09375-0.046875-0.21875-0.078125-0.375-0.03125 0.21094-0.070312 0.40234-0.10938 0.57812l-0.25 0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7656-2.7031h-0.70312v2.7031h-0.29688v-2.7031h-0.70312v-0.35938h1.7031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0h-0.28125v-3.0625h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219 0h-0.28125l-1.125-2.4062h-0.015625v2.4062h-0.26562v-3.0625h0.29688l1.125 2.4062v-2.4062h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812-3.0625-0.60938 3.1719h-0.21875l0.625-3.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5-2.1719c-0.011719-0.1875-0.058594-0.32812-0.14062-0.42188-0.085937-0.10156-0.21094-0.15625-0.375-0.15625-0.14844 0-0.26562 0.042969-0.35938 0.125-0.09375 0.074219-0.14062 0.18359-0.14062 0.32812 0 0.13672 0.035156 0.23438 0.10938 0.29688 0.070312 0.0625 0.20703 0.125 0.40625 0.1875 0.17578 0.0625 0.32031 0.125 0.4375 0.1875 0.11328 0.054688 0.20703 0.14062 0.28125 0.26562 0.082031 0.125 0.125 0.29297 0.125 0.5 0 0.26172-0.074219 0.48047-0.21875 0.65625-0.14844 0.16797-0.33984 0.25-0.57812 0.25-0.30469 0-0.53125-0.09375-0.6875-0.28125-0.14844-0.19531-0.21875-0.44531-0.21875-0.75l0.26562-0.03125c0.007812 0.24219 0.070312 0.41797 0.1875 0.53125 0.125 0.11719 0.26953 0.17188 0.4375 0.17188 0.16406 0 0.29688-0.046875 0.39062-0.14062 0.10156-0.09375 0.15625-0.21875 0.15625-0.375 0-0.16406-0.054687-0.28516-0.15625-0.35938-0.10547-0.082031-0.27734-0.16016-0.51562-0.23438-0.24219-0.070313-0.41797-0.17578-0.53125-0.3125-0.10547-0.13281-0.15625-0.3125-0.15625-0.53125 0-0.25 0.066406-0.45312 0.20312-0.60938 0.13281-0.15625 0.31641-0.23438 0.54688-0.23438 0.23828 0 0.42969 0.078125 0.57812 0.23438 0.14453 0.15625 0.22266 0.38281 0.23438 0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438 0h-1.6094v-3.0625h1.5625v0.35938h-1.2812v0.9375h1.1875v0.35938h-1.1875v1.0469h1.3281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 0h-0.375l-0.76562-1.5469-0.35938 0.48438v1.0625h-0.28125v-3.0625h0.28125v1.5156l1.0781-1.5156h0.375l-0.89062 1.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219-1.2969c0 0.15625-0.00781 0.30469-0.015625 0.4375-0.011719 0.13672-0.042969 0.27734-0.09375 0.42188-0.054688 0.13672-0.14062 0.25-0.26562 0.34375-0.11719 0.09375-0.27344 0.14062-0.46875 0.14062-0.1875 0-0.33984-0.042969-0.45312-0.125-0.11719-0.082031-0.20312-0.1875-0.26562-0.3125-0.054687-0.13281-0.089844-0.27344-0.10938-0.42188-0.011719-0.14453-0.015625-0.30469-0.015625-0.48438v-1.7656h0.28125v1.7656c0 0.1875 0.007813 0.35156 0.03125 0.48438 0.019531 0.125 0.066406 0.24219 0.14062 0.34375 0.082031 0.10547 0.20703 0.15625 0.375 0.15625 0.16406 0 0.28906-0.039062 0.375-0.125 0.082031-0.082031 0.13281-0.19141 0.15625-0.32812 0.03125-0.13281 0.046875-0.3125 0.046875-0.53125v-1.7656h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844-3.0625-0.84375 3.0625h-0.29688l-0.82812-3.0625h0.3125l0.54688 2.2188c0.039062 0.14844 0.082031 0.3125 0.125 0.5 0.03125-0.15625 0.066406-0.32031 0.10938-0.5l0.57812-2.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.75 0h-1.7031v-0.375l1.1094-1.9688s0.023438-0.039062 0.078125-0.125c0.050781-0.09375 0.097656-0.17188 0.14062-0.23438h-1.2031v-0.35938h1.5469v0.35938l-1.2031 2.125-0.14062 0.21875h1.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6562 0h-1.5156v-0.42188l0.70312-1.1719-0.70312-1.0625v-0.40625h1.4688v0.35938h-1.1562l0.73438 1.1094-0.73438 1.2344h1.2031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844 0h-0.3125l-0.5625-2.2188c-0.054687-0.19531-0.089844-0.36719-0.10938-0.51562-0.03125 0.16797-0.070312 0.33984-0.10938 0.51562l-0.59375 2.2188h-0.28125l0.84375-3.0625h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.23438-3.0625h0.8125c0.125 0 0.23438 0.011719 0.32812 0.03125 0.09375 0.011719 0.17578 0.058594 0.25 0.14062 0.082031 0.074219 0.14453 0.17969 0.1875 0.3125 0.039062 0.125 0.0625 0.26172 0.0625 0.40625 0 0.28125-0.070312 0.51172-0.20312 0.6875-0.125 0.16797-0.32812 0.25-0.60938 0.25h-0.54688v1.2344h-0.28125zm0.28125 1.4531h0.54688c0.34375 0 0.51562-0.1875 0.51562-0.5625 0-0.11328-0.027344-0.21875-0.078125-0.3125-0.042969-0.09375-0.09375-0.14844-0.15625-0.17188-0.0625-0.03125-0.15625-0.046875-0.28125-0.046875h-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3438-2.6094-0.17188 0.34375c-0.24219-0.28906-0.52344-0.49219-0.84375-0.60938l0.15625-0.35938c0.34375 0.1875 0.62891 0.39844 0.85938 0.625zm1.3438 0.4375c-0.34375 0.73047-0.6875 1.2578-1.0312 1.5781-0.33594 0.32422-0.71484 0.57031-1.1406 0.73438l-0.17188-0.39062c0.53125-0.15625 0.95703-0.41406 1.2812-0.78125 0.32031-0.36328 0.60156-0.83203 0.84375-1.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844-3.0625-0.85938 1.7656v1.2969h-0.28125v-1.2969l-0.82812-1.7656h0.34375l0.46875 1.0312c0.050781 0.10547 0.10938 0.24219 0.17188 0.40625 0.039062-0.11328 0.25781-0.59375 0.65625-1.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.73438 0c-0.16797 0-0.29297-0.054688-0.375-0.17188-0.074219 0.11719-0.19531 0.17188-0.35938 0.17188v-0.40625h0.015625c0.14453 0 0.21875-0.14062 0.21875-0.42188v-0.39062h0.26562v0.39062c0 0.28125 0.070312 0.42188 0.21875 0.42188h0.015625zm-0.23438-1.7812h-0.26562v-0.375h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.57812-0.82812c0 0.30469-0.042969 0.51562-0.125 0.64062-0.074219 0.125-0.19531 0.1875-0.35938 0.1875h-0.09375v-0.40625h0.10938c0.14453 0 0.21875-0.14062 0.21875-0.42188v-0.39062h0.25zm0.078125-0.95312h-0.21875v-0.29688h0.21875zm-0.39062 0h-0.21875v-0.29688h0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812 0h-0.09375c-0.17969 0-0.30859-0.0625-0.39062-0.1875-0.074219-0.13281-0.10938-0.34766-0.10938-0.64062v-2.2344h0.26562v2.2344c0 0.28125 0.070312 0.42188 0.21875 0.42188h0.10938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844 0h-0.35938l-0.42188-0.875c-0.10547-0.20703-0.17188-0.34766-0.20312-0.42188 0 0.023437-0.21484 0.45312-0.64062 1.2969h-0.34375l0.82812-1.5938-0.73438-1.4688h0.34375l0.45312 0.90625c0.039062 0.10547 0.078125 0.1875 0.10938 0.25 0.03125-0.09375 0.22656-0.47656 0.59375-1.1562h0.3125l-0.75 1.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1406-0.42188c-0.27344 0.3125-0.57031 0.46875-0.89062 0.46875-0.32422 0-0.58984-0.14062-0.79688-0.42188-0.19922-0.28906-0.29688-0.67188-0.29688-1.1406 0-0.28906 0.039062-0.5625 0.125-0.8125 0.082031-0.25 0.20312-0.44141 0.35938-0.57812 0.16406-0.13281 0.36328-0.20312 0.59375-0.20312 0.23828 0 0.42969 0.078125 0.57812 0.23438 0.14453 0.14844 0.24219 0.37109 0.29688 0.67188l-0.25 0.09375c-0.042969-0.21875-0.11719-0.37891-0.21875-0.48438-0.10547-0.11328-0.24219-0.17188-0.40625-0.17188-0.26172 0-0.46094 0.11719-0.59375 0.34375-0.125 0.21875-0.1875 0.51172-0.1875 0.875 0 0.27344 0.03125 0.5 0.09375 0.6875 0.0625 0.17969 0.15625 0.3125 0.28125 0.40625s0.25781 0.14062 0.40625 0.14062c0.22656 0 0.4375-0.10156 0.625-0.3125v-0.57812h-0.625v-0.35938h0.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219 0h-0.28125v-1.4375h-1.1094v1.4375h-0.29688v-3.0625h0.29688v1.25h1.1094v-1.25h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2656 0h-0.26562v-2.5625l-0.625 2.5625h-0.25l-0.625-2.6094v2.6094h-0.26562v-3.0625h0.42188l0.5 2.1719c0.0625 0.24219 0.097656 0.39062 0.10938 0.45312 0.03125-0.125 0.066406-0.28906 0.10938-0.5l0.51562-2.125h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219 0h-0.28125l-1.125-2.4062h-0.015625v2.4062h-0.26562v-3.0625h0.29688l1.125 2.4062v-2.4062h0.26562zm-0.32812-3.7812c0 0.15625-0.027344 0.27734-0.078125 0.35938-0.054687 0.074219-0.12109 0.10938-0.20312 0.10938-0.042969 0-0.078125-0.003906-0.10938-0.015625-0.03125-0.019531-0.070313-0.046875-0.10938-0.078125-0.074219-0.0625-0.13281-0.09375-0.17188-0.09375-0.085937 0-0.125 0.0625-0.125 0.1875h-0.17188c0-0.15625 0.023438-0.26953 0.078125-0.34375 0.0625-0.082031 0.13281-0.125 0.21875-0.125 0.0625 0 0.12891 0.03125 0.20312 0.09375 0.070312 0.0625 0.12891 0.09375 0.17188 0.09375 0.070313 0 0.11328-0.0625 0.125-0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0c0 0.17578-0.027344 0.3125-0.078125 0.40625-0.042969 0.09375-0.09375 0.16016-0.15625 0.20312l-0.078125-0.17188c0.11328-0.0625 0.17188-0.21094 0.17188-0.4375h-0.15625v-0.42188h0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0h-0.29688v-0.42188h0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1719-3.1094c0.30078 0 0.54688 0.14844 0.73438 0.4375 0.19531 0.28125 0.29688 0.66406 0.29688 1.1406 0 0.48047-0.10156 0.86719-0.29688 1.1562-0.1875 0.28125-0.43359 0.42188-0.73438 0.42188-0.3125 0-0.5625-0.14453-0.75-0.4375-0.1875-0.30078-0.28125-0.67188-0.28125-1.1094 0-0.5 0.09375-0.89062 0.28125-1.1719 0.19531-0.28906 0.44531-0.4375 0.75-0.4375zm0 2.8125c0.21875 0 0.39453-0.10938 0.53125-0.32812 0.13281-0.21875 0.20312-0.51953 0.20312-0.90625 0-0.39453-0.074219-0.69531-0.21875-0.90625-0.13672-0.21875-0.30859-0.32812-0.51562-0.32812-0.21875 0-0.39844 0.10547-0.53125 0.3125-0.13672 0.21094-0.20312 0.53125-0.20312 0.96875 0 0.35547 0.066406 0.64062 0.20312 0.85938 0.13281 0.21875 0.3125 0.32812 0.53125 0.32812zm0.375-3.5469-0.32812 0.57812h-0.21875l0.20312-0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6875-2.7031h-1.1562v0.95312h1v0.35938h-1v1.3906h-0.29688v-3.0625h1.4531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.90625-0.92188h-0.8125v-0.375h0.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.125 0h-0.26562v-2.3906c-0.13672 0.17969-0.3125 0.32812-0.53125 0.45312v-0.375c0.30078-0.20703 0.50781-0.46094 0.625-0.76562h0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.46875-1.8438c0.13281-0.125 0.26953-0.1875 0.40625-0.1875 0.1875 0 0.34375 0.089844 0.46875 0.26562 0.13281 0.17969 0.20312 0.41797 0.20312 0.71875 0 0.3125-0.070313 0.57422-0.20312 0.78125-0.13672 0.21094-0.3125 0.3125-0.53125 0.3125-0.17969 0-0.33594-0.066406-0.46875-0.20312-0.125-0.14453-0.19922-0.36328-0.21875-0.65625l0.28125-0.015625c0.019531 0.1875 0.066406 0.33594 0.14062 0.4375 0.070313 0.09375 0.16016 0.14062 0.26562 0.14062 0.13281 0 0.24219-0.070312 0.32812-0.21875 0.082031-0.14453 0.125-0.32031 0.125-0.53125 0-0.21875-0.042969-0.39062-0.125-0.51562-0.085937-0.125-0.19531-0.1875-0.32812-0.1875-0.16797 0-0.29688 0.10156-0.39062 0.29688l-0.25-0.046875 0.20312-1.5625h1.0781v0.35938h-0.85938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1406-1.6562c0.13281 0.03125 0.23438 0.125 0.29688 0.28125 0.070312 0.14844 0.10938 0.30469 0.10938 0.46875 0 0.28125-0.074219 0.51172-0.21875 0.6875-0.14844 0.17969-0.32031 0.26562-0.51562 0.26562-0.1875 0-0.34375-0.078125-0.46875-0.23438s-0.19922-0.36328-0.21875-0.625l0.26562-0.046875c0.03125 0.19922 0.078125 0.35156 0.14062 0.45312 0.070312 0.10547 0.16406 0.15625 0.28125 0.15625 0.125 0 0.22656-0.0625 0.3125-0.1875 0.082031-0.125 0.125-0.27344 0.125-0.45312 0-0.17578-0.039062-0.31641-0.10938-0.42188-0.074219-0.11328-0.17188-0.17188-0.29688-0.17188-0.054688 0-0.11719 0.011719-0.1875 0.03125l0.03125-0.32812c0.0625 0 0.11328-0.00391 0.15625-0.015625 0.039062-0.00781 0.085938-0.03125 0.14062-0.0625 0.050781-0.039063 0.09375-0.097656 0.125-0.17188 0.03125-0.070312 0.046875-0.16016 0.046875-0.26562 0-0.14453-0.039062-0.25781-0.10938-0.34375-0.0625-0.082031-0.14062-0.125-0.23438-0.125-0.10547 0-0.19531 0.046875-0.26562 0.14062-0.0625 0.09375-0.10547 0.23047-0.125 0.40625l-0.26562-0.0625c0.039062-0.26953 0.11719-0.46875 0.23438-0.59375 0.11328-0.13281 0.25-0.20312 0.40625-0.20312 0.1875 0 0.33594 0.078125 0.45312 0.23438 0.125 0.14844 0.1875 0.33594 0.1875 0.5625 0 0.28125-0.10156 0.48438-0.29688 0.60938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5312-0.73438h-0.29688v0.73438h-0.26562v-0.73438h-0.92188v-0.34375l0.96875-1.9844h0.21875v1.9844h0.29688zm-0.5625-0.34375v-1.3906l-0.67188 1.3906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812-3.0781c0.46875 0 0.70312 0.52344 0.70312 1.5625 0 0.53125-0.0625 0.92969-0.1875 1.1875-0.11719 0.25-0.28906 0.375-0.51562 0.375-0.46094 0-0.6875-0.51953-0.6875-1.5625 0-0.51953 0.054687-0.91016 0.17188-1.1719 0.125-0.25781 0.29688-0.39062 0.51562-0.39062zm0 2.8281c0.14453 0 0.25391-0.097656 0.32812-0.29688 0.070312-0.19531 0.10938-0.51953 0.10938-0.96875 0-0.30078-0.015625-0.53906-0.046875-0.71875-0.03125-0.1875-0.085938-0.32031-0.15625-0.40625-0.0625-0.082031-0.14062-0.125-0.23438-0.125-0.13672 0-0.24219 0.10156-0.3125 0.29688-0.074219 0.19922-0.10938 0.51562-0.10938 0.95312 0 0.3125 0.015625 0.55859 0.046875 0.73438 0.03125 0.17969 0.078125 0.3125 0.14062 0.40625 0.0625 0.085938 0.14062 0.125 0.23438 0.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.39062-1.5781c0.125-0.26953 0.29688-0.40625 0.51562-0.40625 0.17578 0 0.32812 0.09375 0.45312 0.28125 0.125 0.17969 0.1875 0.41406 0.1875 0.70312 0 0.29297-0.0625 0.54297-0.1875 0.75-0.125 0.19922-0.28906 0.29688-0.48438 0.29688-0.21094 0-0.38672-0.10156-0.53125-0.3125-0.14844-0.21875-0.21875-0.60938-0.21875-1.1719 0-0.53906 0.0625-0.94531 0.1875-1.2188 0.13281-0.28125 0.32812-0.42188 0.57812-0.42188 0.16406 0 0.30078 0.070313 0.40625 0.20312 0.11328 0.125 0.17969 0.3125 0.20312 0.5625l-0.25 0.03125c-0.054688-0.32031-0.17969-0.48438-0.375-0.48438-0.13672 0-0.25 0.09375-0.34375 0.28125s-0.14062 0.49219-0.14062 0.90625zm0.46875 1.3281c0.125 0 0.22266-0.066406 0.29688-0.20312 0.070312-0.14453 0.10938-0.31641 0.10938-0.51562 0-0.19531-0.039063-0.35938-0.10938-0.48438-0.074219-0.13281-0.17188-0.20312-0.29688-0.20312-0.11719 0-0.21875 0.0625-0.3125 0.1875-0.085937 0.11719-0.125 0.27344-0.125 0.46875 0 0.21094 0.039063 0.38672 0.125 0.53125 0.082031 0.14844 0.1875 0.21875 0.3125 0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5625 0h-1.3438v-3.0625h0.29688v2.7031h1.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4375-1.625c0.13281 0.054688 0.23438 0.14844 0.29688 0.28125 0.070313 0.13672 0.10938 0.28906 0.10938 0.45312 0 0.16797-0.03125 0.32422-0.09375 0.46875-0.054688 0.14844-0.13672 0.25781-0.25 0.32812-0.11719 0.0625-0.26562 0.09375-0.45312 0.09375h-0.82812v-3.0625h0.8125c0.25781 0 0.44141 0.085938 0.54688 0.25 0.10156 0.15625 0.15625 0.33594 0.15625 0.53125 0 0.13672-0.027344 0.26172-0.078125 0.375-0.042969 0.11719-0.11719 0.21094-0.21875 0.28125zm-0.9375-0.15625h0.46875c0.09375 0 0.17188-0.00391 0.23438-0.015625 0.070313-0.019531 0.12891-0.0625 0.17188-0.125 0.050781-0.070313 0.078125-0.17578 0.078125-0.3125 0-0.14453-0.027344-0.25-0.078125-0.3125-0.042969-0.070313-0.10156-0.11328-0.17188-0.125-0.074219-0.019531-0.16406-0.03125-0.26562-0.03125h-0.4375zm0 1.4219h0.54688c0.1875 0 0.31641-0.046875 0.39062-0.14062 0.070312-0.09375 0.10938-0.22266 0.10938-0.39062 0-0.16406-0.042969-0.29688-0.125-0.39062-0.074219-0.09375-0.21484-0.14062-0.42188-0.14062h-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2656-0.98438c0 0.375-0.058594 0.64062-0.17188 0.79688-0.10547 0.15625-0.25 0.23438-0.4375 0.23438s-0.33594-0.070312-0.4375-0.21875c-0.09375-0.15625-0.14062-0.39062-0.14062-0.70312l0.25-0.046875c0.007813 0.19922 0.039063 0.35156 0.09375 0.45312 0.050781 0.10547 0.12891 0.15625 0.23438 0.15625 0.09375 0 0.16016-0.03125 0.20312-0.09375 0.050781-0.070312 0.082031-0.14844 0.09375-0.23438 0.007813-0.082031 0.015625-0.1875 0.015625-0.3125v-2.1094h0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625-1.7969h-0.29688v-0.42188h0.29688zm0 1.7969h-0.29688v-0.42188h0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1406-1.6562c0.26953 0.125 0.40625 0.38672 0.40625 0.78125 0 0.26172-0.070313 0.48047-0.20312 0.65625-0.13672 0.17969-0.30859 0.26562-0.51562 0.26562-0.21094 0-0.38281-0.085938-0.51562-0.26562-0.125-0.17578-0.1875-0.39844-0.1875-0.67188 0-0.1875 0.035156-0.35156 0.10938-0.5 0.070313-0.14453 0.17188-0.23438 0.29688-0.26562v-0.015625c-0.21094-0.09375-0.3125-0.29688-0.3125-0.60938 0-0.22656 0.050781-0.41406 0.15625-0.5625 0.11328-0.15625 0.26562-0.23438 0.45312-0.23438s0.33594 0.078125 0.45312 0.23438c0.11328 0.15625 0.17188 0.34375 0.17188 0.5625 0 0.30469-0.10547 0.50781-0.3125 0.60938zm-0.3125-0.15625c0.10156 0 0.1875-0.039062 0.25-0.125 0.070313-0.09375 0.10938-0.20703 0.10938-0.34375 0-0.13281-0.039062-0.25-0.10938-0.34375-0.0625-0.09375-0.14844-0.14062-0.25-0.14062-0.09375 0-0.17969 0.046875-0.25 0.14062-0.0625 0.09375-0.09375 0.20312-0.09375 0.32812 0 0.14844 0.03125 0.26562 0.09375 0.35938 0.070313 0.085938 0.15625 0.125 0.25 0.125zm0 1.5625c0.125 0 0.22656-0.054688 0.3125-0.17188 0.082031-0.11328 0.125-0.26562 0.125-0.45312 0-0.17578-0.042969-0.32031-0.125-0.4375-0.085937-0.125-0.1875-0.1875-0.3125-0.1875s-0.23047 0.0625-0.3125 0.1875c-0.085937 0.11719-0.125 0.26172-0.125 0.4375 0 0.17969 0.039063 0.32812 0.125 0.45312 0.082031 0.11719 0.1875 0.17188 0.3125 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2656-1.4375c-0.054687 0.11719-0.125 0.21094-0.21875 0.28125-0.085937 0.074219-0.17969 0.10938-0.28125 0.10938-0.17969 0-0.32812-0.085937-0.45312-0.26562-0.125-0.1875-0.1875-0.42969-0.1875-0.73438 0-0.30078 0.0625-0.54688 0.1875-0.73438 0.125-0.19531 0.28516-0.29688 0.48438-0.29688 0.20703 0 0.38281 0.10938 0.53125 0.32812 0.14453 0.21875 0.21875 0.60547 0.21875 1.1562 0 0.55469-0.070313 0.96484-0.20312 1.2344-0.13672 0.27344-0.32812 0.40625-0.57812 0.40625-0.15625 0-0.29297-0.0625-0.40625-0.1875-0.10547-0.125-0.16797-0.3125-0.1875-0.5625l0.25-0.03125c0.039063 0.32422 0.16016 0.48438 0.35938 0.48438 0.15625 0 0.27344-0.10156 0.35938-0.3125 0.09375-0.21875 0.14062-0.50781 0.14062-0.875zm-0.4375 0.0625c0.125 0 0.22266-0.0625 0.29688-0.1875 0.082031-0.13281 0.125-0.30078 0.125-0.5 0-0.19531-0.042969-0.36328-0.125-0.5-0.074219-0.13281-0.17188-0.20312-0.29688-0.20312-0.11719 0-0.21484 0.074219-0.29688 0.21875-0.085938 0.13672-0.125 0.30859-0.125 0.51562 0 0.19922 0.035156 0.35938 0.10938 0.48438 0.082031 0.11719 0.1875 0.17188 0.3125 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5312-2.7344c-0.21094 0.33594-0.39062 0.74609-0.54688 1.2344-0.15625 0.48047-0.24609 0.98047-0.26562 1.5h-0.28125c0.007812-0.41406 0.082031-0.875 0.21875-1.375 0.13281-0.5 0.3125-0.92578 0.53125-1.2812h-1.0469v-0.35938h1.3906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5156 0h-1.4219c0-0.17578 0.039062-0.35156 0.125-0.53125 0.082031-0.17578 0.23828-0.39453 0.46875-0.65625 0.14453-0.16406 0.26953-0.33594 0.375-0.51562 0.11328-0.17578 0.17188-0.35156 0.17188-0.53125 0-0.15625-0.039063-0.28125-0.10938-0.375-0.074219-0.10156-0.17188-0.15625-0.29688-0.15625-0.11719 0-0.21484 0.054687-0.29688 0.15625-0.074219 0.10547-0.10938 0.25781-0.10938 0.45312l-0.28125-0.03125c0.019531-0.28906 0.09375-0.50781 0.21875-0.65625 0.125-0.15625 0.28516-0.23438 0.48438-0.23438 0.20703 0 0.36719 0.085937 0.48438 0.25 0.125 0.16797 0.1875 0.37109 0.1875 0.60938 0 0.1875-0.054687 0.38672-0.15625 0.59375-0.09375 0.19922-0.29297 0.46484-0.59375 0.79688-0.15625 0.17969-0.26172 0.33594-0.3125 0.46875h1.0625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8594 0.90625h-0.1875c-0.16797-0.30469-0.29688-0.625-0.39062-0.96875-0.085938-0.35156-0.125-0.70312-0.125-1.0469 0-0.38281 0.046875-0.74219 0.14062-1.0781 0.09375-0.33203 0.21875-0.64062 0.375-0.92188h0.1875c-0.17969 0.40625-0.29688 0.76172-0.35938 1.0625-0.054688 0.30469-0.078125 0.61719-0.078125 0.9375 0 0.66797 0.14453 1.3359 0.4375 2.0156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8906-0.20312-0.1875 0.23438c-0.32422-0.375-0.53906-0.875-0.64062-1.5v1.7344h-0.23438v-1.6406c-0.074219 0.42969-0.30469 0.88672-0.6875 1.375l-0.17188-0.25c0.35156-0.41406 0.58203-0.88281 0.6875-1.4062h-0.48438v-0.3125h0.65625v-0.60938h-0.28125c-0.054687 0.19922-0.12109 0.38281-0.20312 0.54688l-0.23438-0.15625c0.1875-0.28906 0.28906-0.67578 0.3125-1.1562l0.21875 0.10938c0 0.11719-0.011719 0.23047-0.03125 0.34375h0.21875v-0.6875h0.23438v0.6875h0.54688v0.3125h-0.54688v0.60938h0.6875v0.3125h-0.5c0.11328 0.625 0.32812 1.1094 0.64062 1.4531zm-1.6406-1.125-0.20312 0.17188c-0.042969-0.21875-0.10547-0.39062-0.1875-0.51562v1.9375h-0.23438v-1.7969c-0.054688 0.19922-0.17188 0.44922-0.35938 0.75l-0.1875-0.20312c0.28906-0.4375 0.47266-0.92188 0.54688-1.4531h-0.40625v-0.32812h0.40625v-0.8125h0.23438v0.8125h0.32812v0.32812h-0.32812v0.42188l0.015625-0.03125c0.11328 0.09375 0.23828 0.33594 0.375 0.71875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3281-3.1094c0.16406 0.29297 0.28906 0.61719 0.375 0.96875 0.09375 0.34375 0.14062 0.6875 0.14062 1.0312 0 0.38672-0.054688 0.74609-0.15625 1.0781-0.09375 0.33203-0.21484 0.64453-0.35938 0.9375h-0.1875c0.17578-0.41797 0.28906-0.77734 0.34375-1.0781 0.0625-0.30078 0.09375-0.61328 0.09375-0.9375 0-0.66406-0.14844-1.332-0.4375-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5469-2.8438-0.21875 0.125c-0.03125-0.23828-0.078125-0.42969-0.14062-0.57812l0.21875-0.125c0.050781 0.15625 0.097656 0.35156 0.14062 0.57812zm-1.0156-0.125-0.09375 0.39062c-0.27344-0.21875-0.57812-0.35156-0.92188-0.40625l0.09375-0.39062c0.38281 0.11719 0.69141 0.25 0.92188 0.40625zm0.67188 0.29688-0.20312 0.125c-0.03125-0.23828-0.078125-0.42969-0.14062-0.57812l0.21875-0.125c0.050781 0.15625 0.09375 0.35156 0.125 0.57812zm0.5 0.53125c-0.28125 0.625-0.59375 1.1211-0.9375 1.4844-0.34375 0.36719-0.76172 0.64062-1.25 0.82812l-0.14062-0.40625c0.50781-0.16406 0.92969-0.42578 1.2656-0.78125 0.34375-0.35156 0.61719-0.81641 0.82812-1.3906zm-1.4531 0.25-0.10938 0.40625c-0.23047-0.22656-0.53125-0.375-0.90625-0.4375l0.09375-0.39062c0.375 0.10547 0.67969 0.24609 0.92188 0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.375-2.3906-0.39062 1.2031-0.23438-0.125 0.25-0.79688-0.5 0.125 0.26562 1.7031-0.25 0.078125-0.26562-1.7031-0.59375 0.14062-0.046875-0.34375 0.59375-0.15625-0.09375-0.60938 0.25-0.0625 0.09375 0.60938 0.76562-0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5156-3.5781c0.082031 0 0.15625 0.046875 0.21875 0.14062 0.0625 0.085938 0.09375 0.1875 0.09375 0.3125 0 0.11719-0.03125 0.21875-0.09375 0.3125s-0.13672 0.14062-0.21875 0.14062c-0.09375 0-0.17188-0.046875-0.23438-0.14062s-0.09375-0.19531-0.09375-0.3125c0-0.125 0.03125-0.22656 0.09375-0.3125 0.0625-0.09375 0.14062-0.14062 0.23438-0.14062zm0 0.625c0.03125 0 0.054687-0.015625 0.078125-0.046875 0.019531-0.03125 0.03125-0.070312 0.03125-0.125 0-0.050781-0.011719-0.09375-0.03125-0.125-0.023438-0.039062-0.046875-0.0625-0.078125-0.0625-0.042969 0-0.074219 0.023438-0.09375 0.0625-0.023437 0.03125-0.03125 0.074219-0.03125 0.125 0 0.054688 0.00781 0.09375 0.03125 0.125 0.019531 0.03125 0.050781 0.046875 0.09375 0.046875zm-1.3125-0.3125c-0.0625 0.64844-0.16797 1.2812-0.3125 1.9062-0.14844 0.625-0.3125 1.125-0.5 1.5l-0.25-0.25c0.20703-0.41406 0.37891-0.91406 0.51562-1.5 0.14453-0.58203 0.23438-1.1758 0.26562-1.7812zm1.4531 3.1719-0.28125 0.10938c-0.03125-0.44531-0.12109-0.96875-0.26562-1.5625-0.13672-0.59375-0.29688-1.1445-0.48438-1.6562l0.25-0.17188c0.40625 1.2422 0.66406 2.3359 0.78125 3.2812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.89062 0.90625h-0.1875c-0.16797-0.30469-0.29688-0.625-0.39062-0.96875-0.085938-0.35156-0.125-0.70312-0.125-1.0469 0-0.38281 0.046875-0.74219 0.14062-1.0781 0.09375-0.33203 0.21875-0.64062 0.375-0.92188h0.1875c-0.17969 0.40625-0.29688 0.76172-0.35938 1.0625-0.054688 0.30469-0.078125 0.61719-0.078125 0.9375 0 0.66797 0.14453 1.3359 0.4375 2.0156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.29688-3.1094c0.16406 0.29297 0.28906 0.61719 0.375 0.96875 0.09375 0.34375 0.14062 0.6875 0.14062 1.0312 0 0.38672-0.054688 0.74609-0.15625 1.0781-0.09375 0.33203-0.21484 0.64453-0.35938 0.9375h-0.1875c0.17578-0.41797 0.28906-0.77734 0.34375-1.0781 0.0625-0.30078 0.09375-0.61328 0.09375-0.9375 0-0.66406-0.14844-1.332-0.4375-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6406-0.84375h-0.45312l-0.125 0.89062h-0.23438l0.14062-0.89062h-0.46875l-0.125 0.89062h-0.21875l0.125-0.89062h-0.25v-0.29688h0.29688l0.10938-0.76562h-0.40625v-0.3125h0.45312l0.125-0.89062h0.21875l-0.125 0.89062h0.45312l0.125-0.89062h0.21875l-0.125 0.89062h0.26562v0.3125h-0.3125l-0.09375 0.76562h0.40625zm-0.53125-1.0625h-0.45312l-0.10938 0.76562h0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2344-0.046875-0.078125 0.28125c-0.16797-0.085937-0.32422-0.21094-0.46875-0.375-0.15625 0.125-0.32812 0.1875-0.51562 0.1875-0.30469 0-0.55469-0.14453-0.75-0.4375-0.1875-0.30078-0.28125-0.67969-0.28125-1.1406 0-0.45703 0.09375-0.83203 0.28125-1.125 0.1875-0.30078 0.4375-0.45312 0.75-0.45312 0.30078 0 0.54688 0.14844 0.73438 0.4375 0.19531 0.28125 0.29688 0.66406 0.29688 1.1406 0 0.5-0.10938 0.90234-0.32812 1.2031 0.11328 0.125 0.23438 0.21875 0.35938 0.28125zm-0.57812-0.5c0.16406-0.22656 0.25-0.55469 0.25-0.98438 0-0.38281-0.070312-0.6875-0.20312-0.90625-0.13672-0.21875-0.3125-0.32812-0.53125-0.32812s-0.39844 0.10547-0.53125 0.3125c-0.13672 0.21094-0.20312 0.51562-0.20312 0.92188 0 0.39844 0.066406 0.70312 0.20312 0.92188 0.13281 0.21094 0.3125 0.3125 0.53125 0.3125 0.10156 0 0.19531-0.023437 0.28125-0.078125-0.09375-0.082031-0.1875-0.14062-0.28125-0.17188l0.078125-0.29688c0.16406 0.074219 0.30078 0.17188 0.40625 0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.8125 0c-0.085938 0.019531-0.15234 0.03125-0.20312 0.03125-0.11719 0-0.19922-0.027344-0.25-0.078125-0.054687-0.0625-0.085937-0.13281-0.09375-0.21875-0.011719-0.09375-0.015625-0.22266-0.015625-0.39062v-1.2656h-0.20312v-0.29688h0.20312v-0.54688l0.25-0.23438v0.78125h0.26562v0.29688h-0.26562v1.2969c0 0.10547 0.007812 0.18359 0.03125 0.23438 0.019531 0.042969 0.0625 0.0625 0.125 0.0625 0.03125 0 0.066406-0.003906 0.10938-0.015625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5469-1.0156h-1.1562c0.007813 0.25 0.054687 0.44531 0.14062 0.57812 0.09375 0.125 0.20312 0.1875 0.32812 0.1875 0.10156 0 0.1875-0.035156 0.25-0.10938 0.070313-0.082031 0.125-0.20312 0.15625-0.35938l0.28125 0.046875c-0.042969 0.24219-0.125 0.42188-0.25 0.54688-0.11719 0.11719-0.26172 0.17188-0.4375 0.17188-0.23047 0-0.41406-0.097656-0.54688-0.29688-0.125-0.20703-0.1875-0.48828-0.1875-0.84375 0-0.34375 0.0625-0.625 0.1875-0.84375s0.30078-0.32812 0.53125-0.32812c0.11328 0 0.22266 0.039063 0.32812 0.10938 0.10156 0.0625 0.19141 0.18359 0.26562 0.35938 0.070312 0.16797 0.10938 0.42969 0.10938 0.78125zm-0.26562-0.3125c-0.011719-0.21875-0.0625-0.375-0.15625-0.46875-0.085938-0.10156-0.17969-0.15625-0.28125-0.15625-0.125 0-0.23047 0.058594-0.3125 0.17188-0.074219 0.11719-0.11719 0.26562-0.125 0.45312zm-0.0625-1.7812-0.32812 0.57812h-0.21875l0.20312-0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7969-3.0625-0.59375 3.0625h-0.26562l-0.46875-2.4219c-0.023438-0.11328-0.039062-0.20703-0.046875-0.28125h-0.015625l-0.046875 0.375-0.46875 2.3281h-0.28125l-0.57812-3.0625h0.29688l0.32812 2.0156c0.039062 0.26172 0.066406 0.45312 0.078125 0.57812 0.007813 0.023438 0.015625 0.039062 0.015625 0.046875 0.039062-0.26953 0.070312-0.46094 0.09375-0.57812l0.40625-2.0625h0.34375l0.3125 1.5469c0.070312 0.38672 0.125 0.75 0.15625 1.0938h0.015625c0.019531-0.16406 0.050781-0.39062 0.09375-0.67188l0.34375-1.9688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219 0h-0.28125v-2.7031h-1.1094v2.7031h-0.29688v-3.0625h1.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5781-2.7031h-1.0469v2.7031h-0.28125v-3.0625h1.3281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219-1.2969c0 0.15625-0.00781 0.30469-0.015625 0.4375-0.011719 0.13672-0.042969 0.27734-0.09375 0.42188-0.054688 0.13672-0.14062 0.25-0.26562 0.34375-0.11719 0.09375-0.27344 0.14062-0.46875 0.14062-0.1875 0-0.33984-0.042969-0.45312-0.125-0.11719-0.082031-0.20312-0.1875-0.26562-0.3125-0.054687-0.13281-0.089844-0.27344-0.10938-0.42188-0.011719-0.14453-0.015625-0.30469-0.015625-0.48438v-1.7656h0.28125v1.7656c0 0.1875 0.007813 0.35156 0.03125 0.48438 0.019531 0.125 0.066406 0.24219 0.14062 0.34375 0.082031 0.10547 0.20703 0.15625 0.375 0.15625 0.16406 0 0.28906-0.039062 0.375-0.125 0.082031-0.082031 0.13281-0.19141 0.15625-0.32812 0.03125-0.13281 0.046875-0.3125 0.046875-0.53125v-1.7656h0.28125zm-0.42188-2.0469h-0.26562v-0.4375h0.26562zm-0.54688 0h-0.26562v-0.4375h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0h-0.28125v-3.0625h0.28125zm0-3.3125h-0.28125v-0.4375h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7812-0.84375c0 0.5-0.085938 0.84766-0.25 1.0469-0.15625 0.20703-0.39844 0.3125-0.71875 0.3125-0.46875 0-0.70312-0.28125-0.70312-0.84375 0-0.125 0.007813-0.26562 0.03125-0.42188l0.23438 0.078125c-0.011719 0.10547-0.015625 0.21875-0.015625 0.34375 0 0.15625 0.035156 0.26562 0.10938 0.32812 0.070312 0.070312 0.1875 0.10938 0.34375 0.10938 0.25 0 0.42969-0.0625 0.54688-0.1875 0.11328-0.13281 0.17188-0.38281 0.17188-0.75v-2.2344h0.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.84375 0h-0.84375v-0.40625h0.84375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6719 0h-0.35938c-0.15625 0-0.32031-0.09375-0.48438-0.28125-0.17969 0.1875-0.33984 0.28125-0.48438 0.28125h-0.35938v-0.40625h0.375c0.10156 0 0.19141-0.023438 0.26562-0.078125-0.29297-0.3125-0.4375-0.5625-0.4375-0.75 0-0.15625 0.066406-0.28125 0.20312-0.375 0.13281-0.09375 0.28125-0.14062 0.4375-0.14062 0.16406 0 0.3125 0.046875 0.4375 0.14062 0.13281 0.09375 0.20312 0.21875 0.20312 0.375 0 0.09375-0.042969 0.21094-0.125 0.34375-0.085938 0.125-0.1875 0.25781-0.3125 0.39062 0.09375 0.0625 0.1875 0.09375 0.28125 0.09375h0.35938zm-0.84375-0.67188c0.25781-0.22656 0.39062-0.38281 0.39062-0.46875 0-0.125-0.13281-0.1875-0.39062-0.1875-0.26172 0-0.39062 0.0625-0.39062 0.1875 0 0.085937 0.12891 0.24219 0.39062 0.46875zm0.14062-1.625h-0.26562v-0.375h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3125 0c-0.125 0-0.21484-0.035156-0.26562-0.10938-0.042969 0.32031-0.15234 0.57031-0.32812 0.75-0.17969 0.17578-0.39844 0.26562-0.65625 0.26562-0.0625 0-0.15625-0.011719-0.28125-0.03125l0.046875-0.375c0.09375 0.019531 0.17188 0.03125 0.23438 0.03125 0.5 0 0.75-0.32812 0.75-0.98438 0-0.16406-0.027344-0.35156-0.078125-0.5625h0.28125c0.019531 0.125 0.035156 0.24609 0.046875 0.35938 0.00781 0.16797 0.085938 0.25 0.23438 0.25h0.015625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.57812-0.82812c0 0.30469-0.042969 0.51562-0.125 0.64062-0.074219 0.125-0.19531 0.1875-0.35938 0.1875h-0.09375v-0.40625h0.10938c0.14453 0 0.21875-0.14062 0.21875-0.42188v-0.39062h0.25zm-0.078125 1.4219h-0.26562v-0.375h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4062 0c-0.054688 0-0.125-0.039062-0.21875-0.125-0.074219-0.0625-0.125-0.09375-0.15625-0.09375-0.023438 0-0.039062 0.011719-0.046875 0.03125-0.011719 0.011719-0.015625 0.03125-0.015625 0.0625 0 0.023438 0.019531 0.0625 0.0625 0.125 0.070312 0.082031 0.10938 0.14844 0.10938 0.20312 0 0.17578-0.10938 0.33594-0.32812 0.48438-0.21094 0.14453-0.46484 0.21875-0.76562 0.21875-0.29297 0-0.52344-0.078125-0.6875-0.23438-0.16797-0.14844-0.25-0.35547-0.25-0.625 0-0.14453 0.019531-0.3125 0.0625-0.5l0.23438 0.09375c-0.03125 0.14844-0.046875 0.27734-0.046875 0.39062 0 0.15625 0.050781 0.26953 0.15625 0.34375 0.10156 0.082031 0.28125 0.125 0.53125 0.125 0.23828 0 0.4375-0.039062 0.59375-0.10938 0.15625-0.074219 0.23438-0.15234 0.23438-0.23438 0-0.03125-0.023438-0.078125-0.0625-0.14062-0.074219-0.09375-0.10938-0.17188-0.10938-0.23438 0-0.10156 0.03125-0.19531 0.09375-0.28125 0.070313-0.082031 0.14844-0.125 0.23438-0.125 0.0625 0 0.14062 0.042969 0.23438 0.125 0.0625 0.0625 0.10938 0.09375 0.14062 0.09375zm-0.125 1.1406h-0.1875v-0.26562h0.1875zm-0.35938 0h-0.1875v-0.26562h0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.90625-0.89062c-0.074219 0.03125-0.125 0.046875-0.15625 0.046875-0.15625 0-0.28906-0.0625-0.39062-0.1875-0.10547-0.13281-0.15625-0.33203-0.15625-0.59375 0-0.19531 0.046875-0.36719 0.14062-0.51562 0.10156-0.15625 0.21094-0.23438 0.32812-0.23438 0.13281 0 0.25781 0.10938 0.375 0.32812 0.11328 0.21875 0.17188 0.49219 0.17188 0.8125 0 0.38672-0.10938 0.6875-0.32812 0.90625s-0.51562 0.32812-0.89062 0.32812v-0.40625c0.25781 0 0.45703-0.035156 0.59375-0.10938 0.14453-0.082031 0.25-0.20703 0.3125-0.375zm0.046875-0.40625c0-0.16406-0.03125-0.31641-0.09375-0.45312-0.054687-0.14453-0.11719-0.21875-0.1875-0.21875-0.0625 0-0.11719 0.039062-0.15625 0.10938-0.042969 0.0625-0.0625 0.14062-0.0625 0.23438 0 0.11719 0.023437 0.21094 0.078125 0.28125 0.050781 0.0625 0.11719 0.09375 0.20312 0.09375 0.0625 0 0.13281-0.015625 0.21875-0.046875zm-0.21875-1.6406h-0.26562v-0.375h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.73438-0.46875c-0.21094 0.1875-0.3125 0.40234-0.3125 0.64062 0 0.1875 0.050781 0.32812 0.15625 0.42188 0.11328 0.10156 0.26953 0.15625 0.46875 0.15625 0.16406 0 0.36719-0.042969 0.60938-0.125l0.046875 0.39062c-0.21875 0.09375-0.4375 0.14062-0.65625 0.14062-0.27344 0-0.48438-0.089844-0.64062-0.26562-0.15625-0.17969-0.23438-0.41797-0.23438-0.71875 0-0.16797 0.035156-0.32031 0.10938-0.46875 0.070312-0.14453 0.17578-0.26953 0.3125-0.375-0.17969-0.21875-0.28125-0.375-0.3125-0.46875s-0.046875-0.17969-0.046875-0.26562c0-0.14453 0.0625-0.25781 0.1875-0.34375 0.125-0.09375 0.25781-0.14062 0.40625-0.14062 0.14453 0 0.28125 0.046875 0.40625 0.14062 0.125 0.085938 0.1875 0.20312 0.1875 0.35938 0 0.10547-0.03125 0.21094-0.09375 0.3125-0.054687 0.10547-0.15234 0.21875-0.29688 0.34375-0.03125 0.042969-0.0625 0.074219-0.09375 0.09375 0.09375 0.11719 0.17969 0.18359 0.26562 0.20312 0.082031 0.023438 0.17188 0.03125 0.26562 0.03125h0.20312v0.40625h-0.1875c-0.11719 0-0.23047-0.023438-0.34375-0.078125-0.10547-0.050781-0.24219-0.17969-0.40625-0.39062zm0.0625-0.35938c0.23828-0.17578 0.35938-0.33203 0.35938-0.46875 0-0.125-0.10938-0.1875-0.32812-0.1875-0.23047 0-0.34375 0.058594-0.34375 0.17188 0 0.085938 0.10156 0.24609 0.3125 0.48438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.625-0.42188c0.25781-0.57031 0.46875-0.95312 0.625-1.1406 0.16406-0.19531 0.3125-0.29688 0.4375-0.29688 0.16406 0 0.30078 0.085937 0.40625 0.25 0.11328 0.15625 0.17188 0.35938 0.17188 0.60938 0 0.3125-0.09375 0.55859-0.28125 0.73438-0.1875 0.17969-0.44922 0.26562-0.78125 0.26562h-0.48438c-0.15625 0-0.27734-0.054688-0.35938-0.17188-0.074219 0.11719-0.19531 0.17188-0.35938 0.17188v-0.40625h0.015625c0.14453 0 0.21875-0.14062 0.21875-0.42188v-0.21875h0.26562v0.21875c0 0.21875 0.039062 0.35547 0.125 0.40625zm0.25 0.015625h0.32812c0.25 0 0.44531-0.050781 0.59375-0.15625 0.14453-0.10156 0.21875-0.24219 0.21875-0.42188 0-0.125-0.039063-0.23438-0.10938-0.32812-0.0625-0.10156-0.13672-0.15625-0.21875-0.15625-0.19922 0-0.46875 0.35547-0.8125 1.0625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5156 0v-0.375h-1.6406l1.6094-2.4688v-0.03125h-2.1719v0.375h1.4844l-1.6094 2.4688v0.03125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3594-2.9062c-0.375 0-0.70312 0.09375-0.875 0.17188v0.40625c0.15625-0.078125 0.45312-0.20312 0.79688-0.20312 0.60938 0 0.79688 0.29688 0.79688 0.79688v0.26562c-0.17188-0.078125-0.48438-0.17188-0.8125-0.17188-0.67188 0-1 0.35938-1 0.85938s0.35938 0.8125 0.875 0.8125c0.48438 0 0.79688-0.23438 0.9375-0.39062v0.35938h0.45312v-1.7812c0-0.70312-0.34375-1.125-1.1719-1.125zm0.71875 2.2344c-0.125 0.17188-0.375 0.39062-0.76562 0.39062-0.42188 0-0.59375-0.23438-0.59375-0.51562 0-0.32812 0.20312-0.5625 0.65625-0.5625 0.26562 0 0.53125 0.09375 0.70312 0.15625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9375-2.875c-0.48438 0-0.79688 0.28125-0.9375 0.48438v-0.48438h-0.45312v2.875h0.45312v-2.0156c0.14062-0.1875 0.4375-0.42188 0.8125-0.42188 0.0625 0 0.125 0 0.15625 0.015625h0.015625v-0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9688-2.9062c-0.46875 0-0.8125 0.25-0.96875 0.46875v-1.7656h-0.45312v4.2031h0.45312v-2.0781c0.14062-0.20312 0.4375-0.45312 0.8125-0.45312 0.39062 0 0.65625 0.20312 0.65625 0.70312v1.8281h0.45312v-1.9375c0-0.64062-0.42188-0.96875-0.95312-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6562-2.9531c-0.78125 0-1.3594 0.59375-1.3594 1.5156s0.57812 1.5156 1.3594 1.5156 1.375-0.59375 1.375-1.5156-0.59375-1.5156-1.375-1.5156zm0 2.6406c-0.51562 0-0.89062-0.4375-0.89062-1.125s0.375-1.1094 0.89062-1.1094c0.53125 0 0.90625 0.42188 0.90625 1.1094s-0.375 1.125-0.90625 1.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7969-2.9062c-0.51562 0-0.85938 0.26562-1.0156 0.5-0.14062-0.32812-0.46875-0.5-0.82812-0.5-0.48438 0-0.8125 0.26562-0.95312 0.46875v-0.4375h-0.45312v2.875h0.45312v-2.0625c0.10938-0.20312 0.39062-0.46875 0.75-0.46875 0.375 0 0.65625 0.1875 0.65625 0.6875v1.8438h0.46875v-1.9688c0-0.046875 0-0.078125-0.015625-0.10938 0.14062-0.21875 0.40625-0.45312 0.75-0.45312 0.39062 0 0.67188 0.20312 0.67188 0.6875v1.8438h0.45312v-1.9844c0-0.65625-0.46875-0.92188-0.9375-0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7812-1.6094c0-0.9375-0.57812-1.3438-1.1875-1.3438-0.70312 0-1.2969 0.51562-1.2969 1.5156 0 0.95312 0.5625 1.4688 1.4062 1.4688 0.4375 0 0.78125-0.14062 0.95312-0.25v-0.40625h-0.015625c-0.15625 0.125-0.46875 0.28125-0.90625 0.28125-0.65625 0-0.96875-0.40625-0.98438-1h2.0156s0.015625-0.125 0.015625-0.26562zm-2.0312-0.046875c0.03125-0.625 0.375-0.9375 0.84375-0.9375 0.42188 0 0.73438 0.32812 0.73438 0.85938v0.078125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.65625 0.03125c0.17188 0 0.29688-0.125 0.29688-0.29688s-0.125-0.29688-0.29688-0.29688-0.29688 0.125-0.29688 0.29688 0.125 0.29688 0.29688 0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.29688-1.4375c0 0.85938 0.54688 1.4688 1.4062 1.4688 0.35938 0 0.625-0.10938 0.75-0.1875v-0.4375h-0.015625c-0.14062 0.10938-0.39062 0.23438-0.71875 0.23438-0.51562 0-0.95312-0.34375-0.95312-1.0781s0.4375-1.0781 0.95312-1.0781c0.32812 0 0.57812 0.14062 0.71875 0.23438h0.015625v-0.4375c-0.125-0.078125-0.39062-0.1875-0.75-0.1875-0.85938 0-1.4062 0.60938-1.4062 1.4688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438-2.9844c-0.17188 0-0.3125 0.015625-0.375 0.03125l0.09375-0.98438h1.7344l0.078125-0.8125h-2.6094l-0.34375 2.875h0.046875c0.1875-0.10938 0.57812-0.25 1.0469-0.25 0.5625 0 0.85938 0.26562 0.85938 0.64062 0 0.32812-0.17188 0.64062-0.9375 0.64062-0.39062 0-0.78125-0.14062-1.0156-0.28125h-0.046875v0.95312c0.20312 0.09375 0.625 0.21875 1.1719 0.21875 1.1094 0 1.8594-0.5625 1.8594-1.5469 0-0.89062-0.60938-1.4844-1.5625-1.4844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2031-4.8594c-1.1875 0-1.875 1.0312-1.875 2.4844s0.6875 2.4844 1.875 2.4844 1.875-1.0312 1.875-2.4844-0.6875-2.4844-1.875-2.4844zm0 4.0781c-0.5625 0-0.8125-0.64062-0.8125-1.5938 0-0.96875 0.25-1.5938 0.8125-1.5938s0.8125 0.625 0.8125 1.5938c0 0.95312-0.25 1.5938-0.8125 1.5938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4062-1.7188 0.5-0.71875 0.65625-0.89062v-0.015625h-1.1094v0.015625s-0.046875 0.10938-0.46875 0.71875l-0.14062 0.21875-0.375-0.59375c-0.15625-0.25-0.21875-0.34375-0.21875-0.34375v-0.015625h-1.1562v0.015625l0.26562 0.39062 0.875 1.2344-0.57812 0.79688-0.625 0.89062v0.015625h1.1094v-0.015625s0.125-0.23438 0.54688-0.875l0.09375-0.125 0.4375 0.65625c0.15625 0.23438 0.21875 0.34375 0.21875 0.34375v0.015625h1.1719v-0.015625l-0.26562-0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.25-1.6719c0 1.0312 0.64062 1.7188 1.7188 1.7188 0.39062 0 0.70312-0.125 0.84375-0.20312v-0.9375h-0.03125c-0.14062 0.125-0.42188 0.26562-0.75 0.26562-0.46875 0-0.79688-0.25-0.79688-0.84375s0.32812-0.84375 0.79688-0.84375c0.32812 0 0.60938 0.14062 0.75 0.26562h0.03125v-0.9375c-0.14062-0.078125-0.45312-0.20312-0.84375-0.20312-1.0781 0-1.7188 0.6875-1.7188 1.7188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.4375-3.3906c-0.5625 0-0.9375 0.26562-1.125 0.46875-0.1875-0.26562-0.51562-0.46875-0.90625-0.46875-0.46875 0-0.79688 0.20312-0.96875 0.40625v-0.35938h-1v3.3438h1v-2.2969c0.0625-0.14062 0.25-0.29688 0.51562-0.29688 0.32812 0 0.5625 0.21875 0.5625 0.5625v2.0312h0.98438v-2.2969c0.09375-0.14062 0.28125-0.29688 0.53125-0.29688 0.35938 0 0.53125 0.26562 0.53125 0.5625v2.0312h1v-2.3125c0-0.6875-0.54688-1.0781-1.125-1.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1406-4.75c-0.20312 0.10938-0.57812 0.26562-1.0625 0.26562v0.8125c0.34375 0 0.625-0.046875 0.76562-0.09375v3.7656h1.0312v-4.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8594-4.8594c-0.92188 0-1.6875 0.53125-1.6875 1.7031 0 0.92188 0.59375 1.5156 1.3438 1.5156 0.51562 0 0.84375-0.17188 1.0469-0.35938-0.046875 0.8125-0.375 1.1875-1 1.1875-0.46875 0-0.79688-0.14062-0.95312-0.26562h-0.03125v0.96875c0.1875 0.078125 0.53125 0.15625 0.96875 0.15625 1.2031 0 2.0312-0.73438 2.0312-2.7031 0-1.4219-0.60938-2.2031-1.7188-2.2031zm-0.015625 2.4062c-0.42188 0-0.67188-0.28125-0.67188-0.73438 0-0.42188 0.15625-0.8125 0.6875-0.8125 0.46875 0 0.70312 0.34375 0.70312 1.0312v0.078125c-0.078125 0.21875-0.29688 0.4375-0.71875 0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812 0.03125c0.32812 0 0.57812-0.23438 0.57812-0.5625 0-0.34375-0.25-0.57812-0.57812-0.57812s-0.5625 0.23438-0.5625 0.57812c0 0.32812 0.23438 0.5625 0.5625 0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.9375-3.7031c0.3125 0 0.5625-0.26562 0.5625-0.5625s-0.25-0.5625-0.5625-0.5625c-0.32812 0-0.5625 0.26562-0.5625 0.5625s0.25 0.5625 0.5625 0.5625zm-0.5 0.39062v3.3125h1v-3.3438h-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-15-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3594-3.3906c-0.45312 0-0.76562 0.20312-0.92188 0.375v-0.32812h-1v3.3438h1v-2.3281c0.078125-0.10938 0.26562-0.25 0.53125-0.25 0.35938 0 0.53125 0.17188 0.53125 0.53125v2.0469h0.98438v-2.2656c0-0.625-0.40625-1.125-1.125-1.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.35938 0v-3.5781h1.5312c0.38281 0 0.66016 0.03125 0.82812 0.09375 0.17578 0.0625 0.31641 0.17969 0.42188 0.34375 0.10156 0.16797 0.15625 0.35547 0.15625 0.5625 0 0.27344-0.085937 0.49609-0.25 0.67188-0.15625 0.17969-0.39062 0.28906-0.70312 0.32812 0.15625 0.09375 0.28516 0.19922 0.39062 0.3125 0.10156 0.10547 0.23828 0.29297 0.40625 0.5625l0.4375 0.70312h-0.85938l-0.51562-0.78125c-0.1875-0.28125-0.32031-0.45312-0.39062-0.51562-0.0625-0.070313-0.13672-0.125-0.21875-0.15625-0.074219-0.03125-0.19531-0.046875-0.35938-0.046875h-0.14062v1.5zm0.73438-2.0625h0.53125c0.34375 0 0.55469-0.015625 0.64062-0.046875 0.09375-0.03125 0.16016-0.082031 0.20312-0.15625 0.050781-0.070313 0.078125-0.16016 0.078125-0.26562 0-0.11328-0.03125-0.20703-0.09375-0.28125-0.0625-0.082031-0.15234-0.13281-0.26562-0.15625h-0.53125-0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8594-0.82812 0.6875 0.125c-0.09375 0.25-0.23438 0.44531-0.42188 0.57812-0.1875 0.125-0.42188 0.1875-0.70312 0.1875-0.46094 0-0.79297-0.14844-1-0.45312-0.17969-0.22656-0.26562-0.52344-0.26562-0.89062 0-0.42578 0.10938-0.75781 0.32812-1 0.22656-0.25 0.51562-0.375 0.85938-0.375 0.38281 0 0.6875 0.13281 0.90625 0.39062 0.22656 0.25 0.33594 0.64062 0.32812 1.1719h-1.7188c0.007813 0.19922 0.066406 0.35547 0.17188 0.46875 0.10156 0.11719 0.23438 0.17188 0.39062 0.17188 0.10156 0 0.19141-0.023437 0.26562-0.078125 0.070312-0.0625 0.12891-0.16016 0.17188-0.29688zm0.046875-0.6875c-0.011719-0.19531-0.070312-0.34766-0.17188-0.45312-0.09375-0.10156-0.21094-0.15625-0.34375-0.15625-0.14844 0-0.27344 0.054688-0.375 0.15625-0.09375 0.11719-0.14062 0.26562-0.14062 0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.29688 0.17188 0.78125 0.09375c0.00781 0.09375 0.039063 0.15625 0.09375 0.1875 0.0625 0.050781 0.16406 0.078125 0.3125 0.078125 0.17578 0 0.30469-0.027344 0.39062-0.078125 0.0625-0.042969 0.10938-0.10156 0.14062-0.17188 0.019531-0.0625 0.03125-0.17188 0.03125-0.32812v-0.375c-0.21094 0.28125-0.46875 0.42188-0.78125 0.42188-0.34375 0-0.62109-0.14453-0.82812-0.4375-0.15625-0.23828-0.23438-0.53125-0.23438-0.875 0-0.4375 0.10156-0.76953 0.3125-1 0.20703-0.22656 0.46875-0.34375 0.78125-0.34375 0.32031 0 0.58594 0.14062 0.79688 0.42188v-0.35938h0.64062v2.3281c0 0.30078-0.027344 0.52344-0.078125 0.67188-0.054688 0.15625-0.125 0.27344-0.21875 0.35938-0.085938 0.09375-0.20312 0.16016-0.35938 0.20312-0.14844 0.050781-0.33984 0.078125-0.57812 0.078125-0.4375 0-0.75-0.078125-0.9375-0.23438-0.17969-0.14844-0.26562-0.33594-0.26562-0.5625v-0.078125zm0.60938-1.5156c0 0.27344 0.050781 0.47656 0.15625 0.60938 0.11328 0.125 0.25 0.1875 0.40625 0.1875 0.16406 0 0.30469-0.066406 0.42188-0.20312 0.11328-0.13281 0.17188-0.32812 0.17188-0.57812 0-0.26953-0.058594-0.46875-0.17188-0.59375-0.10547-0.13281-0.24609-0.20312-0.42188-0.20312-0.15625 0-0.29297 0.0625-0.40625 0.1875-0.10547 0.125-0.15625 0.32422-0.15625 0.59375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.35938 0v-0.6875h0.6875v0.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 1.0469h-0.46875c-0.25-0.375-0.44531-0.76562-0.57812-1.1719-0.125-0.40625-0.1875-0.79688-0.1875-1.1719 0-0.46875 0.078125-0.91016 0.23438-1.3281 0.14453-0.36328 0.32031-0.70312 0.53125-1.0156h0.46875c-0.21875 0.49219-0.37109 0.91406-0.45312 1.2656-0.085937 0.34375-0.125 0.71094-0.125 1.0938 0 0.27344 0.019531 0.54688 0.0625 0.82812 0.050781 0.27344 0.125 0.53516 0.21875 0.79688 0.050781 0.16406 0.14844 0.39844 0.29688 0.70312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.35938 0v-3.5781h2.6562v0.60938h-1.9219v0.78125h1.7969v0.60938h-1.7969v0.96875h2v0.60938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6562-1.3125 0.70312 0.21875c-0.11719 0.38672-0.29688 0.67969-0.54688 0.875-0.25 0.1875-0.5625 0.28125-0.9375 0.28125-0.48047 0-0.875-0.16016-1.1875-0.48438-0.30469-0.32031-0.45312-0.76953-0.45312-1.3438 0-0.59375 0.14844-1.0508 0.45312-1.375 0.3125-0.33203 0.71875-0.5 1.2188-0.5 0.4375 0 0.79688 0.13281 1.0781 0.39062 0.15625 0.15625 0.27344 0.375 0.35938 0.65625l-0.71875 0.17188c-0.042969-0.1875-0.13281-0.33203-0.26562-0.4375-0.13672-0.10156-0.29688-0.15625-0.48438-0.15625-0.26172 0-0.47656 0.09375-0.64062 0.28125-0.16797 0.1875-0.25 0.49609-0.25 0.92188 0 0.44922 0.078125 0.77344 0.23438 0.96875 0.16406 0.1875 0.37891 0.28125 0.64062 0.28125 0.19531 0 0.36328-0.054688 0.5-0.17188 0.13281-0.125 0.23438-0.31641 0.29688-0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.17188 1.0469c0.13281-0.28125 0.22656-0.5 0.28125-0.65625 0.050781-0.15625 0.097656-0.33594 0.14062-0.53125 0.050781-0.20703 0.085938-0.39844 0.10938-0.57812 0.03125-0.1875 0.046875-0.375 0.046875-0.5625 0-0.38281-0.042969-0.75-0.125-1.0938-0.085938-0.35156-0.24219-0.77344-0.46875-1.2656h0.46875c0.25 0.35547 0.44141 0.73047 0.57812 1.125 0.13281 0.38672 0.20312 0.78125 0.20312 1.1875 0 0.33594-0.054688 0.69922-0.15625 1.0938-0.125 0.4375-0.32812 0.86328-0.60938 1.2812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9688 0h-0.6875v-2.5781c-0.25 0.23047-0.54688 0.40234-0.89062 0.51562v-0.625c0.1875-0.0625 0.38281-0.17188 0.59375-0.32812 0.20703-0.16406 0.34766-0.35938 0.42188-0.57812h0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.23438-0.82812 0.65625-0.078125c0.019531 0.13672 0.0625 0.24219 0.125 0.3125 0.070313 0.0625 0.16406 0.09375 0.28125 0.09375 0.13281 0 0.25-0.0625 0.34375-0.1875 0.10156-0.13281 0.17188-0.41016 0.20312-0.82812-0.17969 0.21094-0.39844 0.3125-0.65625 0.3125-0.28125 0-0.52734-0.10938-0.73438-0.32812-0.19922-0.21875-0.29688-0.50391-0.29688-0.85938 0-0.35156 0.10938-0.64062 0.32812-0.85938 0.21875-0.22656 0.49219-0.34375 0.82812-0.34375 0.35156 0 0.64453 0.14062 0.875 0.42188 0.23828 0.28125 0.35938 0.74609 0.35938 1.3906 0 0.64844-0.12109 1.1172-0.35938 1.4062-0.24219 0.29297-0.55859 0.4375-0.95312 0.4375-0.28125 0-0.51172-0.070312-0.6875-0.21875-0.16797-0.15625-0.27344-0.37891-0.3125-0.67188zm1.5469-1.5c0-0.21875-0.054688-0.39062-0.15625-0.51562-0.10547-0.125-0.21875-0.1875-0.34375-0.1875-0.13672 0-0.24609 0.054688-0.32812 0.15625-0.085937 0.10547-0.125 0.26562-0.125 0.48438 0 0.24219 0.046875 0.41406 0.14062 0.51562 0.09375 0.10547 0.20703 0.15625 0.34375 0.15625 0.13281 0 0.24219-0.050781 0.32812-0.15625 0.09375-0.10156 0.14062-0.25391 0.14062-0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.1875-0.95312 0.67188-0.078125c0.019531 0.16797 0.070313 0.29688 0.15625 0.39062 0.09375 0.085937 0.20703 0.125 0.34375 0.125 0.14453 0 0.26562-0.050781 0.35938-0.15625 0.09375-0.10156 0.14062-0.25 0.14062-0.4375 0-0.16406-0.046875-0.30078-0.14062-0.40625-0.09375-0.10156-0.20312-0.15625-0.32812-0.15625-0.09375 0-0.20312 0.023437-0.32812 0.0625l0.078125-0.5625c0.1875 0 0.32812-0.039063 0.42188-0.125 0.10156-0.082031 0.15625-0.19531 0.15625-0.34375 0-0.11328-0.039062-0.20703-0.10938-0.28125-0.074219-0.070313-0.16797-0.10938-0.28125-0.10938-0.125 0-0.23047 0.042969-0.3125 0.125-0.074219 0.085938-0.12109 0.20312-0.14062 0.35938l-0.64062-0.10938c0.050781-0.21875 0.11719-0.39062 0.20312-0.51562 0.09375-0.13281 0.21875-0.23828 0.375-0.3125 0.15625-0.070313 0.33203-0.10938 0.53125-0.10938 0.33203 0 0.60156 0.10938 0.8125 0.32812 0.16406 0.16797 0.25 0.36719 0.25 0.59375 0 0.3125-0.17188 0.5625-0.51562 0.75 0.20703 0.042969 0.36719 0.14062 0.48438 0.29688 0.125 0.14844 0.1875 0.32812 0.1875 0.54688 0 0.3125-0.11719 0.58594-0.34375 0.8125-0.23047 0.21875-0.51562 0.32812-0.85938 0.32812-0.32422 0-0.59375-0.09375-0.8125-0.28125-0.21094-0.1875-0.32812-0.42969-0.35938-0.73438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875-0.92188 0.6875-0.0625c0.019531 0.14844 0.078125 0.26562 0.17188 0.35938s0.20312 0.14062 0.32812 0.14062c0.14453 0 0.26562-0.054687 0.35938-0.17188 0.10156-0.125 0.15625-0.30078 0.15625-0.53125 0-0.21875-0.054687-0.37891-0.15625-0.48438-0.09375-0.11328-0.21875-0.17188-0.375-0.17188-0.19922 0-0.375 0.085938-0.53125 0.25l-0.54688-0.078125 0.34375-1.8594h1.8125v0.64062h-1.2969l-0.10938 0.60938c0.15625-0.070312 0.3125-0.10938 0.46875-0.10938 0.3125 0 0.57031 0.10938 0.78125 0.32812 0.20703 0.21875 0.3125 0.50781 0.3125 0.85938 0 0.29297-0.085938 0.55859-0.25 0.79688-0.23047 0.3125-0.55469 0.46875-0.96875 0.46875-0.33594 0-0.60547-0.085938-0.8125-0.26562-0.21094-0.17578-0.33594-0.41406-0.375-0.71875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.0625 0.875-3.7031h0.51562l-0.89062 3.7031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5312-0.64062v0.64062h-2.4062c0.019531-0.23828 0.09375-0.46875 0.21875-0.6875 0.13281-0.21875 0.39453-0.50391 0.78125-0.85938 0.3125-0.28125 0.50391-0.47266 0.57812-0.57812 0.09375-0.14453 0.14062-0.28516 0.14062-0.42188 0-0.15625-0.042969-0.27344-0.125-0.35938-0.085938-0.082031-0.19922-0.125-0.34375-0.125-0.14844 0-0.26172 0.046875-0.34375 0.14062-0.085938 0.085937-0.13281 0.22656-0.14062 0.42188l-0.6875-0.0625c0.039063-0.375 0.16406-0.64453 0.375-0.8125 0.21875-0.16406 0.48828-0.25 0.8125-0.25 0.35156 0 0.62891 0.10156 0.82812 0.29688 0.20703 0.1875 0.3125 0.42188 0.3125 0.70312 0 0.15625-0.03125 0.30859-0.09375 0.45312-0.054688 0.14844-0.14062 0.29688-0.26562 0.45312-0.085937 0.11719-0.23438 0.27344-0.45312 0.46875-0.21875 0.19922-0.35938 0.32812-0.42188 0.39062-0.054687 0.0625-0.09375 0.125-0.125 0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.375-3.5938c0.34375 0 0.61328 0.125 0.8125 0.375 0.22656 0.29297 0.34375 0.77734 0.34375 1.4531 0 0.67969-0.11719 1.1641-0.34375 1.4531-0.19922 0.25-0.46875 0.375-0.8125 0.375-0.35547 0-0.64062-0.13281-0.85938-0.40625-0.21094-0.26953-0.3125-0.74219-0.3125-1.4219 0-0.67578 0.11719-1.1641 0.35938-1.4688 0.19531-0.23828 0.46875-0.35938 0.8125-0.35938zm0 0.5625c-0.085938 0-0.16406 0.03125-0.23438 0.09375-0.0625 0.054688-0.10938 0.14844-0.14062 0.28125-0.054688 0.17969-0.078125 0.47656-0.078125 0.89062 0 0.41797 0.019531 0.70312 0.0625 0.85938 0.050781 0.15625 0.10938 0.26172 0.17188 0.3125 0.0625 0.054688 0.13281 0.078125 0.21875 0.078125 0.082031 0 0.15625-0.023437 0.21875-0.078125 0.0625-0.050781 0.11328-0.14453 0.15625-0.28125 0.039062-0.17578 0.0625-0.47266 0.0625-0.89062 0-0.41406-0.023438-0.70312-0.0625-0.85938-0.042969-0.15625-0.09375-0.25781-0.15625-0.3125-0.0625-0.0625-0.13672-0.09375-0.21875-0.09375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-16-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5625 0v-0.71875h-1.4688v-0.60938l1.5469-2.2656h0.57812v2.2656h0.45312v0.60938h-0.45312v0.71875zm0-1.3281v-1.2188l-0.82812 1.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.125-2.375h-0.8125v2.375h0.35938v-0.95312h0.45312c0.54688 0 0.84375-0.26562 0.84375-0.71875 0-0.4375-0.29688-0.70312-0.84375-0.70312zm-0.45312 1.1406v-0.85938h0.4375c0.3125 0 0.48438 0.125 0.48438 0.42188 0 0.3125-0.17188 0.4375-0.48438 0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.32812-2.375v2.375h0.34375v-2.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7969-0.28125h-1.125v-0.79688h1.0312v-0.28125h-1.0312v-0.73438h1.125v-0.28125h-1.4844v2.375h1.5v-0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8906 0v-0.28125h-1.2656l1.2812-2.0469v-0.046875h-1.7031v0.28125h1.1875l-1.2812 2.0469v0.046875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2812-2.375h-0.3125l-0.70312 1.8125-0.21875 0.54688v0.015625h0.35938l0.015625-0.015625 0.1875-0.53125h1.0312l0.20312 0.53125v0.015625h0.375v-0.015625l-0.23438-0.57812zm0.26562 1.5625h-0.82812l0.40625-1.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.20312-0.10938c0.10938 0.0625 0.32812 0.14062 0.625 0.14062 0.53125 0 0.84375-0.28125 0.84375-0.67188 0-0.3125-0.15625-0.53125-0.54688-0.6875l-0.26562-0.09375c-0.20312-0.078125-0.28125-0.17188-0.28125-0.34375 0-0.1875 0.14062-0.34375 0.45312-0.34375 0.25 0 0.4375 0.09375 0.53125 0.15625h0.015625v-0.34375c-0.09375-0.046875-0.28125-0.10938-0.5625-0.10938-0.48438 0-0.79688 0.28125-0.79688 0.65625 0 0.28125 0.15625 0.51562 0.5 0.64062l0.26562 0.10938c0.23438 0.078125 0.32812 0.20312 0.32812 0.375 0 0.1875-0.125 0.35938-0.46875 0.35938-0.28125 0-0.51562-0.10938-0.64062-0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2812-2.0781c0.29688 0 0.48438 0.10938 0.57812 0.1875v-0.35938c-0.09375-0.078125-0.29688-0.14062-0.59375-0.14062-0.59375 0-1.0938 0.4375-1.0938 1.2031s0.5 1.2031 1.0938 1.2031c0.29688 0 0.5-0.0625 0.59375-0.14062v-0.35938c-0.09375 0.078125-0.28125 0.20312-0.57812 0.20312-0.40625 0-0.75-0.29688-0.75-0.90625s0.34375-0.89062 0.75-0.89062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.95312-3h-0.34375v0.015625l0.34375 0.4375h0.26562zm0.84375 2.7188h-1.125v-0.79688h1.0312v-0.28125h-1.0312v-0.73438h1.125v-0.28125h-1.4844v2.375h1.5v-0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2344-2.4219c-0.64062 0-1.0625 0.5-1.0625 1.2344s0.42188 1.2344 1.0625 1.2344c0.65625 0 1.0781-0.5 1.0781-1.2344s-0.42188-1.2344-1.0781-1.2344zm0 2.1719c-0.46875 0-0.70312-0.40625-0.70312-0.9375s0.23438-0.9375 0.70312-0.9375 0.71875 0.40625 0.71875 0.9375-0.25 0.9375-0.71875 0.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7812-2.3594v1.7656l-1.1406-1.7812h-0.32812v2.375h0.34375v-1.7812l1.125 1.7812h0.34375v-2.375h-0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6719-2.375h-1.6406v0.28125h0.64062v2.0938h0.35938v-2.0938h0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.39062 0.015625c0.10938 0 0.20312-0.078125 0.20312-0.20312s-0.09375-0.20312-0.20312-0.20312c-0.125 0-0.20312 0.078125-0.20312 0.20312s0.078125 0.20312 0.20312 0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-19-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75-5.9844c-0.75 0-1.2812 0.17188-1.5312 0.29688h-0.015625l0.39062-3.2031h4.0781l0.10938-0.90625h-5.1094l-0.67188 5.4062h0.09375c0.375-0.26562 1.1875-0.64062 2.3438-0.64062 1.5156 0 2.3125 0.85938 2.3125 2.0156 0 1.2656-0.90625 2.1406-2.6094 2.1406-1.0938 0-1.9375-0.375-2.4062-0.70312h-0.046875v1.0938c0.40625 0.25 1.2656 0.5625 2.5469 0.5625 2.1562 0 3.6875-1.1562 3.6875-3.1094 0-1.8125-1.2812-2.9531-3.1719-2.9531z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-665.77 -397.77)",
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("use", {
    x: 725.54102,
    y: 464.46701,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 728.40936,
    y: 464.46701,
    xlinkHref: "#glyph-0-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 731.27771,
    y: 464.46701,
    xlinkHref: "#glyph-0-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.14606,
    y: 464.46701,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 737.0144,
    y: 464.46701,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 739.88275,
    y: 464.46701,
    xlinkHref: "#glyph-0-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.7511,
    y: 464.46701,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.61945,
    y: 464.46701,
    xlinkHref: "#glyph-0-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.48779,
    y: 464.46701,
    xlinkHref: "#glyph-0-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 751.35614,
    y: 464.46701,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 754.22449,
    y: 464.46701,
    xlinkHref: "#glyph-0-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 757.09283,
    y: 464.46701,
    xlinkHref: "#glyph-0-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.96118,
    y: 464.46701,
    xlinkHref: "#glyph-0-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 762.82953,
    y: 464.46701,
    xlinkHref: "#glyph-0-4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0e0f0e"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.926 60.156h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.227 60.156h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.531 60.156h0.5664v-16.82h-0.5664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.828 60.156h0.57031v-16.82h-0.57031z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m47.105 60.156h1.5469v-16.82h-1.5469z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.383 60.156h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.684 60.156h1.5469v-16.82h-1.5469z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.937 60.156h0.5664v-16.82h-0.5664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.238 60.156h1.543v-16.82h-1.543z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.512 60.156h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.789 60.156h1.5469v-16.82h-1.5469z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.066 60.156h0.57032v-16.82h-0.57032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.344 60.156h1.5469v-16.82h-1.5469z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.621 60.156h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.922 60.156h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.141 60.156h1.6289v-16.82h-1.6289z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.477 60.156h0.56641v-16.82h-0.56641z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.672 60.156h0.64844v-16.82h-0.64844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.973 60.156h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.223 60.156h1.6289v-16.82h-1.6289z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m81.5 60.156h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.801 60.156h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.078 60.156h0.65235v-16.82h-0.65235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.355 60.156h0.64843v-16.82h-0.64843z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m88.656 60.156h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.91 60.156h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.187 60.156h0.64843v-16.82h-0.64843z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.488 60.156h0.64844v-16.82h-0.64844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.789 60.156h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.04 60.156h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.34 60.156h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.62 60.156h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.89 60.156h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.2 60.156h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.47 60.156h0.65235v-16.82h-0.65235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.77 60.156h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.03 60.156h0.64844v-16.82h-0.64844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.3 60.156h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.58 60.156h0.65235v-16.82h-0.65235z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-665.77 -397.77)",
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("use", {
    x: 739.87701,
    y: 437.63199,
    xlinkHref: "#glyph-1-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.11688,
    y: 437.63199,
    xlinkHref: "#glyph-1-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 750.78094,
    y: 437.63199,
    xlinkHref: "#glyph-1-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.3985,
    y: 437.56754,
    xlinkHref: "#glyph-2-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 767.1825,
    y: 437.56754,
    xlinkHref: "#glyph-2-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 776.79498,
    y: 433.25427,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.24298,
    y: 433.25427,
    xlinkHref: "#glyph-3-0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m127.81 176v-0.25h-127.31v-175.25h127.06v175.5h0.25v-0.25 0.25h0.25v-176h-128.06v176.25h128.06v-0.25zm-59.527-160.16h-0.25c0 1.1055-0.44922 2.1055-1.1719 2.8281-0.72656 0.72656-1.7266 1.1719-2.832 1.1719s-2.1055-0.44531-2.8281-1.1719c-0.72657-0.72266-1.1719-1.7227-1.1719-2.8281 0-1.1055 0.44531-2.1055 1.1719-2.832 0.72265-0.72265 1.7226-1.1719 2.8281-1.1719s2.1055 0.44922 2.832 1.1719c0.72266 0.72657 1.1719 1.7266 1.1719 2.832h0.5c0-2.4883-2.0156-4.5039-4.5039-4.5039-2.4844 0-4.5 2.0156-4.5 4.5039 0 2.4844 2.0156 4.5 4.5 4.5 2.4883 0 4.5039-2.0156 4.5039-4.5",
    fill: "#4f5257"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.54 133.91v-0.25391l0.60156-4e-3c-4e-3 0 0.33594-0.0664 0.33594-0.72656v-1.3281c-0.47657-0.043-1.207-0.30469-1.207-1.0703l-8e-3 -2.9648 1.8594-4e-3v0.2539l-1.6016 4e-3 4e-3 2.7109c0 0.79687 1.0352 0.82031 1.0781 0.82422h0.125l4e-3 1.5742c4e-3 0.89453-0.55078 0.97656-0.57422 0.98046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.58 133.9c-0.0391-8e-3 -0.59375-0.0859-0.59766-0.98437v-1.5703l0.125-4e-3c0.043 0 1.0781-0.0312 1.0742-0.82812l-8e-3 -2.7109-1.0586 4e-3v-0.2539l1.3125-4e-3 8e-3 2.9648c0 0.76562-0.72657 1.0312-1.1992 1.0781l4e-3 1.3242c0 0.66406 0.34375 0.72656 0.35938 0.72656h0.58203v0.25391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.67 129-4e-3 -1.3516h0.25781v1.3516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.14 129.02-4e-3 -1.3516h0.25391l4e-3 1.3516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.28 133.76-8e-3 -3.9766h0.1289c0.16407 0 0.22266-0.24219 0.22266-0.2461l-4e-3 -1.8711h0.25391l4e-3 1.9023c-0.0352 0.16016-0.14063 0.38282-0.35157 0.44922l0.0117 3.7422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.83 134.13-4.2227 8e-3 -4.2773 0.0117c-0.0937 0-0.19531-0.10156-0.19531-0.25l-0.0156-6.3555c0-0.15235 0.0977-0.30079 0.19531-0.30079l4.2774-8e-3 4.2226-0.0117c0.14453 0 0.24219 0.14844 0.24219 0.30078l0.0156 6.3555c0 0.14844-0.0977 0.25-0.24219 0.25m0.51562-6.6094c0-0.34375-0.24218-0.69141-0.53125-0.69141l-4.2226 8e-3 -4.2774 8e-3c-0.29297 0-0.53515 0.35156-0.53515 0.69922l0.0156 6.3555c0 0.35157 0.24219 0.69532 0.53516 0.69532l4.2773-8e-3 4.2227-0.0117c0.29297 0 0.53515-0.34766 0.53125-0.69532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.05 134.28-4.2305 0.0117-4.2773 8e-3c-0.15234 0-0.25-0.10157-0.25-0.20313l-0.0156-6.7383c0-0.15234 0.0977-0.25391 0.25-0.25391l4.2773-8e-3 4.2266-0.0117c0.14844 0 0.25 0.0977 0.25 0.25391l0.0117 6.7383c4e-3 0.10156-0.0937 0.20312-0.24219 0.20312m0.52344-6.9453c0-0.30078-0.24609-0.55078-0.54297-0.55078l-4.2305 0.0117-4.2773 8e-3c-0.29688 0-0.53906 0.25-0.53906 0.55469l0.0156 6.7422c0 0.30078 0.24609 0.5 0.54297 0.5l4.2773-8e-3 4.2305-0.0117c0.29688 0 0.54297-0.19922 0.53906-0.50391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.82 133.83-4.082 8e-3 -0.0117-5.3281 4.0781-0.0117 4.0352-8e-3 0.0117 5.332zm4.2188-5.543-4.2344 0.0117-4.2773 8e-3 0.0156 5.7852 4.2773-8e-3 4.2266-0.0117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.09 133.03-1.3359-2.4609-0.0977-0.0508c-0.19531 0.10156-0.19531 0.10156-0.0976 0.30469-0.2461 0.10156-0.39453 0.35156-0.2461 0.60156l1.0352 1.7109c0.0977 0.25 0.44531 0.39844 0.69141 0.29687l0.0508 0.15235v-0.30078c-0.2461-0.0508-0.44141 0.15234-0.59375-0.19922l-1.0352-1.7109c-0.19922-0.34766 0.24219-0.40234 0.29297-0.5l1.3359 2.4102zm-8e-3 -2.1094v0.25l4e-3 0.10156v0.35156l-0.10156-0.20312c-0.0469-0.20313 0-0.40235 0.0977-0.5m8e-3 2.6641v-0.30078h0.0469-0.0469v-0.25391l0.29297 0.45313c0.0508 0.15234-0.19532 0.19921-0.2461 0.10156zm1.7188-0.30469c-0.2461-0.0508-0.44141 0.15234-0.64063-0.19922l-1.0352-1.7109-0.0469-0.0977v0.35156l0.98438 1.5078c0.10156 0.25 0.39453 0.39844 0.6875 0.30078l0.0547 0.14844zm0-0.25-1.332-2.4648-0.0977-0.0508c-0.19922 0.10156-0.19922 0.10156-0.0977 0.30468-0.10156 0-0.14843 0.0508-0.19922 0.10157v0.25c0.0508-0.15235 0.29688-0.20313 0.34375-0.30469l1.3828 2.4141zm-4e-3 -2.1133v0.70312l-0.0977-0.19921c-0.0977-0.20313-0.0508-0.40625 0.0977-0.50391m8e-3 2.6641-4e-3 -0.30078v-0.25l0.25 0.45313c0.0976 0.14843-0.19922 0.19921-0.2461 0.0976m1.7188-0.30469c-0.24609-0.0508-0.49218 0.15235-0.63672-0.20312l-1.0391-1.707-0.0508-0.10156v0.35546l0.9375 1.5078c0.15234 0.25 0.44531 0.40234 0.73828 0.29687l0.0508 0.15235zm0-0.25-1.3828-2.4648-0.0977-0.0508c-0.19531 0.10156-0.19531 0.10156-0.0977 0.30469l-0.14844 0.10156v0.25c0.0508-0.15234 0.29297-0.20313 0.34375-0.30078l1.3828 2.4102zm-4e-3 -1.8633v0.45313l-0.10157-0.19922c-0.0937-0.20313-0.0508-0.40625 0.10157-0.50391zm4e-3 2.4141v-0.55079l0.25 0.44922c0.0469 0.15235-0.19922 0.20313-0.25 0.10157m-4e-3 -2.3125v0.35156l0.83984 1.3555v-0.25391l-0.83984-1.3516zm0.83593 0.55078-0.54296-0.95313c-0.0469 0.10156-0.29297 0.14844-0.29297 0.30078v-0.25l0.14453-0.10156c-0.0977-0.20312-0.0977-0.20312 0.10156-0.30469l0.0937 0.0508 0.49609 0.90625zm0.83985 1.457-0.83985-1.457v-0.35157l1.1367 2.0078c0.0469 0.15234-0.24609 0.20312-0.29687 0.10156l-0.0469-0.14844c-0.29687 0.10156-0.58984-0.0508-0.6914-0.30078l-0.0977-0.15234v-0.25391l0.24609 0.35547c0.14844 0.35156 0.34375 0.14844 0.58985 0.19922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.66 130.16h0.29688v0.20312h-0.29688zm0-0.35157h0.29688v0.19922l-0.29688 4e-3zm-4e-3 -0.35156h0.29687v0.19922h-0.29687zm0-0.35156h0.29687v0.19922h-0.29687zm0-0.35156h0.29687v0.19922h-0.29687zm0-0.35547h0.29687v0.15234h-0.29687zm-1.0312 1.7656h0.29687l-0.0508 0.20313h-0.24609zm0.0508-0.35547h0.24609v0.20313h-0.29687zm-4e-3 -0.34765h0.29688l-0.0508 0.19922h-0.2461zm0.0508-0.35547h0.2461v0.20312h-0.29688zm-4e-3 -0.34766h0.30078v0.19922h-0.30078zm0.0508-0.35547h0.29687l-0.0508 0.19922h-0.24609zm-1.2266 1.7656 0.29687 0.0469-0.0508 0.15235h-0.24609zm0.0508-0.35547h0.29297l-0.0469 0.20313h-0.24609zm0.0937-0.35156h0.24609v0.19922h-0.29297zm0.0508-0.35156h0.24609v0.19921l-0.29687 4e-3zm0.0469-0.35157h0.29688l-0.0508 0.19922-0.29297 4e-3zm0.0508-0.35156 0.29297-4e-3 -0.0469 0.20313h-0.29688zm-1.3242 1.8125h0.24218l-0.0469 0.19922-0.2461-0.0469zm0.0469-0.40234 0.29688 0.0508-0.0508 0.20312-0.29296-0.0508zm0.0977-0.35157 0.29297 0.0469-0.0469 0.20312-0.29687-0.0508zm0.0976-0.35156 0.2461 0.0469v0.15234h-0.29688zm0.10157-0.35156 0.24218 0.0469-0.0508 0.15235h-0.24609zm0.0469-0.35547h0.29297l-0.0469 0.20313h-0.29296zm4.0352 1.75-0.2461 4e-3v0.19922h0.29688zm0-0.35156h-0.29688l0.0508 0.20312h0.2461zm-0.0469-0.35156h-0.25v0.20312h0.29688zm0-0.35157h-0.29687v0.20313h0.29687zm-0.0547-0.35156h-0.29687l0.0508 0.20313 0.24609-4e-3zm0-0.35547-0.29687 4e-3v0.19922h0.29687zm1.1836 1.7617-0.24219 0.0508v0.15235l0.28906-4e-3zm-0.0469-0.35156h-0.29687l0.0469 0.20312 0.29688-4e-3zm-0.0547-0.35156h-0.29297l0.0469 0.19921h0.29688zm-0.0508-0.35157h-0.29296l0.0508 0.19922h0.24218zm-0.0469-0.35156h-0.29688l0.0508 0.19922h0.24609zm-0.0977-0.35547h-0.25v0.20313h0.30078zm1.3789 1.8086h-0.29688l0.0508 0.20312 0.29687-0.0508zm-0.0977-0.40235-0.29687 0.0508 0.0508 0.20313 0.29687-0.0508zm-0.10156-0.35156-0.24219 0.0547 0.0469 0.19531 0.25-0.0508zm-0.0508-0.35156-0.29297 0.0508 0.0508 0.15234h0.29297zm-0.0977-0.35157-0.29687 0.0508 0.0547 0.15234h0.29296zm-0.0976-0.35546h-0.2461v0.20312h0.29688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.03 127.95c-0.1328 0-0.23828-0.10938-0.23828-0.24219s0.10547-0.24219 0.23828-0.24219c0.13281 0 0.24219 0.10938 0.24219 0.24219s-0.10938 0.24219-0.24219 0.24219m0-0.64844c-0.22266 0-0.40234 0.1836-0.40234 0.40625 0 0.21875 0.17968 0.40235 0.40234 0.40235 0.22266 0 0.40234-0.1836 0.40234-0.40235 0-0.22265-0.17968-0.40625-0.40234-0.40625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.254 134.13-4.2305 0.0117-4.2695 0.0117c-0.0976 0-0.19531-0.10156-0.19531-0.25l-0.0156-6.3594c0-0.14844 0.0976-0.29688 0.19531-0.29688l4.2734-0.0117 4.2226-8e-3c0.14844 0 0.2461 0.14844 0.2461 0.29688l0.0117 6.3594c0 0.14844-0.0937 0.2461-0.23828 0.2461m0.51953-6.6055c-4e-3 -0.34766-0.24609-0.69531-0.53906-0.69531l-4.2226 0.0117-4.2734 8e-3c-0.29297 4e-3 -0.53516 0.35156-0.53516 0.69531l0.0156 6.3594c0 0.34766 0.24218 0.69532 0.53515 0.69532l4.2734-0.0117 4.2266-8e-3c0.28907 0 0.53125-0.34766 0.53125-0.69922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.297 133.59-3.3008 8e-3 -0.0156-5.7617 3.3047-8e-3 3.3516-8e-3 0.0117 5.7617zm3.5312-6.0664-7.0898 0.016 0.0156 6.3594 3.543-8e-3 3.543-0.0117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.484 129.57c-0.875-0.54688-1.6523-0.44531-2.2344-0.19531-0.29297 0.10156-0.53907 0.25-0.67969 0.39843-0.19531 0.10157-0.29297 0.19922-0.29297 0.19922l-0.0469-0.0508v-0.34375c0.0469-0.0547 0.0937-0.10156 0.1914-0.15234 0.19531-0.14844 0.4375-0.29688 0.77735-0.44531 0.6289-0.25391 1.5039-0.35157 2.4297 0.1914 0.82422 0.49219 1.457 0.44141 1.8438 0.24219 0.24219-0.0977 0.39063-0.24609 0.53516-0.34766 0.0977-0.10156 0.14453-0.14843 0.14453-0.14843l0.0977-0.10157 0.0469 0.0508 4e-3 0.34766v0.0508c-0.29297 0.29688-1.3086 1.2422-2.8164 0.30469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.484 130.77c-0.875-0.54688-1.6523-0.44532-2.2305-0.19532-0.29297 0.14844-0.53906 0.30078-0.68359 0.39844-0.19531 0.14844-0.28906 0.25-0.28906 0.25l-0.0508-0.0508v-0.39844c0.0508-0.0508 0.0976-0.0976 0.19531-0.14453 0.19531-0.10156 0.43359-0.30469 0.77734-0.40234 0.62891-0.30078 1.5039-0.39844 2.4258 0.1914 0.82813 0.4961 1.4609 0.39453 1.8477 0.19922 0.24219-0.10156 0.39062-0.25 0.53125-0.35156 0.0977-0.10156 0.14844-0.14844 0.14844-0.14844l0.0937-0.10156 0.0508 0.0508v0.34766l4e-3 0.0508c-0.29296 0.29687-1.3086 1.2422-2.8203 0.30469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.488 132c-0.875-0.54297-1.6524-0.4375-2.2344-0.19141-0.28906 0.0977-0.53515 0.25-0.67968 0.39844-0.19532 0.10156-0.28907 0.19922-0.28907 0.19922l-0.0508-0.0508v-0.39454c0.0508 0 0.0977-0.0508 0.19141-0.10156 0.19531-0.14844 0.4375-0.29687 0.78125-0.44922 0.625-0.25 1.5-0.39843 2.4258 0.19532 0.82422 0.49218 1.457 0.39453 1.8438 0.19531 0.24219-0.10156 0.39062-0.20313 0.53516-0.30078 0.0976-0.10157 0.14843-0.19922 0.14843-0.19922l0.0937-0.0977 0.0508 0.0469v0.44922c-0.28906 0.25-1.3086 1.1953-2.8164 0.30078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.414 134.43-9.0508-7.0781 0.21094-0.26953 9.0508 7.0781z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.57 134.25-0.21094-0.26562 8.9297-6.9805 0.20703 0.26953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.723 129.2c-0.13281 0-0.24218-0.10937-0.24218-0.23828 0-0.13281 0.10937-0.24219 0.24218-0.24219 0.13282 0 0.24219 0.10938 0.24219 0.24219 0 0.12891-0.10937 0.23828-0.24219 0.23828m0-0.64453c-0.22265 0-0.40234 0.1836-0.40234 0.40625 0 0.21875 0.17969 0.40235 0.40234 0.40235 0.22266 0 0.40235-0.1836 0.40235-0.40235 0-0.22265-0.17969-0.40625-0.40235-0.40625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.723 130.95c-0.13281 0-0.24218-0.10938-0.24218-0.23829 0-0.13281 0.10937-0.24218 0.24218-0.24218 0.13282 0 0.24219 0.10937 0.24219 0.24218 0 0.12891-0.10937 0.23829-0.24219 0.23829m0-0.64454c-0.22265 0-0.40234 0.1836-0.40234 0.40625 0 0.21875 0.17969 0.40235 0.40234 0.40235 0.22266 0 0.40235-0.1836 0.40235-0.40235 0-0.22265-0.17969-0.40625-0.40235-0.40625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.723 132.71c-0.13281 0-0.24218-0.10547-0.24218-0.23828 0-0.13282 0.10937-0.24219 0.24218-0.24219 0.13282 0 0.24219 0.10937 0.24219 0.24219 0 0.13281-0.10937 0.23828-0.24219 0.23828m0-0.64063c-0.22265 0-0.40234 0.17969-0.40234 0.40235 0 0.21875 0.17969 0.40234 0.40234 0.40234 0.22266 0 0.40235-0.18359 0.40235-0.40234 0-0.22266-0.17969-0.40235-0.40235-0.40235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.27 134.43-9.0508-7.0781 0.21094-0.26953 9.0508 7.0781z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.414 134.43-9.0508-7.0781 0.21094-0.26953 9.0508 7.0781z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.332 134.34-0.21094-0.26953 8.9258-6.9805 0.21094 0.26953z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m56.435 128.92 1.5547 2.3711 3.1758-2.9726-0.40235-0.42969-2.6641 2.4922-1.168-1.7812",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-665.77 -397.77)",
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("use", {
    x: 674.44098,
    y: 473.04999,
    xlinkHref: "#glyph-5-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.14807,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 677.95197,
    y: 473.04999,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.01447,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.71832,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.20734,
    y: 473.04999,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.16443,
    y: 473.04999,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.29724,
    y: 473.04999,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 688.59485,
    y: 473.04999,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.29919,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.78815,
    y: 473.04999,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.51202,
    y: 473.04999,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 694.29993,
    y: 473.04999,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.92804,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.73389,
    y: 473.04999,
    xlinkHref: "#glyph-5-61"
  }), /*#__PURE__*/React.createElement("use", {
    x: 699.70422,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.5589,
    y: 473.04999,
    xlinkHref: "#glyph-5-62"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.09479,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.5838,
    y: 473.04999,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 704.34949,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.03656,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 706.88812,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.42407,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.91309,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.55176,
    y: 473.04999,
    xlinkHref: "#glyph-5-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.1076,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.64471,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.13373,
    y: 473.04999,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 714.08105,
    y: 473.04999,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 714.69702,
    y: 473.04999,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.44196,
    y: 473.04999,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.38336,
    y: 473.04999,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 719.77869,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 721.48962,
    y: 473.04999,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.41656,
    y: 473.04999,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 724.02985,
    y: 473.04999,
    xlinkHref: "#glyph-5-64"
  }), /*#__PURE__*/React.createElement("use", {
    x: 726.15875,
    y: 473.04999,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 728.10681,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 728.6427,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 729.13171,
    y: 473.04999,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.87665,
    y: 473.04999,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 732.74976,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 733.28564,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 733.77466,
    y: 473.04999,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.38684,
    y: 473.04999,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 736.34698,
    y: 473.04999,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.29504,
    y: 473.04999,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.888,
    y: 473.04999,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 740.49469,
    y: 473.04999,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.32861,
    y: 473.04999,
    xlinkHref: "#glyph-5-56"
  }), /*#__PURE__*/React.createElement("use", {
    x: 744.14502,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 744.68097,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.16998,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 746.97351,
    y: 473.04999,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.89343,
    y: 473.04999,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 750.4989,
    y: 473.04999,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 752.22864,
    y: 473.04999,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 752.84503,
    y: 473.04999,
    xlinkHref: "#glyph-5-56"
  }), /*#__PURE__*/React.createElement("use", {
    x: 754.53522,
    y: 473.04999,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 756.56525,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 757.10114,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 757.59015,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.29413,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.78308,
    y: 473.04999,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.72614,
    y: 473.04999,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 763.85425,
    y: 473.04999,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 765.76831,
    y: 473.04999,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 767.72418,
    y: 473.04999,
    xlinkHref: "#glyph-5-61"
  }), /*#__PURE__*/React.createElement("use", {
    x: 769.69489,
    y: 473.04999,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 771.39917,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 771.88818,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 772.37714,
    y: 473.04999,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 774.28857,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 774.88507,
    y: 473.04999,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 775.48309,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 776.09521,
    y: 473.04999,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 777.3999,
    y: 473.04999,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 777.93579,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.4248,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.91382,
    y: 473.04999,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 779.40283,
    y: 473.04999,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 780.87256,
    y: 473.04999,
    xlinkHref: "#glyph-5-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 782.13232,
    y: 473.04999,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.47919,
    y: 473.04999,
    xlinkHref: "#glyph-5-72"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.44098,
    y: 477.34845,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 675.8902,
    y: 477.34845,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 677.65271,
    y: 477.34845,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 679.43591,
    y: 477.34845,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.38007,
    y: 477.34845,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.99371,
    y: 477.34845,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.12256,
    y: 477.34845,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 685.9917,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.68475,
    y: 477.34845,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 688.03741,
    y: 477.34845,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.14948,
    y: 477.34845,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.26471,
    y: 477.34845,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.87018,
    y: 477.34845,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 694.61237,
    y: 477.34845,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 696.20105,
    y: 477.34845,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 696.81427,
    y: 477.34845,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.77911,
    y: 477.34845,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 700.48303,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.17603,
    y: 477.34845,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.6076,
    y: 477.34845,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.96698,
    y: 477.34845,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.83728,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 706.53027,
    y: 477.34845,
    xlinkHref: "#glyph-5-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.2373,
    y: 477.34845,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.04077,
    y: 477.34845,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.10327,
    y: 477.34845,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 713.80756,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 714.50055,
    y: 477.34845,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.45758,
    y: 477.34845,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.59033,
    y: 477.34845,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.88837,
    y: 477.34845,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.59229,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.28528,
    y: 477.34845,
    xlinkHref: "#glyph-5-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.06848,
    y: 477.34845,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 727.13098,
    y: 477.34845,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 728.8927,
    y: 477.34845,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.66028,
    y: 477.34845,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 731.27856,
    y: 477.34845,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 732.64966,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 733.34271,
    y: 477.34845,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.78015,
    y: 477.34845,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 735.3161,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 736.00909,
    y: 477.34845,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 737.48132,
    y: 477.34845,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.01721,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.71021,
    y: 477.34845,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 739.89844,
    y: 477.34845,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.50275,
    y: 477.34845,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 743.39532,
    y: 477.34845,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.09845,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.79144,
    y: 477.34845,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 746.32855,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 747.02155,
    y: 477.34845,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.9668,
    y: 477.34845,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 750.92969,
    y: 477.34845,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 752.50507,
    y: 477.34845,
    xlinkHref: "#glyph-5-75"
  }), /*#__PURE__*/React.createElement("use", {
    x: 753.72382,
    y: 477.34845,
    xlinkHref: "#glyph-5-76"
  }), /*#__PURE__*/React.createElement("use", {
    x: 754.19922,
    y: 477.34845,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 755.50195,
    y: 477.34845,
    xlinkHref: "#glyph-5-69"
  }), /*#__PURE__*/React.createElement("use", {
    x: 756.94727,
    y: 477.34845,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 757.28119,
    y: 477.34845,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 758.59381,
    y: 477.34845,
    xlinkHref: "#glyph-5-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 760.0899,
    y: 477.34845,
    xlinkHref: "#glyph-5-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.50006,
    y: 477.34845,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.83289,
    y: 477.34845,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 763.16608,
    y: 477.34845,
    xlinkHref: "#glyph-5-77"
  }), /*#__PURE__*/React.createElement("use", {
    x: 764.63171,
    y: 477.34845,
    xlinkHref: "#glyph-5-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 766.07977,
    y: 477.34845,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 766.69733,
    y: 477.34845,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 768.19537,
    y: 477.34845,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 769.69342,
    y: 477.34845,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 771.05786,
    y: 477.34845,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 772.43872,
    y: 477.34845,
    xlinkHref: "#glyph-5-66"
  }), /*#__PURE__*/React.createElement("use", {
    x: 773.29669,
    y: 477.34845,
    xlinkHref: "#glyph-5-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 774.76251,
    y: 477.34845,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 776.13477,
    y: 477.34845,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 776.82776,
    y: 477.34845,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 779.12152,
    y: 477.34845,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.24847,
    y: 477.34845,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.14105,
    y: 477.34845,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.44098,
    y: 481.64728,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.39801,
    y: 481.64728,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.53082,
    y: 481.64728,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.82849,
    y: 481.64728,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.53247,
    y: 481.64728,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.57343,
    y: 481.64728,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 685.33978,
    y: 481.64728,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.02649,
    y: 481.64728,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.87805,
    y: 481.64728,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 688.46674,
    y: 481.64728,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.23352,
    y: 481.64728,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.77051,
    y: 481.64728,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 691.81165,
    y: 481.64728,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.57916,
    y: 481.64728,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 694.19128,
    y: 481.64728,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 696.0603,
    y: 481.64728,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.10144,
    y: 481.64728,
    xlinkHref: "#glyph-5-78"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.60223,
    y: 481.64728,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 700.10028,
    y: 481.64728,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.51941,
    y: 481.64728,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.12097,
    y: 481.64728,
    xlinkHref: "#glyph-5-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.56122,
    y: 481.64728,
    xlinkHref: "#glyph-5-78"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.03387,
    y: 481.64728,
    xlinkHref: "#glyph-5-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 706.47253,
    y: 481.64728,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 706.9823,
    y: 481.64728,
    xlinkHref: "#glyph-5-79"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.39246,
    y: 481.64728,
    xlinkHref: "#glyph-5-80"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.84052,
    y: 481.64728,
    xlinkHref: "#glyph-5-78"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.21149,
    y: 481.64728,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.25262,
    y: 481.64728,
    xlinkHref: "#glyph-5-81"
  }), /*#__PURE__*/React.createElement("use", {
    x: 714.50067,
    y: 481.64728,
    xlinkHref: "#glyph-5-82"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.68939,
    y: 481.64728,
    xlinkHref: "#glyph-5-83"
  }), /*#__PURE__*/React.createElement("use", {
    x: 719.02924,
    y: 481.64728,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 719.62219,
    y: 481.64728,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 721.28546,
    y: 481.64728,
    xlinkHref: "#glyph-5-56"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.99719,
    y: 481.64728,
    xlinkHref: "#glyph-5-84"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.49841,
    y: 481.64728,
    xlinkHref: "#glyph-5-85"
  }), /*#__PURE__*/React.createElement("use", {
    x: 727.76599,
    y: 481.64728,
    xlinkHref: "#glyph-5-86"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.44647,
    y: 481.64728,
    xlinkHref: "#glyph-5-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 733.14948,
    y: 481.64728,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.19141,
    y: 481.64728,
    xlinkHref: "#glyph-5-87"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.90546,
    y: 481.64728,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 736.2699,
    y: 481.64728,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 737.57733,
    y: 481.64728,
    xlinkHref: "#glyph-5-80"
  }), /*#__PURE__*/React.createElement("use", {
    x: 739.01215,
    y: 481.64728,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 740.56488,
    y: 481.64728,
    xlinkHref: "#glyph-5-66"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.39886,
    y: 481.64728,
    xlinkHref: "#glyph-5-78"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.76801,
    y: 481.64728,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 744.08124,
    y: 481.64728,
    xlinkHref: "#glyph-5-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.60669,
    y: 481.64728,
    xlinkHref: "#glyph-5-66"
  }), /*#__PURE__*/React.createElement("use", {
    x: 746.49023,
    y: 481.64728,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 747.88086,
    y: 481.64728,
    xlinkHref: "#glyph-5-79"
  }), /*#__PURE__*/React.createElement("use", {
    x: 749.25189,
    y: 481.64728,
    xlinkHref: "#glyph-5-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 750.66681,
    y: 481.64728,
    xlinkHref: "#glyph-5-88"
  }), /*#__PURE__*/React.createElement("use", {
    x: 751.36884,
    y: 481.64728,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 752.40979,
    y: 481.64728,
    xlinkHref: "#glyph-5-89"
  }), /*#__PURE__*/React.createElement("use", {
    x: 753.91956,
    y: 481.64728,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 755.87384,
    y: 481.64728,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 757.74286,
    y: 481.64728,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 758.78479,
    y: 481.64728,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 760.08624,
    y: 481.64728,
    xlinkHref: "#glyph-5-69"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.56006,
    y: 481.64728,
    xlinkHref: "#glyph-5-77"
  }), /*#__PURE__*/React.createElement("use", {
    x: 763.06085,
    y: 481.64728,
    xlinkHref: "#glyph-5-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 764.55579,
    y: 481.64728,
    xlinkHref: "#glyph-5-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 766.01672,
    y: 481.64728,
    xlinkHref: "#glyph-5-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 767.38776,
    y: 481.64728,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 768.42963,
    y: 481.64728,
    xlinkHref: "#glyph-5-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 770.13666,
    y: 481.64728,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 771.94019,
    y: 481.64728,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 774.00269,
    y: 481.64728,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 775.70667,
    y: 481.64728,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 776.74756,
    y: 481.64728,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.70459,
    y: 481.64728,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 780.8374,
    y: 481.64728,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.13507,
    y: 481.64728,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.44098,
    y: 485.95001,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.36481,
    y: 485.95001,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.16949,
    y: 485.95001,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.1402,
    y: 485.95001,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.94415,
    y: 485.95001,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.83673,
    y: 485.95001,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 685.54071,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.10309,
    y: 485.95001,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.71521,
    y: 485.95001,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 689.67224,
    y: 485.95001,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 691.58435,
    y: 485.95001,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.12134,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.68396,
    y: 485.95001,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.01208,
    y: 485.95001,
    xlinkHref: "#glyph-5-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 696.47766,
    y: 485.95001,
    xlinkHref: "#glyph-5-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.9433,
    y: 485.95001,
    xlinkHref: "#glyph-5-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 699.31433,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 700.87805,
    y: 485.95001,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.17102,
    y: 485.95001,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.30072,
    y: 485.95001,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.24097,
    y: 485.95001,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.84564,
    y: 485.95001,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.80072,
    y: 485.95001,
    xlinkHref: "#glyph-5-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.6402,
    y: 485.95001,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 714.45111,
    y: 485.95001,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.91168,
    y: 485.95001,
    xlinkHref: "#glyph-5-62"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.44867,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.01086,
    y: 485.95001,
    xlinkHref: "#glyph-5-90"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.1308,
    y: 485.95001,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.08783,
    y: 485.95001,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.84052,
    y: 485.95001,
    xlinkHref: "#glyph-5-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.62567,
    y: 485.95001,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 727.3374,
    y: 485.95001,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 729.24286,
    y: 485.95001,
    xlinkHref: "#glyph-5-62"
  }), /*#__PURE__*/React.createElement("use", {
    x: 729.77991,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 731.34247,
    y: 485.95001,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 733.28076,
    y: 485.95001,
    xlinkHref: "#glyph-5-69"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.75183,
    y: 485.95001,
    xlinkHref: "#glyph-5-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 736.45587,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.01825,
    y: 485.95001,
    xlinkHref: "#glyph-5-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 739.45496,
    y: 485.95001,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.48309,
    y: 485.95001,
    xlinkHref: "#glyph-5-79"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.62842,
    y: 485.95001,
    xlinkHref: "#glyph-5-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 743.16541,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 744.72797,
    y: 485.95001,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 747.03461,
    y: 485.95001,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.85376,
    y: 485.95001,
    xlinkHref: "#glyph-5-66"
  }), /*#__PURE__*/React.createElement("use", {
    x: 749.70728,
    y: 485.95001,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 752.01392,
    y: 485.95001,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 753.8186,
    y: 485.95001,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 755.73071,
    y: 485.95001,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 757.85181,
    y: 485.95001,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.73853,
    y: 485.95001,
    xlinkHref: "#glyph-5-76"
  }), /*#__PURE__*/React.createElement("use", {
    x: 760.27551,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.83771,
    y: 485.95001,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 763.6084,
    y: 485.95001,
    xlinkHref: "#glyph-5-91"
  }), /*#__PURE__*/React.createElement("use", {
    x: 764.18066,
    y: 485.95001,
    xlinkHref: "#glyph-5-92"
  }), /*#__PURE__*/React.createElement("use", {
    x: 765.55164,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 767.11426,
    y: 485.95001,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 769.03302,
    y: 485.95001,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 770.7298,
    y: 485.95001,
    xlinkHref: "#glyph-5-93"
  }), /*#__PURE__*/React.createElement("use", {
    x: 773.26477,
    y: 485.95001,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 774.82703,
    y: 485.95001,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 777.13446,
    y: 485.95001,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.93835,
    y: 485.95001,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 780.85162,
    y: 485.95001,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 782.97272,
    y: 485.95001,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.44098,
    y: 490.24844,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 675.05231,
    y: 490.24844,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.54065,
    y: 490.24844,
    xlinkHref: "#glyph-5-76"
  }), /*#__PURE__*/React.createElement("use", {
    x: 677.01764,
    y: 490.24844,
    xlinkHref: "#glyph-5-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.36328,
    y: 490.24844,
    xlinkHref: "#glyph-5-72"
  }), /*#__PURE__*/React.createElement("use", {
    x: 679.86646,
    y: 490.24844,
    xlinkHref: "#glyph-5-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.25513,
    y: 490.24844,
    xlinkHref: "#glyph-5-80"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.72388,
    y: 490.24844,
    xlinkHref: "#glyph-5-80"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.15747,
    y: 490.24844,
    xlinkHref: "#glyph-5-72"
  }), /*#__PURE__*/React.createElement("use", {
    x: 685.59619,
    y: 490.24844,
    xlinkHref: "#glyph-5-80"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.04462,
    y: 490.24844,
    xlinkHref: "#glyph-5-63"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-665.77 -397.77)",
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("use", {
    x: 674.44098,
    y: 498.54599,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.41638,
    y: 498.54599,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.1441,
    y: 498.54599,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.10309,
    y: 498.54599,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.07452,
    y: 498.54599,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.1261,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.72913,
    y: 498.54599,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.49097,
    y: 498.54599,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 688.37573,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 688.9787,
    y: 498.54599,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.76752,
    y: 498.54599,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.91089,
    y: 498.54599,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 694.84589,
    y: 498.54599,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 696.46674,
    y: 498.54599,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.42102,
    y: 498.54599,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 700.55389,
    y: 498.54599,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.38,
    y: 498.54599,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.76672,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 704.36975,
    y: 498.54599,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 704.92139,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.52441,
    y: 498.54599,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 706.98822,
    y: 498.54599,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.81555,
    y: 498.54599,
    xlinkHref: "#glyph-5-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.61438,
    y: 498.54599,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.56744,
    y: 498.54599,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 713.19446,
    y: 498.54599,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.13312,
    y: 498.54599,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.95221,
    y: 498.54599,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.9198,
    y: 498.54599,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.97137,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 721.57434,
    y: 498.54599,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.29327,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.89624,
    y: 498.54599,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 726.11395,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 726.71698,
    y: 498.54599,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 728.50574,
    y: 498.54599,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.64838,
    y: 498.54599,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 732.58337,
    y: 498.54599,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.20422,
    y: 498.54599,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 736.15851,
    y: 498.54599,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.29132,
    y: 498.54599,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 740.11749,
    y: 498.54599,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.50415,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.10718,
    y: 498.54599,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.65887,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 743.26184,
    y: 498.54599,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.58386,
    y: 498.54599,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 747.40338,
    y: 498.54599,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 749.37994,
    y: 498.54599,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 751.09906,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 751.70203,
    y: 498.54599,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 752.3299,
    y: 498.54599,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 754.21466,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 754.81763,
    y: 498.54599,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 756.60681,
    y: 498.54599,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 758.75018,
    y: 498.54599,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 760.68378,
    y: 498.54599,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 762.30487,
    y: 498.54599,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 764.25995,
    y: 498.54599,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 766.39276,
    y: 498.54599,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 768.21814,
    y: 498.54599,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 769.60486,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 770.20789,
    y: 498.54599,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 770.75995,
    y: 498.54599,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 771.36292,
    y: 498.54599,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 772.82715,
    y: 498.54599,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 774.65399,
    y: 498.54599,
    xlinkHref: "#glyph-5-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 776.45282,
    y: 498.54599,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.40588,
    y: 498.54599,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 779.03369,
    y: 498.54599,
    xlinkHref: "#glyph-5-90"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.16846,
    y: 498.54599,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.13989,
    y: 498.54599,
    xlinkHref: "#glyph-5-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.44098,
    y: 502.54443,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.16949,
    y: 502.54443,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.05353,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.34766,
    y: 502.54443,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.13672,
    y: 502.54443,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.2793,
    y: 502.54443,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.21368,
    y: 502.54443,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.83405,
    y: 502.54443,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 689.78912,
    y: 502.54443,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 691.92194,
    y: 502.54443,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.74731,
    y: 502.54443,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.1333,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.42743,
    y: 502.54443,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.97943,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 700.27234,
    y: 502.54443,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.41687,
    y: 502.54443,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 704.17664,
    y: 502.54443,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.64148,
    y: 502.54443,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.46844,
    y: 502.54443,
    xlinkHref: "#glyph-5-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.26648,
    y: 502.54443,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.21967,
    y: 502.54443,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.84778,
    y: 502.54443,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 713.80756,
    y: 502.54443,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.56927,
    y: 502.54443,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 717.32904,
    y: 502.54443,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 719.29779,
    y: 502.54443,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 721.18182,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.47595,
    y: 502.54443,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 724.1037,
    y: 502.54443,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.98767,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 728.28064,
    y: 502.54443,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.0697,
    y: 502.54443,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 732.21307,
    y: 502.54443,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.14667,
    y: 502.54443,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 735.76776,
    y: 502.54443,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 737.72211,
    y: 502.54443,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 739.85492,
    y: 502.54443,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.68109,
    y: 502.54443,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 743.06708,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.36078,
    y: 502.54443,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.91278,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.20648,
    y: 502.54443,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 749.67133,
    y: 502.54443,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 751.2522,
    y: 502.54443,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 752.95142,
    y: 502.54443,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 754.49561,
    y: 502.54443,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 756.54761,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 758.84131,
    y: 502.54443,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.46826,
    y: 502.54443,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.35223,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 763.64636,
    y: 502.54443,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 765.43549,
    y: 502.54443,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 767.57806,
    y: 502.54443,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 769.51282,
    y: 502.54443,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 771.05658,
    y: 502.54443,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 773.18353,
    y: 502.54443,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 775.31635,
    y: 502.54443,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 777.14288,
    y: 502.54443,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.59021,
    y: 502.54443,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 779.9574,
    y: 502.54443,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 782.0094,
    y: 502.54443,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 784.3028,
    y: 502.54443,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.44098,
    y: 506.54327,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.41638,
    y: 506.54327,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.17694,
    y: 506.54327,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.09808,
    y: 506.54327,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.24139,
    y: 506.54327,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.9809,
    y: 506.54327,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 685.73871,
    y: 506.54327,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.3598,
    y: 506.54327,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 689.12622,
    y: 506.54327,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.57391,
    y: 506.54327,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 691.77588,
    y: 506.54327,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.32684,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 694.37549,
    y: 506.54327,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.00323,
    y: 506.54327,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 696.88721,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.93604,
    y: 506.54327,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 699.7251,
    y: 506.54327,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.86768,
    y: 506.54327,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.80206,
    y: 506.54327,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.42242,
    y: 506.54327,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.37714,
    y: 506.54327,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.50995,
    y: 506.54327,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.33533,
    y: 506.54327,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.72131,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 713.77008,
    y: 506.54327,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 714.32208,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.37085,
    y: 506.54327,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 717.29547,
    y: 506.54327,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.8775,
    y: 506.54327,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.28772,
    y: 506.54327,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.15295,
    y: 506.54327,
    xlinkHref: "#glyph-5-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.72125,
    y: 506.54327,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.53961,
    y: 506.54327,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 727.36621,
    y: 506.54327,
    xlinkHref: "#glyph-5-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 729.17755,
    y: 506.54327,
    xlinkHref: "#glyph-5-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 731.06152,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 732.11035,
    y: 506.54327,
    xlinkHref: "#glyph-5-94"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.08301,
    y: 506.54327,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 736.22949,
    y: 506.54327,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.03027,
    y: 506.54327,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 739.57446,
    y: 506.54327,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.71588,
    y: 506.54327,
    xlinkHref: "#glyph-5-95"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.94043,
    y: 506.54327,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 744.86157,
    y: 506.54327,
    xlinkHref: "#glyph-5-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 746.65454,
    y: 506.54327,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 747.29205,
    y: 506.54327,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 749.01105,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 750.05963,
    y: 506.54327,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 750.61163,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 751.65997,
    y: 506.54327,
    xlinkHref: "#glyph-5-96"
  }), /*#__PURE__*/React.createElement("use", {
    x: 753.6311,
    y: 506.54327,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 755.59985,
    y: 506.54327,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 757.40454,
    y: 506.54327,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.00928,
    y: 506.54327,
    xlinkHref: "#glyph-5-97"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.64093,
    y: 506.54327,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.85791,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 762.90656,
    y: 506.54327,
    xlinkHref: "#glyph-5-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 764.71826,
    y: 506.54327,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 766.47882,
    y: 506.54327,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 768.43164,
    y: 506.54327,
    xlinkHref: "#glyph-5-97"
  }), /*#__PURE__*/React.createElement("use", {
    x: 768.98364,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 770.03247,
    y: 506.54327,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 771.82153,
    y: 506.54327,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 773.96484,
    y: 506.54327,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 775.8985,
    y: 506.54327,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 777.51959,
    y: 506.54327,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 779.28912,
    y: 506.54327,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.09106,
    y: 506.54327,
    xlinkHref: "#glyph-5-97"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.70319,
    y: 506.54327,
    xlinkHref: "#glyph-5-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.25421,
    y: 506.54327,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 784.30206,
    y: 506.54327,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.44098,
    y: 510.54172,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.02502,
    y: 510.54172,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 677.99493,
    y: 510.54172,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 679.76056,
    y: 510.54172,
    xlinkHref: "#glyph-5-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.06134,
    y: 510.54172,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.81799,
    y: 510.54172,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 685.4223,
    y: 510.54172,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.05511,
    y: 510.54172,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.50244,
    y: 510.54172,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 688.94501,
    y: 510.54172,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.74854,
    y: 510.54172,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.2995,
    y: 510.54172,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.71771,
    y: 510.54172,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.26971,
    y: 510.54172,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.68762,
    y: 510.54172,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.47668,
    y: 510.54172,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.61926,
    y: 510.54172,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 699.55402,
    y: 510.54172,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.17517,
    y: 510.54172,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.12946,
    y: 510.54172,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.26227,
    y: 510.54172,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.08844,
    y: 510.54172,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.47443,
    y: 510.54172,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.89233,
    y: 510.54172,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.44434,
    y: 510.54172,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.86224,
    y: 510.54172,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.8252,
    y: 510.54172,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.45996,
    y: 510.54172,
    xlinkHref: "#glyph-5-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 714.24316,
    y: 510.54172,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.1424,
    y: 510.54172,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 717.72327,
    y: 510.54172,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 719.27423,
    y: 510.54172,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 719.69202,
    y: 510.54172,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 721.65491,
    y: 510.54172,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.20691,
    y: 510.54172,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.62482,
    y: 510.54172,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 724.41388,
    y: 510.54172,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 726.55768,
    y: 510.54172,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 728.49127,
    y: 510.54172,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.11237,
    y: 510.54172,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 732.06744,
    y: 510.54172,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 734.20026,
    y: 510.54172,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 736.02527,
    y: 510.54172,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 737.41132,
    y: 510.54172,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 737.82922,
    y: 510.54172,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.38123,
    y: 510.54172,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.51794,
    y: 510.54172,
    xlinkHref: "#glyph-5-98"
  }), /*#__PURE__*/React.createElement("use", {
    x: 740.28357,
    y: 510.54172,
    xlinkHref: "#glyph-5-53"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.10254,
    y: 510.54172,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.10272,
    y: 510.54172,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.9397,
    y: 510.54172,
    xlinkHref: "#glyph-5-100"
  }), /*#__PURE__*/React.createElement("use", {
    x: 743.60168,
    y: 510.54172,
    xlinkHref: "#glyph-5-50"
  }), /*#__PURE__*/React.createElement("use", {
    x: 743.92767,
    y: 510.54172,
    xlinkHref: "#glyph-5-101"
  }), /*#__PURE__*/React.createElement("use", {
    x: 745.23572,
    y: 510.54172,
    xlinkHref: "#glyph-5-102"
  }), /*#__PURE__*/React.createElement("use", {
    x: 746.19958,
    y: 510.54172,
    xlinkHref: "#glyph-5-103"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.60858,
    y: 510.54172,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.60858,
    y: 510.54172,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 749.44556,
    y: 510.54172,
    xlinkHref: "#glyph-5-104"
  }), /*#__PURE__*/React.createElement("use", {
    x: 750.97888,
    y: 510.54172,
    xlinkHref: "#glyph-5-105"
  }), /*#__PURE__*/React.createElement("use", {
    x: 752.64691,
    y: 510.54172,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 752.64764,
    y: 510.54172,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 753.48462,
    y: 510.54172,
    xlinkHref: "#glyph-5-47"
  }), /*#__PURE__*/React.createElement("use", {
    x: 754.21362,
    y: 510.54172,
    xlinkHref: "#glyph-5-106"
  }), /*#__PURE__*/React.createElement("use", {
    x: 757.0827,
    y: 510.54172,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 758.05219,
    y: 510.54172,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.63818,
    y: 510.54172,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.3819,
    y: 510.54172,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.99048,
    y: 510.54172,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 763.53424,
    y: 510.54172,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 766.00372,
    y: 510.54172,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 767.76544,
    y: 510.54172,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 769.64899,
    y: 510.54172,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 770.06903,
    y: 510.54172,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 771.85803,
    y: 510.54172,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 774.00055,
    y: 510.54172,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 775.9353,
    y: 510.54172,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 777.55646,
    y: 510.54172,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 779.51074,
    y: 510.54172,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.64349,
    y: 510.54172,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.47009,
    y: 510.54172,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.44116,
    y: 514.54016,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.99316,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.37903,
    y: 514.54016,
    xlinkHref: "#glyph-5-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 677.96497,
    y: 514.54016,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 679.76965,
    y: 514.54016,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.32068,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.70721,
    y: 514.54016,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.42621,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 685.81189,
    y: 514.54016,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.60095,
    y: 514.54016,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 689.74432,
    y: 514.54016,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 691.67828,
    y: 514.54016,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.29944,
    y: 514.54016,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.25452,
    y: 514.54016,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.38617,
    y: 514.54016,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 699.21234,
    y: 514.54016,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 700.59833,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.98419,
    y: 514.54016,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.53619,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.92212,
    y: 514.54016,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.71118,
    y: 514.54016,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.85455,
    y: 514.54016,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.78851,
    y: 514.54016,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.40967,
    y: 514.54016,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 713.36475,
    y: 514.54016,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.4964,
    y: 514.54016,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 717.32257,
    y: 514.54016,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.76398,
    y: 514.54016,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.5257,
    y: 514.54016,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.40967,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.79523,
    y: 514.54016,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.52179,
    y: 514.54016,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 727.65186,
    y: 514.54016,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 728.27881,
    y: 514.54016,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.2652,
    y: 514.54016,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 731.98419,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 733.37024,
    y: 514.54016,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 733.92224,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 735.30811,
    y: 514.54016,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 737.09723,
    y: 514.54016,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 739.24097,
    y: 514.54016,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 741.17456,
    y: 514.54016,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.79565,
    y: 514.54016,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 744.75,
    y: 514.54016,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 746.88281,
    y: 514.54016,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.70935,
    y: 514.54016,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 750.15039,
    y: 514.54016,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 751.91211,
    y: 514.54016,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 753.79608,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 755.18164,
    y: 514.54016,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 756.9082,
    y: 514.54016,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.03711,
    y: 514.54016,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.66486,
    y: 514.54016,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 761.65039,
    y: 514.54016,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 763.36945,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 764.75513,
    y: 514.54016,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 765.30713,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 766.69299,
    y: 514.54016,
    xlinkHref: "#glyph-5-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 768.6051,
    y: 514.54016,
    xlinkHref: "#glyph-5-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 770.41644,
    y: 514.54016,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 772.34418,
    y: 514.54016,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 774.49457,
    y: 514.54016,
    xlinkHref: "#glyph-5-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 776.29352,
    y: 514.54016,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.05524,
    y: 514.54016,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 780.03064,
    y: 514.54016,
    xlinkHref: "#glyph-5-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.74963,
    y: 514.54016,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.13538,
    y: 514.54016,
    xlinkHref: "#glyph-5-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.44116,
    y: 518.539,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.23022,
    y: 518.539,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.3728,
    y: 518.539,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.30756,
    y: 518.539,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.92865,
    y: 518.539,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.883,
    y: 518.539,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.01581,
    y: 518.539,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.84235,
    y: 518.539,
    xlinkHref: "#glyph-5-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 689.276,
    y: 518.539,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 691.08459,
    y: 518.539,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.88263,
    y: 518.539,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 694.7666,
    y: 518.539,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.3186,
    y: 518.539,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.87061,
    y: 518.539,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 696.42261,
    y: 518.539,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.18225,
    y: 518.539,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 700.10999,
    y: 518.539,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.23694,
    y: 518.539,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.84906,
    y: 518.539,
    xlinkHref: "#glyph-5-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 704.54633,
    y: 518.539,
    xlinkHref: "#glyph-5-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 706.35687,
    y: 518.539,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.11743,
    y: 518.539,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.09399,
    y: 518.539,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.85455,
    y: 518.539,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 713.82727,
    y: 518.539,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.87921,
    y: 518.539,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.43121,
    y: 518.539,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.31525,
    y: 518.539,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.86725,
    y: 518.539,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.65619,
    y: 518.539,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.79871,
    y: 518.539,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 724.73352,
    y: 518.539,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 726.35461,
    y: 518.539,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 728.30896,
    y: 518.539,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.44177,
    y: 518.539,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 732.26794,
    y: 518.539,
    xlinkHref: "#glyph-5-73"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-665.77 -397.77)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 673.995,
    y: 547.33258,
    xlinkHref: "#glyph-15-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 677.71179,
    y: 547.33258,
    xlinkHref: "#glyph-15-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.21771,
    y: 547.33258,
    xlinkHref: "#glyph-15-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 685.99384,
    y: 547.33258,
    xlinkHref: "#glyph-15-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 689.71063,
    y: 547.33258,
    xlinkHref: "#glyph-15-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.41583,
    y: 547.33258,
    xlinkHref: "#glyph-15-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.66064,
    y: 547.33258,
    xlinkHref: "#glyph-15-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.31018,
    y: 547.33258,
    xlinkHref: "#glyph-15-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.93011,
    y: 547.33258,
    xlinkHref: "#glyph-15-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 713.84302,
    y: 547.33258,
    xlinkHref: "#glyph-15-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.73676,
    y: 547.33258,
    xlinkHref: "#glyph-15-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 719.35791,
    y: 547.33258,
    xlinkHref: "#glyph-15-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.11841,
    y: 547.33258,
    xlinkHref: "#glyph-15-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.73834,
    y: 547.33258,
    xlinkHref: "#glyph-15-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 729.65045,
    y: 547.33258,
    xlinkHref: "#glyph-15-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 731.54578,
    y: 547.33258,
    xlinkHref: "#glyph-15-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 736.46222,
    y: 547.33258,
    xlinkHref: "#glyph-15-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 738.38135,
    y: 547.33258,
    xlinkHref: "#glyph-15-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.43134,
    y: 547.33258,
    xlinkHref: "#glyph-15-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.52625,
    y: 529.13611,
    xlinkHref: "#glyph-16-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.10516,
    y: 529.13611,
    xlinkHref: "#glyph-16-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.89514,
    y: 529.13611,
    xlinkHref: "#glyph-16-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.95752,
    y: 529.13611,
    xlinkHref: "#glyph-16-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.48737,
    y: 529.13611,
    xlinkHref: "#glyph-16-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 688.10754,
    y: 529.13611,
    xlinkHref: "#glyph-16-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 691.38489,
    y: 529.13611,
    xlinkHref: "#glyph-16-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 694.84778,
    y: 529.13611,
    xlinkHref: "#glyph-16-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.65265,
    y: 529.13611,
    xlinkHref: "#glyph-16-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 700.28064,
    y: 529.13611,
    xlinkHref: "#glyph-16-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.03845,
    y: 529.13611,
    xlinkHref: "#glyph-16-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.8186,
    y: 529.13611,
    xlinkHref: "#glyph-16-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.6236,
    y: 529.13611,
    xlinkHref: "#glyph-16-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.02252,
    y: 529.13611,
    xlinkHref: "#glyph-16-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.81665,
    y: 529.13611,
    xlinkHref: "#glyph-16-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.64325,
    y: 529.13611,
    xlinkHref: "#glyph-16-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.4632,
    y: 529.13611,
    xlinkHref: "#glyph-16-16"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m98.105 9.7617c0.20312 0.0391 0.40625 0.0742 0.60546 0.11719 0.97266 0.20703 1.8164 0.65234 2.5195 1.3555l0.0312 0.0273c0.30859-0.30469 0.62109-0.60938 0.92968-0.91797l0.0274 0.0234c-0.0117 0.94922-0.0274 1.8906-0.043 2.8438-0.94141-0.0156-1.8867-0.0274-2.8359-0.0469 0.32813-0.3125 0.64844-0.62109 0.98438-0.94531-0.13672-0.11719-0.23829-0.21484-0.34766-0.29687-0.76563-0.59375-1.6406-0.83985-2.5938-0.82422-1.4922 0.0195-2.7812 0.59375-3.9531 1.4688-0.52343 0.39843-0.98437 0.85547-1.3984 1.3672l-0.0703 0.0781c-0.32031-0.33203-0.6289-0.66406-0.95703-1l0.10547-0.125c0.98047-1.125 2.1328-2.0273 3.5274-2.5859 0.67578-0.26953 1.3789-0.44531 2.1016-0.53125l0.23047-0.0273c0.3789 4e-3 0.75781 0.0117 1.1367 0.0195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.191 17.215c0.0195-0.125 0.043-0.25 0.0664-0.38671l0.082 0.0742c0.37109 0.39063 0.74609 0.77735 1.1172 1.1758l0.0742 0.17578c0.0273 0.16797 0.043 0.34375 0.0664 0.55078l-0.10547-0.10156c-0.40625-0.41797-0.80859-0.83985-1.2109-1.2539l-0.0937-0.0781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.65 15.578c-0.0234 0.125-0.0469 0.24218-0.0742 0.38281l-0.082-0.0781c-0.36328-0.37109-0.72656-0.74609-1.082-1.1211l-0.082-0.18359c-0.0234-0.15235-0.0351-0.3086-0.0547-0.4961l0.10157 0.10547c0.39453 0.40625 0.78515 0.81641 1.1797 1.2266l0.0937 0.0742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.652 14.238c-4e-3 0.38281-0.0117 0.7461-0.0156 1.1211 0.1875-0.0117 0.35937-0.0195 0.54296-0.0274 8e-3 -0.36328 0.0117-0.71875 0.0195-1.082-0.1836-4e-3 -0.36329-8e-3 -0.54688-0.0117m-2.8906-1.3828c0.23828 0.12891 0.46875 0.25 0.69531 0.36719l0.0312 0.0312c-0.25 0.36718-0.5 0.73047-0.75 1.1016 0.0977 0.11328 0.1914 0.22656 0.29687 0.34766 0.21094-0.34375 0.41407-0.6836 0.625-1.0352 0.25782 0.12109 0.51172 0.23828 0.77735 0.36328-0.44141 0.58594-0.875 1.1641-1.3281 1.7734 0.19922-0.0117 0.375-0.0195 0.56641-0.0274-0.0273-0.1289-0.0586-0.2539-0.0937-0.3789 0.21875-0.0625 0.42578-0.11719 0.64453-0.17578 0.14062 0.36718 0.27734 0.73047 0.41406 1.0938l0.0234-8e-3c0.0156-0.99218 0.0352-1.9922 0.0508-2.9922 0.27734-0.0156 0.53906-0.0234 0.80078-0.0352 0.73828-0.0312 1.4688-0.12891 2.1914-0.26953l0.11328 0.0469c0.10937 0.32032 0.22266 0.64454 0.34375 0.98438-0.10938 0.0234-0.21094 0.0508-0.31641 0.0664-0.1875 0.0234-0.375 0.043-0.5625 0.0625l-0.10156 0.082c-0.0195 0.35937-0.0391 0.71875-0.0586 1.0781l8e-3 0.0469c0.33984-8e-3 0.67969-0.0156 1.0312-0.0274-4e-3 0.32813-0.0117 0.65235-0.0156 1.0039-0.33593-8e-3 -0.67578-0.0117-1.0391-0.0195 0.0274 0.32812 0.0469 0.625 0.0859 0.92187 0.0352 0.23828 0.0898 0.48047 0.14453 0.71875l0.11719 0.1875 0.16015-0.16015c0.0664-0.12891 0.1211-0.26563 0.1875-0.41016l0.0391 0.0859c0.11328 0.27344 0.22265 0.54297 0.33593 0.80859l0.0352 0.25391c-0.0586 0.25-0.14062 0.48047-0.28125 0.6914-0.27734 0.41016-0.72266 0.44532-1.0625 0.082-0.25391-0.26954-0.38281-0.60938-0.42969-0.96875-0.0898-0.6875-0.15234-1.3789-0.22265-2.0664l-0.0156-0.19531c-0.19531 0-0.38672-4e-3 -0.58203-8e-3 -0.0117 0.6836-0.0234 1.3672-0.0352 2.0586 0.21875-0.0391 0.42579-0.0781 0.64454-0.11719 8e-3 0.34766 0.0156 0.6875 0.0195 1.0391-0.70313 0.12891-1.3945 0.26172-2.1133 0.39453 4e-3 -0.32421 0.0117-0.64062 0.0156-0.96875-0.11719 0.0195-0.21484 0.0312-0.32031 0.043-0.0547-0.53906-0.11328-1.0742-0.17188-1.625 0.1875-0.0234 0.3711-0.0469 0.57032-0.0742 0.082 0.48047 0.16406 0.94922 0.25 1.4297l0.14843-8e-3c8e-3 -0.5625 0.0195-1.1211 0.0274-1.6992-0.23047 0.0508-0.45703 0.0937-0.6875 0.14063l-0.0742-0.23047c-0.1211 0.0117-0.24219 0.0312-0.38672 0.043-0.0117 0.98828-0.0273 1.9726-0.043 2.9688-0.31641-4e-3 -0.60937-0.0117-0.91016-0.0117 0.0156-0.96094 0.0312-1.918 0.0469-2.8906-0.34375 0.0156-0.68359 0.0312-1.043 0.043 8e-3 -0.32422 0.0117-0.63281 0.0156-0.96875 0.11718 0 0.2539 8e-3 0.38281 4e-3l0.14844-0.0703c0.10156-0.0937 0.1875-0.19531 0.28515-0.30468-0.29687-0.32032-0.58594-0.64063-0.88281-0.96485 0.16406-0.26562 0.32812-0.53125 0.49609-0.80859l0.19532 0.11328c0.1875-0.31641 0.375-0.63281 0.5625-0.95703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.898 18.816c0.3086 0.33593 0.60546 0.65625 0.91796 1-0.19531 0.20703-0.39843 0.44531-0.61718 0.66797-1 1.0078-2.1562 1.7578-3.5078 2.2031-0.61718 0.20703-1.2578 0.32813-1.9102 0.36719-1.0508 0.0625-2.0469-0.125-2.9844-0.60156-0.42187-0.21875-0.80469-0.5-1.1445-0.83204l-0.0977-0.0937c-0.30859 0.29688-0.61328 0.59375-0.93359 0.90235 0.0156-0.95703 0.0312-1.8945 0.0469-2.8438 0.94531 0.0156 1.8906 0.0273 2.8281 0.043-0.32031 0.3164-0.64844 0.6289-0.98047 0.94922 0.26172 0.26953 0.52735 0.47656 0.82422 0.64453 0.75 0.41797 1.5625 0.5664 2.4062 0.49609 1.8633-0.14453 3.3711-1.0117 4.6484-2.332 0.16797-0.17969 0.32031-0.36719 0.5039-0.57031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.125 19.234c-0.22657-0.14063-0.4375-0.27344-0.64453-0.40625l-0.0352-0.0899c0.15234-0.53125 0.17578-1.0859 0.24219-1.6367l0.10937-0.0859c0.19141 0.0234 0.38281 0.0351 0.58203 0.0508 8e-3 0.73437-0.0391 1.4453-0.2539 2.168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.305 15.004c-0.33593-0.33203-0.66406-0.66407-1-0.9961 0.17579-0.25781 0.34766-0.50781 0.52735-0.76953 0.3164 0.33985 0.6289 0.67188 0.94531 1.0156-0.16406 0.2539-0.32031 0.51172-0.47266 0.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.54 17.852c0.32812 0.32032 0.64844 0.64453 0.97266 0.96875-0.17579 0.2461-0.34375 0.48828-0.50782 0.71875-0.30859-0.3125-0.61718-0.625-0.93359-0.9414 0.15625-0.25 0.3125-0.50391 0.46875-0.7461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.84 16.059c-0.19922-0.20312-0.38672-0.39062-0.57812-0.58203-0.13672-0.14062-0.26563-0.27734-0.40235-0.42187l-0.0234-0.0977c0.0937-0.21094 0.19922-0.41406 0.30469-0.6289l0.0742 0.0742c0.28516 0.29688 0.57031 0.59766 0.85547 0.89063l0.0273 0.15625c-0.0898 0.19922-0.17187 0.40234-0.25781 0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.69 18.5c-0.19531-0.19531-0.38281-0.38672-0.57031-0.57422-0.12109-0.11719-0.23828-0.23828-0.35156-0.36719l-0.0352-0.11328c0.0859-0.22656 0.1836-0.44531 0.27735-0.67578l0.10156 0.10547c0.27344 0.30859 0.55078 0.61719 0.83203 0.92188l0.0156 0.16406c-0.0937 0.17578-0.17968 0.35937-0.26953 0.53906"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.555 17.25c-0.3789-0.38672-0.74218-0.75781-1.1094-1.1289l-0.0195-0.0898c0.0469-0.15625 0.10156-0.31641 0.14844-0.47266l0.043-0.0312 0.0898 0.14063c0.29687 0.30469 0.59375 0.60937 0.89453 0.91406l0.0508 0.17578c-0.0391 0.16016-0.0664 0.32813-0.0977 0.49219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.31 15.602 0.082 0.0781c0.32031 0.33594 0.64063 0.67187 0.96094 1.0078l0.0312 0.15625c-0.0547 0.14844-0.10156 0.29297-0.15625 0.45703l-0.0859-0.0859c-0.29297-0.32031-0.58594-0.63671-0.8789-0.96093l-0.0469-0.17578c0.0312-0.15235 0.0625-0.3086 0.0937-0.47657"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m109.51 22.07c-2.1406-1.0898-3.4727-3.2617-3.4727-5.6641 0-2.3008 1.2461-4.4258 3.2539-5.5469 0.11328-0.0664 0.23046-0.125 0.23046-0.125l0.38282 0.75781-0.19922 0.10547c-1.7383 0.97265-2.8203 2.8164-2.8203 4.8086 0 2.082 1.1523 3.9648 3.0117 4.9102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.27 22.074-0.38671-0.75391c1.8594-0.94531 3.0156-2.832 3.0156-4.9141 0-1.9922-1.0781-3.8359-2.8203-4.8086l-0.19531-0.10547 0.39062-0.75 0.21875 0.11328c2.0039 1.125 3.25 3.25 3.25 5.5508 0 2.4062-1.332 4.5781-3.4727 5.668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.49 20.578c-1.6289-0.7461-2.6797-2.3828-2.6797-4.1719 0-1.707 0.9375-3.2617 2.4492-4.0586l0.23047-0.11719 0.35156 0.76953-0.1875 0.0977c-1.2344 0.64843-1.9961 1.9141-1.9961 3.3086 0 1.457 0.85547 2.793 2.1836 3.4023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.3 20.578-0.35156-0.76954c1.3281-0.60546 2.1875-1.9414 2.1875-3.4023 0-1.3945-0.76563-2.6602-1.9961-3.3125l-0.1875-0.0898 0.35156-0.77344 0.22656 0.11328c1.5156 0.80078 2.4531 2.3555 2.4531 4.0625 0 1.7891-1.0547 3.4297-2.6836 4.1719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.59 18.941c-1.1094-0.35157-1.8555-1.3711-1.8555-2.5352 0-1.0586 0.625-2.0156 1.5898-2.4375 0.0898-0.0391 0.17968-0.0742 0.27343-0.10156l0.25 0.80859-0.17968 0.0664c-0.66016 0.29297-1.0898 0.9414-1.0898 1.6641 0 0.79297 0.51172 1.4883 1.2695 1.7266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.2 18.945-0.25781-0.8125c0.76172-0.23828 1.2695-0.93359 1.2695-1.7266 0-0.72266-0.42578-1.375-1.0859-1.6641l-0.18359-0.0664 0.26172-0.80859 0.26171 0.10156c0.96875 0.42188 1.5898 1.3789 1.5898 2.4375 0 1.168-0.7461 2.1836-1.8555 2.5391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.04 16.406c0 0.35547-0.28906 0.64453-0.64453 0.64453s-0.64453-0.28906-0.64453-0.64453 0.28906-0.64453 0.64453-0.64453 0.64453 0.28906 0.64453 0.64453"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-665.77 -397.77)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 776.57001,
    y: 559.22998,
    xlinkHref: "#glyph-18-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.67487,
    y: 559.22998,
    xlinkHref: "#glyph-18-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 779.71222,
    y: 559.22998,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.78723,
    y: 559.22998,
    xlinkHref: "#glyph-18-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.96027,
    y: 559.22998,
    xlinkHref: "#glyph-18-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 786.32825,
    y: 559.22998,
    xlinkHref: "#glyph-18-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 776.57001,
    y: 563.03003,
    xlinkHref: "#glyph-18-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.67487,
    y: 563.03003,
    xlinkHref: "#glyph-18-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 779.71222,
    y: 563.03003,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.71692,
    y: 563.03003,
    xlinkHref: "#glyph-18-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.82434,
    y: 563.03003,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 785.8595,
    y: 563.03003,
    xlinkHref: "#glyph-18-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 776.57001,
    y: 566.83002,
    xlinkHref: "#glyph-18-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 778.67487,
    y: 566.83002,
    xlinkHref: "#glyph-18-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 779.71222,
    y: 566.83002,
    xlinkHref: "#glyph-18-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 781.71692,
    y: 566.83002,
    xlinkHref: "#glyph-18-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 783.82434,
    y: 566.83002,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 785.8595,
    y: 566.83002,
    xlinkHref: "#glyph-18-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 757.84619,
    y: 566.86047,
    xlinkHref: "#glyph-18-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 759.9126,
    y: 566.86047,
    xlinkHref: "#glyph-18-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 762.45868,
    y: 566.86047,
    xlinkHref: "#glyph-18-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 764.96765,
    y: 566.86047,
    xlinkHref: "#glyph-18-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 766.5954,
    y: 566.86047,
    xlinkHref: "#glyph-18-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 767.78601,
    y: 566.69501,
    xlinkHref: "#glyph-19-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.23102,
    y: 563.83801,
    xlinkHref: "#glyph-13-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.961,
    y: 563.83801,
    xlinkHref: "#glyph-13-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.98499,
    y: 563.83801,
    xlinkHref: "#glyph-13-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.06702,
    y: 563.83801,
    xlinkHref: "#glyph-13-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 721.091,
    y: 563.83801,
    xlinkHref: "#glyph-13-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 724.51099,
    y: 563.83801,
    xlinkHref: "#glyph-13-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 727.82898,
    y: 563.83801,
    xlinkHref: "#glyph-13-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 733.06097,
    y: 563.83801,
    xlinkHref: "#glyph-13-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 735.99506,
    y: 563.83801,
    xlinkHref: "#glyph-13-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 737.30908,
    y: 563.83801,
    xlinkHref: "#glyph-13-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 739.94897,
    y: 563.83801,
    xlinkHref: "#glyph-13-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 743.26697,
    y: 563.83801,
    xlinkHref: "#glyph-13-5"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m68.453 15.684c0 2.4375-1.9726 4.4102-4.4102 4.4102s-4.4141-1.9727-4.4141-4.4102 1.9766-4.4141 4.4141-4.4141 4.4102 1.9766 4.4102 4.4141",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m68.453 15.684h-0.25c0 1.1484-0.46484 2.1875-1.2188 2.9414-0.7539 0.75391-1.793 1.2188-2.9414 1.2188-1.1524 0-2.1914-0.46484-2.9453-1.2188-0.7539-0.75391-1.2188-1.793-1.2188-2.9414 0-1.1484 0.46485-2.1875 1.2188-2.9414 0.75391-0.75391 1.793-1.2227 2.9453-1.2227 1.1484 0 2.1875 0.46875 2.9414 1.2227 0.75391 0.7539 1.2188 1.793 1.2188 2.9414h0.5c0-2.5742-2.0859-4.6641-4.6602-4.6641-2.5781 0-4.6641 2.0898-4.6641 4.6641 0 2.5742 2.0859 4.6602 4.6641 4.6602 2.5742 0 4.6602-2.0859 4.6602-4.6602",
    fill: "#4f5257"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.094 8.4727c-2.5117 0-3.3984 3.9766-4.2266 7.168-0.29687-0.30469-1.2148-1.2383-1.2148-1.2344-0.1875-0.1875-0.39844-0.12891-0.53125 4e-3 -0.12891 0.1289-0.14453 0.3789 0 0.52734 8e-3 8e-3 1.2461 1.2617 1.6758 1.6953 0.11719 0.11719 0.28906 0.1875 0.45703 0.0859 0.17969-0.10547 0.20313-0.30469 0.20703-0.30469 1.4688-6.6914 2.7774-7.1875 3.6289-7.1875 0.71875 0 1.543 0.53907 1.543 1.6133 1.0664 0 1.7344 1.4258 0.875 2.3086 0.71094 0.34765 1.0312 0.77734 1.0312 1.3242 0 0.54687-0.44922 1.1055-1.1055 1.1055-0.65234 0-0.98047-0.42579-1.4883-0.42579-0.23047 0-0.36719 0.1836-0.36719 0.375v1.3477h-0.96094v-1.3438c0-0.21094-0.15234-0.37891-0.33984-0.37891l-0.082 8e-3 -1.2812 0.16015c-0.15625 0.0195-0.29688 0.19141-0.29688 0.3711 0 0.20312 0.16407 0.3789 0.39063 0.375l0.0625-8e-3 0.8125-0.10546v1.3359c0 0.16797 0.1875 0.33203 0.35547 0.33203h1.707c0.19531 0 0.37109-0.17187 0.37109-0.3789v-1.2148c0.35157 0.21875 0.84766 0.3086 1.1016 0.3086 0.95703 0 1.8672-0.76563 1.8633-1.8828 0-1.0195-0.76563-1.5274-0.76563-1.5274 0.44922-1.2148-0.27734-2.3867-1.2148-2.7148-0.34375-1.25-1.3945-1.7383-2.207-1.7383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.094 8.4727c-2.5117 0-3.3984 3.9766-4.2266 7.168-0.29687-0.30469-1.2148-1.2383-1.2148-1.2344-0.1875-0.1875-0.39844-0.12891-0.53125 4e-3 -0.12891 0.1289-0.14453 0.3789 0 0.52734 8e-3 8e-3 1.2461 1.2617 1.6758 1.6953 0.11719 0.11719 0.28906 0.1875 0.45703 0.0859 0.17969-0.10547 0.20313-0.30469 0.20703-0.30469 1.4688-6.6914 2.7774-7.1875 3.6289-7.1875 0.71875 0 1.543 0.53907 1.543 1.6133 1.0664 0 1.7344 1.4258 0.875 2.3086 0.71094 0.34765 1.0312 0.77734 1.0312 1.3242 0 0.54687-0.44922 1.1055-1.1055 1.1055-0.65234 0-0.98047-0.42579-1.4883-0.42579-0.23047 0-0.36719 0.1836-0.36719 0.375v1.3477h-0.96094v-1.3438c0-0.21094-0.15234-0.37891-0.33984-0.37891l-0.082 8e-3 -1.2812 0.16015c-0.15625 0.0195-0.29688 0.19141-0.29688 0.3711 0 0.20312 0.16407 0.3789 0.39063 0.375l0.0625-8e-3 0.8125-0.10546v1.3359c0 0.16797 0.1875 0.33203 0.35547 0.33203h1.707c0.19531 0 0.37109-0.17187 0.37109-0.3789v-1.2148c0.35157 0.21875 0.84766 0.3086 1.1016 0.3086 0.95703 0 1.8672-0.76563 1.8633-1.8828 0-1.0195-0.76563-1.5274-0.76563-1.5274 0.44922-1.2148-0.27734-2.3867-1.2148-2.7148-0.34375-1.25-1.3945-1.7383-2.207-1.7383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.023 19.113c0 0.3125 0.34375 0.50391 0.90625 0.77344 0.45313 0.21484 0.71094 0.44531 0.71094 0.625 0 0.29687-0.30859 0.40234-0.60156 0.40234-0.45703 0-0.72266-0.1875-0.87109-0.59375l-8e-3 -0.0351h-0.0391l-0.17969 0.0469-8e-3 0.14844 0.10156 0.42187c0.0234 0.10547 0.0625 0.1211 0.22266 0.15235 0.0742 0.0156 0.4375 0.0781 0.74219 0.0781 0.86718 0 1.25-0.35547 1.25-0.71093 0-0.25782-0.25-0.50391-0.78907-0.78125l-0.24609-0.1211c-0.37109-0.17969-0.59375-0.28515-0.59375-0.47265 0-0.1836 0.23047-0.3125 0.5625-0.3125 0.43359 0 0.54688 0.24609 0.60547 0.46093l4e-3 0.0391h0.043c0.0937 0 0.16016-8e-3 0.19141-0.0508l0.0234-0.0859-0.0352-0.36719c-8e-3 -0.11328-0.0976-0.13281-0.21875-0.15625-0.14453-0.0273-0.3164-0.0586-0.57812-0.0586-0.75 0-1.1953 0.22265-1.1953 0.59765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.508 19.852c0 0.63672 0.54297 1.2812 1.5781 1.2812 0.52344 0 0.82032-0.125 1.0391-0.24218l0.0625-0.0312-0.10157-0.10938 8e-3 4e-3 -0.0742-0.0391-0.0508 0.0195c-0.0781 0.0351-0.32032 0.14843-0.75782 0.14843-0.53515 0-1.1133-0.35156-1.1133-1.1367 0-0.75 0.625-1.0117 1.1602-1.0117 0.38672 0 0.58984 0.14062 0.62891 0.42968l4e-3 0.0469h0.0508c0.043 0 0.16407 0 0.16407-0.0899v-0.4414c0-0.10156-0.1211-0.1211-0.16797-0.12891l-0.0547-4e-3c-0.12109-0.0156-0.23828-0.0312-0.55078-0.0312-1.0586 0-1.8242 0.5625-1.8242 1.3359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.598 18.547-0.9375 4e-3 -0.62109-8e-3 -0.0937-4e-3 -0.0977 0.10157c0 0.0273 0 0.11328 0.10547 0.11328 0.375 0 0.38672 0.0273 0.39453 0.17578v0.0937l8e-3 0.39062v0.84375c0 0.14063-4e-3 0.35938-0.0156 0.54297 0 0.0508-4e-3 0.10156-0.33594 0.10156-0.0937 0-0.14843 0.0156-0.14843 0.10938l0.0898 0.10156h0.0195c0.0391-4e-3 0.14844-8e-3 0.66406-8e-3 0.5586 0 0.66797 4e-3 0.70313 8e-3h0.0234c0.0703 0 0.13281-8e-3 0.13281-0.10156 0-0.10547-0.082-0.10938-0.22656-0.10938-0.33204 0-0.33594-0.0508-0.33594-0.10156-8e-3 -0.16797-0.0156-0.38672-0.0156-0.54297v-0.30078h0.28125c0.42969 0 0.47657 8e-3 0.53907 0.34375l0.12109 0.082c0.10156 0 0.11328-0.0547 0.11328-0.0781l-8e-3 -0.12891c-8e-3 -0.0664-0.0156-0.16015-0.0156-0.28125v-0.51562l-0.14062-0.0781c-0.082 0-0.0977 0.0508-0.14844 0.29297-0.0273 0.0977-0.20312 0.14844-0.48828 0.14844h-0.25v-0.75781c0-0.20704 0.0352-0.20704 0.0781-0.21094 0.16407-8e-3 0.5625-0.0195 0.6836-0.0195 0.10937 0 0.21484 0.0234 0.28515 0.0703 0.21094 0.13281 0.32032 0.22656 0.38672 0.28125l0.15235 0.082 0.12109-0.0781-0.0391-0.10157c-0.0352-0.082-0.0898-0.20703-0.16797-0.40234-0.0195-0.0625-0.0898-0.0625-0.21875-0.0625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.652 25.699h-0.20703v-1.3594h-4e-3l-0.46875 1.3594h-0.19531l-0.47266-1.3828h-4e-3v1.3828h-0.20313v-1.625h0.32032l0.38671 1.1523c0.043 0.125 0.0703 0.20703 0.0742 0.23828h4e-3c0.0234-0.0625 0.0547-0.14843 0.0898-0.26171l0.39063-1.1289h0.28906"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.125 25.699h0.21875v-1.625h-0.21875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.152 25.699h-0.27344l-0.32422-0.46094c-0.082-0.11328-0.13281-0.1875-0.15234-0.22656h-4e-3c0 0.0117-0.16406 0.24219-0.48828 0.6875h-0.25781l0.63281-0.84766-0.5625-0.77734h0.25782l0.34765 0.48437 0.082 0.13282c0.0274-0.0508 0.17969-0.25391 0.46094-0.61719h0.23438l-0.57422 0.76562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.891 27.988h-0.88672v0.50391h0.76953v0.1914h-0.76953v0.73829h-0.21875v-1.625h1.1055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.234 28.273c-8e-3 -0.10547-0.043-0.1836-0.10937-0.23438-0.0664-0.0508-0.16016-0.0781-0.28516-0.0781-0.11328 0-0.20312 0.0195-0.27344 0.0625l-0.10156 0.17969 0.0781 0.15625c0.0508 0.0351 0.15625 0.0703 0.30859 0.10546 0.13672 0.0274 0.24609 0.0586 0.33203 0.0899l0.21875 0.14453c0.0625 0.0625 0.0937 0.15234 0.0937 0.26172 0 0.14062-0.0586 0.25781-0.16797 0.34765-0.11328 0.0937-0.25781 0.14063-0.4414 0.14063-0.22657 0-0.39844-0.0508-0.51172-0.15234-0.11719-0.10157-0.17578-0.23438-0.1836-0.39844l0.20703-0.0195c0.0117 0.13281 0.0625 0.22656 0.14844 0.28515 0.0937 0.0586 0.20703 0.0899 0.33594 0.0899 0.12109 0 0.21484-0.0234 0.28906-0.0742l0.11719-0.19922-0.11719-0.19531c-0.082-0.043-0.21094-0.082-0.39453-0.1211s-0.31641-0.0937-0.39844-0.16797c-0.082-0.0703-0.12109-0.16406-0.12109-0.27734 0-0.13281 0.0508-0.23828 0.15625-0.32422 0.0977-0.0859 0.23828-0.125 0.41797-0.125s0.32812 0.0391 0.43359 0.125c0.11328 0.082 0.17188 0.20313 0.17969 0.35938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.262 28.906c-0.0469 0.18359-0.12891 0.31641-0.2461 0.40625-0.11719 0.0898-0.26172 0.13672-0.42969 0.13672-0.26562 0-0.46093-0.082-0.58203-0.25-0.125-0.16797-0.18359-0.36719-0.18359-0.60156 0-0.26172 0.0703-0.46094 0.21484-0.60938 0.14063-0.14453 0.32813-0.21875 0.55469-0.21875 0.16016 0 0.29688 0.0391 0.41016 0.1211 0.11328 0.0781 0.1914 0.19531 0.23828 0.35156l-0.21094 0.0508c-0.0391-0.11328-0.0898-0.19922-0.16406-0.25781-0.0742-0.0547-0.16406-0.082-0.27735-0.082-0.17578 0-0.30859 0.0547-0.40625 0.17187-0.0898 0.11719-0.13671 0.27344-0.13671 0.46875 0 0.22656 0.0469 0.39453 0.14843 0.50391 0.0937 0.11328 0.21875 0.16797 0.37891 0.16797 0.12891 0 0.23047-0.0352 0.30859-0.10547 0.082-0.0664 0.13672-0.17188 0.16797-0.3086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.078 27.848h-0.17969v0.46093h-0.0937v-0.46093h-0.17187v-0.0781h0.44531zm0.59766 0.46093h-0.0859v-0.45312l-0.13672 0.45312h-0.082l-0.14844-0.46093v0.46093h-0.082v-0.53906h0.13281l0.13672 0.4336 0.13282-0.4336h0.13281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.238 28.605c0 0.26953 0.0312 0.45312 0.0977 0.54297 0.0625 0.0898 0.14063 0.13281 0.23438 0.13281 0.0937 0 0.17187-0.043 0.23437-0.13672 0.0664-0.0898 0.0977-0.26953 0.0977-0.53906 0-0.27344-0.0312-0.45313-0.0977-0.54297-0.0625-0.0898-0.14062-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22265 0.11719-0.0703 0.10156-0.10547 0.28906-0.10547 0.5625m-0.20703 0c0-0.19922 0.0195-0.35547 0.0586-0.47266 0.043-0.12109 0.10156-0.21484 0.17969-0.27734 0.0781-0.0664 0.17969-0.0977 0.30078-0.0977l0.23437 0.0547 0.16407 0.15234c0.043 0.0703 0.0781 0.15235 0.10547 0.2461 0.0234 0.0976 0.0351 0.23047 0.0351 0.39453 0 0.19141-0.0195 0.35156-0.0586 0.46875-0.043 0.12109-0.0977 0.21484-0.17969 0.27734-0.0781 0.0664-0.17969 0.0977-0.30078 0.0977-0.16016 0-0.28516-0.0547-0.375-0.17188-0.10938-0.13671-0.16406-0.35937-0.16406-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.527 28.605c0 0.26953 0.0312 0.45312 0.0937 0.54297 0.0664 0.0898 0.14453 0.13281 0.23828 0.13281 0.0937 0 0.17188-0.043 0.23438-0.13672 0.0625-0.0898 0.0976-0.26953 0.0976-0.53906 0-0.27344-0.0351-0.45313-0.0976-0.54297-0.0625-0.0898-0.14453-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22657 0.11719-0.0664 0.10156-0.10156 0.28906-0.10156 0.5625m-0.21094 0c0-0.19922 0.0195-0.35547 0.0625-0.47266 0.0391-0.12109 0.10157-0.21484 0.17969-0.27734 0.0781-0.0664 0.17969-0.0977 0.30078-0.0977l0.23047 0.0547 0.16797 0.15234c0.043 0.0703 0.0781 0.15235 0.10156 0.2461 0.0274 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0195 0.35156-0.0586 0.46875-0.043 0.12109-0.10156 0.21484-0.17969 0.27734-0.082 0.0664-0.17968 0.0977-0.30078 0.0977-0.16015 0-0.28515-0.0547-0.3789-0.17188-0.10938-0.13671-0.16407-0.35937-0.16407-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.812 28.605c0 0.26953 0.0312 0.45312 0.0976 0.54297 0.0625 0.0898 0.14063 0.13281 0.23438 0.13281 0.0937 0 0.17187-0.043 0.23437-0.13672 0.0664-0.0898 0.0977-0.26953 0.0977-0.53906 0-0.27344-0.0312-0.45313-0.0977-0.54297-0.0625-0.0898-0.14062-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22265 0.11719-0.0703 0.10156-0.10547 0.28906-0.10547 0.5625m-0.20703 0c0-0.19922 0.0195-0.35547 0.0586-0.47266 0.043-0.12109 0.10156-0.21484 0.17969-0.27734 0.0781-0.0664 0.17968-0.0977 0.30078-0.0977l0.23437 0.0547 0.16407 0.15234c0.0469 0.0703 0.0781 0.15235 0.10546 0.2461 0.0234 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0234 0.35156-0.0625 0.46875-0.0391 0.12109-0.0977 0.21484-0.17969 0.27734-0.0781 0.0664-0.17969 0.0977-0.30078 0.0977-0.16016 0-0.28516-0.0547-0.375-0.17188-0.10938-0.13671-0.16406-0.35937-0.16406-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.102 28.605c0 0.26953 0.0312 0.45312 0.0977 0.54297 0.0586 0.0898 0.14062 0.13281 0.23046 0.13281 0.0977 0 0.17579-0.043 0.23829-0.13672 0.0625-0.0898 0.0937-0.26953 0.0937-0.53906 0-0.27344-0.0312-0.45313-0.0937-0.54297-0.0625-0.0898-0.14063-0.13672-0.23829-0.13672-0.0937 0-0.16796 0.0391-0.22265 0.11719-0.0703 0.10156-0.10547 0.28906-0.10547 0.5625m-0.21094 0c0-0.19922 0.0234-0.35547 0.0625-0.47266 0.0391-0.12109 0.0977-0.21484 0.17969-0.27734 0.0781-0.0664 0.17969-0.0977 0.29687-0.0977l0.23438 0.0547 0.16797 0.15234c0.043 0.0703 0.0781 0.15235 0.10156 0.2461 0.0273 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0195 0.35156-0.0586 0.46875-0.043 0.12109-0.10156 0.21484-0.17969 0.27734-0.0781 0.0664-0.17969 0.0977-0.30469 0.0977-0.15625 0-0.28125-0.0547-0.375-0.17188-0.10546-0.13671-0.16406-0.35937-0.16406-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.387 28.605c0 0.26953 0.0351 0.45312 0.0976 0.54297 0.0625 0.0898 0.14063 0.13281 0.23438 0.13281 0.0937 0 0.17187-0.043 0.23828-0.13672 0.0625-0.0898 0.0937-0.26953 0.0937-0.53906 0-0.27344-0.0312-0.45313-0.0937-0.54297-0.0664-0.0898-0.14453-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22657 0.11719-0.0703 0.10156-0.10546 0.28906-0.10546 0.5625m-0.20704 0c0-0.19922 0.0195-0.35547 0.0625-0.47266 0.0391-0.12109 0.0977-0.21484 0.17579-0.27734 0.082-0.0664 0.17968-0.0977 0.30078-0.0977l0.23437 0.0547 0.16406 0.15234c0.0469 0.0703 0.082 0.15235 0.10547 0.2461 0.0234 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0195 0.35156-0.0625 0.46875-0.0391 0.12109-0.0977 0.21484-0.17969 0.27734-0.0781 0.0664-0.17969 0.0977-0.30078 0.0977-0.16016 0-0.28516-0.0547-0.375-0.17188-0.10938-0.13671-0.16407-0.35937-0.16407-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.676 28.605c0 0.26953 0.0312 0.45312 0.0977 0.54297 0.0625 0.0898 0.14063 0.13281 0.23438 0.13281 0.0937 0 0.17187-0.043 0.23437-0.13672 0.0625-0.0898 0.0977-0.26953 0.0977-0.53906 0-0.27344-0.0352-0.45313-0.0977-0.54297-0.0625-0.0898-0.14453-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22265 0.11719-0.0703 0.10156-0.10547 0.28906-0.10547 0.5625m-0.21094 0c0-0.19922 0.0234-0.35547 0.0625-0.47266 0.0391-0.12109 0.10156-0.21484 0.17969-0.27734 0.0781-0.0664 0.17969-0.0977 0.30078-0.0977l0.23047 0.0547 0.16797 0.15234c0.043 0.0703 0.0781 0.15235 0.10156 0.2461 0.0273 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0195 0.35156-0.0586 0.46875-0.043 0.12109-0.10156 0.21484-0.17969 0.27734-0.0781 0.0664-0.17969 0.0977-0.30078 0.0977-0.16016 0-0.28516-0.0547-0.37891-0.17188-0.10547-0.13671-0.16406-0.35937-0.16406-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.961 28.605c0 0.26953 0.0352 0.45312 0.0977 0.54297 0.0625 0.0898 0.14063 0.13281 0.23438 0.13281 0.0937 0 0.17187-0.043 0.23828-0.13672 0.0625-0.0898 0.0937-0.26953 0.0937-0.53906 0-0.27344-0.0312-0.45313-0.0937-0.54297-0.0664-0.0898-0.14453-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22657 0.11719-0.0703 0.10156-0.10547 0.28906-0.10547 0.5625m-0.20703 0c0-0.19922 0.0195-0.35547 0.0625-0.47266 0.0391-0.12109 0.0977-0.21484 0.17578-0.27734 0.082-0.0664 0.17969-0.0977 0.30079-0.0977l0.23437 0.0547 0.16797 0.15234c0.043 0.0703 0.0781 0.15235 0.10156 0.2461 0.0234 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0195 0.35156-0.0625 0.46875-0.0391 0.12109-0.0977 0.21484-0.17968 0.27734-0.0781 0.0664-0.17969 0.0977-0.30078 0.0977-0.16016 0-0.28516-0.0547-0.375-0.17188-0.10938-0.13671-0.16407-0.35937-0.16407-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.894 8.582h-0.17969v0.46485h-0.0898v-0.46485h-0.17188v-0.0742h0.44141zm0.60156 0.46485h-0.0859v-0.45704l-0.14062 0.45704h-0.082l-0.14453-0.46485h-4e-3v0.46485h-0.082v-0.53907h0.13281l0.13671 0.42969h4e-3l0.1289-0.42969h0.13672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.742 18.707 1.2227-1.1758 0.0156 0.59375 1.0547-4e-3 1.0547-8e-3 0.18359-0.0664c0.10157-0.0352 0.23438-0.0977 0.29688-0.14063 0.38281-0.26562 0.47266-0.75391 0.23828-1.2695-0.0352-0.0703-0.38672-0.69141-0.78125-1.375s-0.71484-1.25-0.70312-1.2578l0.9375-0.53125c4e-3 0.0117 0.32421 0.5664 0.71484 1.2383 0.79687 1.3711 0.86328 1.5 0.96875 1.8164 0.40625 1.2148-0.082 2.2148-1.2578 2.5547-0.35938 0.10156-0.39453 0.10547-1.5703 0.1211l-1.125 0.0117-0.0234 0.67969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.672 19.16c-0.76953-0.13672-1.3281-0.50391-1.5859-1.043-0.11328-0.23438-0.14843-0.39063-0.16015-0.69922-0.0156-0.32031 0.0195-0.54297 0.13672-0.89063 0.0976-0.29687 0.21484-0.52734 0.67968-1.3281 0.21485-0.36719 0.38672-0.67188 0.38282-0.67578l-0.50782-0.3125 1.6328-0.46094 0.39843 1.6367-0.58203-0.26563c-0.0664 0.0937-0.83203 1.4258-0.8789 1.543-0.0899 0.19141-0.125 0.39063-0.11328 0.57813 0.0234 0.40234 0.23828 0.66797 0.67187 0.8125l0.16797 0.0586 1.5625 8e-3 1.5625 4e-3v1.0781l-1.5742-4e-3c-1.4023 0-1.5977-4e-3 -1.793-0.0391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.23 12.684c-0.0234-0.0195 1.3281-2.3672 1.5078-2.6289 0.19922-0.28906 0.49609-0.59375 0.74219-0.76172 0.15234-0.10547 0.44531-0.23828 0.63281-0.28516 0.47656-0.12109 1.0273 4e-3 1.4726 0.33203 0.21875 0.16016 0.53907 0.50782 0.70704 0.75782 0.0781 0.12109 0.32812 0.53906 0.55078 0.92578 0.22265 0.38672 0.40625 0.70703 0.41015 0.71094l0.52735-0.27735-0.41407 1.6367-1.6211-0.46094 0.54297-0.35156c0-0.0312-0.83594-1.4688-0.9375-1.6133-0.26172-0.36719-0.64453-0.55859-0.98438-0.49219-0.27343 0.0508-0.53515 0.23438-0.71484 0.4961-0.0508 0.0703-0.40234 0.66406-0.78516 1.3242-0.38281 0.66407-0.70312 1.207-0.71484 1.2109-0.31641-0.16015-0.62891-0.33203-0.92187-0.52344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.227 16.074v0.50781h-1.9688v-0.38281l0.69922-0.75c0.48047-0.52344 0.55859-0.66016 0.55859-0.90625 0-0.25-0.16797-0.40625-0.49219-0.40625-0.33984 0-0.57812 0.13281-0.69531 0.24609h-8e-3v-0.61328c0.13672-0.0859 0.41016-0.1914 0.78906-0.1914 0.65235 0 1.0586 0.3789 1.0586 0.91406 0 0.42187-0.17579 0.70703-0.69922 1.2305l-0.35157 0.35156h1.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.527 16.074v0.50781h-1.9688v-0.38281l0.69531-0.75c0.48047-0.52344 0.5625-0.66016 0.5625-0.90625 0-0.25-0.16797-0.40625-0.49218-0.40625-0.33985 0-0.57813 0.13281-0.69922 0.24609h-4e-3v-0.61328c0.13281-0.0859 0.41016-0.1914 0.78906-0.1914 0.65235 0 1.0547 0.3789 1.0547 0.91406 0 0.42187-0.17187 0.70703-0.69531 1.2305l-0.35156 0.35156h1.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.051 22.219 0.20312 0.0156c0.31641 0 0.50782-0.15235 0.50782-0.42188 0-0.25391-0.17969-0.39062-0.46875-0.39062-0.11719 0-0.19922 0.0117-0.24219 0.0195zm-0.41797-1.0664c0.15234-0.0273 0.35937-0.0508 0.64453-0.0508 0.30469 0 0.53125 0.0664 0.67578 0.1875 0.13672 0.11328 0.22656 0.29297 0.22656 0.50782 0 0.21875-0.0664 0.39843-0.19921 0.51953-0.16407 0.16797-0.42969 0.24609-0.72657 0.24609l-0.20312-0.0156v0.86718h-0.41797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.578 22.445-0.17969-0.5625c-0.043-0.14062-0.082-0.29687-0.11718-0.42968h-4e-3c-0.0352 0.13281-0.0703 0.29296-0.11328 0.42968l-0.17578 0.5625zm-0.65625 0.31641-0.19922 0.65234h-0.43359l0.73828-2.293h0.53516l0.74609 2.293h-0.44922l-0.20703-0.65234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.207 22.219 0.20312 0.0156c0.3125 0 0.50782-0.15235 0.50782-0.42188 0-0.25391-0.17969-0.39062-0.46875-0.39062-0.11719 0-0.19922 0.0117-0.24219 0.0195zm-0.41797-1.0664c0.15234-0.0273 0.35937-0.0508 0.64062-0.0508 0.3086 0 0.53516 0.0664 0.67969 0.1875 0.13672 0.11328 0.22656 0.29297 0.22656 0.50782 0 0.21875-0.0703 0.39843-0.19921 0.51953-0.16797 0.16797-0.42969 0.24609-0.72657 0.24609l-0.20312-0.0156v0.86718h-0.41797"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1.4023 5h17.621c5.0469 0 9.1524 4.1562 9.1524 9.2617v53.102h-17.621c-5.0469 0-9.1523-4.1523-9.1523-9.2578",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.652 65.238h11.395v-31.844c0-3.9336-3.1484-7.1328-7.0234-7.1328h-11.398v31.844c0 3.9336 3.1523 7.1328 7.0273 7.1328",
    fill: "#171817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.652 64.531c-3.4844 0-6.3203-2.8828-6.3203-6.4258v-31.137h10.691c3.4844 0 6.3164 2.8828 6.3164 6.4258v31.137",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.625 58.105c0 3.9336 3.1523 7.1328 7.0273 7.1328h11.395v-22.676l-9.2109 4.5391-9.2109-4.543",
    fill: "#171817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.652 64.531c-3.4844 0-6.3203-2.8828-6.3203-6.4258v-14.406l8.5039 4.1914 8.5039-4.1875v20.828",
    fill: "#171817"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.918 60.191h-0.45313l-0.10547 0.0117c0.21094-2.3477 0.53906-5.9688 0.69531-7.6094 0.0156-0.16797-0.10546-0.31641-0.27343-0.33203-0.17188-0.0195-0.31641 0.10547-0.33203 0.27344-0.24219 2.5195-0.88282 9.7109-0.88672 9.7852-0.0156 0.1211-0.13282 0.21875-0.26953 0.21875h-4.9102c-0.14063 0-0.25781-0.0976-0.26953-0.21875-8e-3 -0.0742-0.64844-7.2656-0.89063-9.7852-0.0156-0.16797-0.16015-0.29297-0.33203-0.27344-0.16406 0.0156-0.28906 0.16406-0.27344 0.33203 0.16016 1.6406 0.48438 5.2578 0.69532 7.6094l-0.10547-0.0117h-0.45313c-0.28906 0-0.52734 0.23437-0.52734 0.52734v1.9023c0 0.29297 0.23828 0.52735 0.52734 0.52735h0.45313c0.21875 0 0.40625-0.13281 0.48437-0.32422 0.16407 0.19922 0.41016 0.32422 0.69141 0.32422h4.9102c0.27734 0 0.52734-0.125 0.6875-0.32422 0.0781 0.19141 0.26562 0.32812 0.48437 0.32812h0.45313c0.28906 0 0.52734-0.23828 0.52734-0.53125v-1.9023c0-0.28906-0.23828-0.52734-0.52734-0.52734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.223 49.813h-0.52343l-0.71485-0.625c-0.15234-0.13281-0.3789-0.21094-0.62109-0.21094h-5.0508c-0.2461 0-0.47266 0.0781-0.625 0.21094l-0.71485 0.625h-0.52343c-0.33204 0-0.60547 0.28125-0.60547 0.63281v0.80078c0 0.11329 0.0312 0.22266 0.082 0.32032l0.0977 0.10156c0.0977 0.0664 0.21094 0.10156 0.32422 0.10156h8.9766c0.11718 0 0.22656-0.0351 0.32421-0.10156l0.0977-0.10156c0.0508-0.0977 0.082-0.20703 0.082-0.32032v-0.80078c0-0.35156-0.27344-0.63281-0.60547-0.63281m0.0117 1.3633h-8.793v-0.73047l8e-3 -0.0391h0.63671l0.19532-0.0742 0.79687-0.69922c0.0352-0.0312 0.125-0.0625 0.23438-0.0625h5.0508c0.10937 0 0.19531 0.0312 0.23047 0.0625l0.79687 0.69922 0.19531 0.0742h0.63672l0.0117 0.0391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.359 49.848h-5.0469c-0.14063 0-0.25 0.11328-0.25 0.25 0 0.14062 0.10937 0.2539 0.25 0.2539h5.0469c0.14063 0 0.25391-0.11328 0.25391-0.2539 0-0.13672-0.11328-0.25-0.25391-0.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.309 55.617c-0.0625-0.15625-0.23828-0.22656-0.39062-0.16406-0.15235 0.0625-0.22657 0.23828-0.16407 0.39062 0.10547 0.25391 0.16016 0.52344 0.16016 0.79688 0 1.1445-0.93359 2.0742-2.0781 2.0742-1.1445 0-2.0742-0.92968-2.0742-2.0742 0-1.1445 0.92968-2.0781 2.0742-2.0781l0.0234 4e-3 -0.42969 0.42578c-0.11328 0.11719-0.11328 0.30859 0 0.42578l0.21485 0.0859 0.21094-0.0859 0.9414-0.94141c0.11719-0.11718 0.11719-0.30859 0-0.42578l-0.9414-0.9414c-0.11719-0.11719-0.30469-0.11719-0.42579 0-0.11328 0.11718-0.11328 0.30859 0 0.42578l0.4336 0.42968h-0.0273c-1.4766 0-2.6758 1.1992-2.6758 2.6758 0 1.4766 1.1992 2.6758 2.6758 2.6758 1.4766 0 2.6758-1.1992 2.6758-2.6758 0-0.35547-0.0664-0.69922-0.20313-1.0234"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#040606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.848 16.164c-0.75781 1.1172-0.11328 2.5938 0.67578 3.3398 0.71485 0.67968 1.2891 0.83984 1.3633 0.85937l0.36718-0.69922 1.0547 2.8828-2.9844 0.60546 0.39843-0.73437-0.40234-0.22656c-1.2578-0.81641-1.5234-1.9297-1.6094-2.2734-0.14843-0.59766-0.37109-2.3867 1.1367-3.7539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.836 16.211c0.54297 1.2422 2.1328 1.4805 3.1836 1.2148 0.93359-0.23828 1.375-0.62109 1.4492-0.6914l-4e-3 -8e-3 -0.39844-0.6914 3 0.65625-1.0859 2.8438-0.40235-0.71485-0.39062 0.21094c-1.3633 0.625-2.4453 0.25781-2.7852 0.14453-0.58203-0.1914-2.2148-0.95703-2.5664-2.9648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.141 13.215c-0.21094 1.4844-1.1016 2.1953-1.3828 2.418-0.47656 0.39063-2 1.3516-3.8828 0.5625 1.3398 0.21485 2.3984-0.99609 2.7422-2.0234 0.3086-0.92579 0.21875-1.5078 0.20313-1.5977h-0.0117l-0.79687-0.0352 2.168-2.1758 1.8125 2.4414-0.82031-0.0469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.039 11.961c-0.68359 0-1.2383-0.55469-1.2383-1.2383 0-0.6836 0.55469-1.2383 1.2383-1.2383s1.2383 0.55468 1.2383 1.2383c0 0.68359-0.55469 1.2383-1.2383 1.2383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.734 7.1289c-4.4766 0-8.1133 3.6367-8.1133 8.1133 0 4.4726 3.6367 8.1133 8.1133 8.1133 0.23828 0 0.47266-0.0156 0.70703-0.0352l0.0547 0.8125 1.4844-1.4336-1.6602-1.2656 0.0625 0.85547c-0.21484 0.0195-0.42969 0.0352-0.64844 0.0352-0.34375 0-0.68359-0.0273-1.0117-0.0742l-0.0351-0.21875-0.76953-6.5703c-0.10547-1.2383 0.60156-1.4336 1.0391-1.25l2.4609 0.98828c0.28125 0.12109 0.41796-0.11328 0.41796-0.11328s0.16016-0.25-0.125-0.42969c0 0-3.3555-2.2227-4.0703-2.3555-0.97656-0.18359-1.9375 0.60547-2.1562 1.6367l-1.1875 5.832c-1.0234-1.2266-1.6445-2.8086-1.6445-4.5273 0-3.9024 3.1797-7.082 7.082-7.082 2.0859 0 3.9609 0.91015 5.2578 2.3476l0.72657-0.73828c-1.4844-1.6211-3.6172-2.6406-5.9844-2.6406m-3.6133 10.855c0.10547-0.28907 0.26172-0.26954 0.26172-0.26954s0.14453-0.0312 0.22266 0.26172l1.1602 4.0664c-0.96875-0.28516-1.8476-0.76172-2.5976-1.3945"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m4.4453 39.727v-1.4453h0.50391v0.85547h0.70703v-0.67969h0.50781v0.67969h0.77734v-0.85938h0.51172v1.4492",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m6.6289 38.094-0.0156-0.55859c0.1875-0.0156 0.40234-0.0586 0.40234-0.26953 0-0.16797-0.14453-0.21875-0.27734-0.21875-0.16797 0-0.28906 0.10546-0.45313 0.27734l-0.28125 0.28906c-0.2539 0.26953-0.5039 0.4336-0.83203 0.4336-0.41797 0-0.77344-0.26172-0.77344-0.79688 0-0.375 0.19141-0.72656 0.84766-0.75l0.0195 0.51953c-0.21875 0.0234-0.39062 0.0742-0.39062 0.25781 0 0.14844 0.11328 0.21485 0.25 0.21485 0.16015 0 0.3125-0.16406 0.44922-0.30469l0.26171-0.26562c0.27735-0.29297 0.53516-0.45704 0.8711-0.45704 0.4414 0 0.79297 0.30469 0.79297 0.80469s-0.33203 0.79297-0.8711 0.82422",
    fill: "#fff"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#050606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.789 36.715v0.24219h0.97656v-0.25c0-0.1875-0.13281-0.29687-0.5-0.29687-0.3164 0-0.48437 0.0976-0.48437 0.30468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5937 36.398-1.332 0.34765v0.21875h1.332v0.66797h-3.3594v-0.96484c0-0.56641 0.30469-0.90625 0.99219-0.90625 0.48828 0 0.75781 0.16016 0.88672 0.38672l1.4805-0.4336zm-2.8047 1.5508v0.95703h0.80469v-0.75781h0.57031v0.75781h1.4219v0.65625h-3.3633v-1.6133zm-1.2617-2.3867v4.2188c0 0.77344 0.63672 1.4023 1.4023 1.4023h3.3594v-7.0312h-3.3594c-0.77734 0-1.4023 0.63672-1.4023 1.4102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6484 28.762c0 0.35156-0.082 0.62109-0.23046 0.80078-0.15235 0.17969-0.41016 0.26953-0.78125 0.26953h-0.10157v-0.67969h0.0899c0.17968 0 0.3125-0.0312 0.40234-0.10156 0.0781-0.0703 0.12891-0.17969 0.12891-0.35156 0-0.11719-0.0391-0.21875-0.10938-0.28906-0.0703-0.0781-0.17187-0.10938-0.30859-0.10938-0.10156 0-0.19141 0.0195-0.26172 0.0508-0.0703 0.0391-0.12891 0.10938-0.17969 0.23047-0.16015 0.39844-0.26953 0.64844-0.32031 0.73828-0.0508 0.10157-0.12109 0.17969-0.19141 0.24219-0.0703 0.0586-0.16015 0.11719-0.26953 0.15625-0.0976 0.043-0.21875 0.0625-0.36719 0.0625-0.32031 0-0.5625-0.0898-0.73046-0.26953-0.17188-0.17969-0.25-0.44141-0.25-0.76953 0-0.33203 0.0781-0.58985 0.23046-0.77344 0.14844-0.17969 0.37891-0.26953 0.6875-0.26953h0.082v0.65234c-0.33204 0-0.5 0.11719-0.5 0.36719 0 0.26172 0.1289 0.39453 0.38671 0.39453 0.1211 0 0.22266-0.0312 0.28125-0.082 0.0625-0.0508 0.1211-0.14062 0.17969-0.26953l0.23047-0.51953c0.0898-0.23047 0.21094-0.39063 0.35156-0.49219 0.14063-0.0977 0.32032-0.14844 0.53907-0.14844 0.6914 0 1.0312 0.39063 1.0312 1.168zm-0.0625 1.2695v1.918h-3.3594v-1.8789h0.55078v1.1992h0.78906v-1.1289h0.55078v1.1289h0.89844v-1.25h0.55078zm-4.0586-2.3711v4.2226c0 0.76953 0.62891 1.4062 1.4102 1.4062h3.3594v-7.0273h-3.3594c-0.76953 0-1.4102 0.62891-1.4102 1.4102"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m13.789 33.289 0.22656 0.10157 0.19141-0.0664c0.125-0.0977 0.14062-0.27344 0.0391-0.39453l-0.0977-0.10547c0.10938-0.0547 0.23047-0.082 0.35547-0.082 0.24219 0 0.46485 0.0976 0.61719 0.26953 0.28125 0.32031 0.23438 0.79687-0.10547 1.0625-0.14062 0.10937-0.32422 0.17187-0.50781 0.17187-0.23828 0-0.46484-0.0976-0.61719-0.27343-0.18359-0.20703-0.22265-0.48047-0.13672-0.72266zm-1.1289-1.2812 0.6836 0.77735c-0.1211 0.17187-0.20313 0.37109-0.22266 0.58593-0.0352 0.35157 0.0781 0.69141 0.31641 0.96094 0.26562 0.30078 0.65625 0.47266 1.0703 0.47266 0.32422 0 0.64062-0.10547 0.88672-0.30078 0.58984-0.46094 0.67187-1.293 0.18359-1.8477-0.26562-0.30078-0.65625-0.47656-1.0703-0.47656-0.26563 0-0.51953 0.0742-0.74219 0.20703l-0.6875-0.78516 0.0117 4e-3 0.12109-0.0234 0.0508-0.0351 0.0664 4e-3 2.8984 0.29297c0.22266 0.0234 0.55078 0.19141 0.69141 0.35156l5.7852 6.5781c0.0859 0.0976 0.0703 0.24609-0.0351 0.32812l-3.8281 2.9961-0.16016 0.0508-0.1875-0.082-5.7852-6.5781c-0.14063-0.16015-0.25781-0.5-0.24219-0.70703l0.18359-2.6992zm10.496 6.4102-5.7852-6.582c-0.23437-0.26953-0.71094-0.50781-1.082-0.54688l-2.9023-0.29297-0.13672-8e-3 -0.88672-1.8516c-0.0664-0.13672-0.2461-0.20313-0.39453-0.13672l-0.15235 0.15625 8e-3 0.21094 0.8125 1.6953-0.0274 0.0117-1.1562-1.3203c-0.10547-0.11328-0.29687-0.13282-0.41797-0.0352-0.125 0.0977-0.14453 0.27344-0.0391 0.39453l1.2031 1.3633c-0.082 0.17969-0.12891 0.39063-0.14063 0.56641l-0.1875 2.6992c-0.0234 0.34765 0.14453 0.83203 0.37891 1.1016l5.7852 6.5781c0.16016 0.18359 0.39453 0.28515 0.64453 0.28515 0.19532 0 0.38672-0.0625 0.53516-0.17969l3.832-2.9961c0.17188-0.13672 0.28125-0.32422 0.30078-0.53516 0.0195-0.21093-0.0469-0.41796-0.1914-0.57812",
    fill: "#171716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodcontact);
export default __webpack_public_path__ + "static/media/foodcontact.0f3c86817544403260da28e9b60c6d37.svg";
export { ForwardRef as ReactComponent };